//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.0.0 (NJsonSchema v11.6.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Main Login Process
     */
    login(version: string, request: SystemLoginRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/Account/login";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forgot Password
     */
    forgotpassword(version: string, request: ForgotPasswordRequest): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/Account/forgotpassword";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotpassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotpassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotpassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Forgot Username
     */
    forgotusername(version: string, request: ForgotUserNameRequest): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/Account/forgotusername";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotusername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotusername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotusername(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset Password
     */
    resetpassword(version: string, request: ResetPasswordRequest): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/Account/resetpassword";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetpassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetpassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetpassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetmypassword(version: string, request: ResetMyPasswordRequest): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/Account/resetmypassword";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetmypassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetmypassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetmypassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminCostSettingsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get all admin cost settings
     */
    adminCostSettingsGet(version: string): Observable<AuditActionResultOfAdminCostSettingsModel> {
        let url_ = this.baseUrl + "/v{version}/AdminCostSettings";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminCostSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminCostSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfAdminCostSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfAdminCostSettingsModel>;
        }));
    }

    protected processAdminCostSettingsGet(response: HttpResponseBase): Observable<AuditActionResultOfAdminCostSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfAdminCostSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update admin cost setting
     */
    adminCostSettingsPatch(version: string, request: UpdateAdminCostSettingRequest): Observable<AuditActionResultOfAdminCostSettingsModel> {
        let url_ = this.baseUrl + "/v{version}/AdminCostSettings";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminCostSettingsPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminCostSettingsPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfAdminCostSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfAdminCostSettingsModel>;
        }));
    }

    protected processAdminCostSettingsPatch(response: HttpResponseBase): Observable<AuditActionResultOfAdminCostSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfAdminCostSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditDetailsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    auditDetails(id: number | null | undefined, module: string | null | undefined, recordId: string | null | undefined, action: string | null | undefined, changes: string | null | undefined, initiator: string | null | undefined, eventDateTime: Date | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfAuditDetail> {
        let url_ = this.baseUrl + "/v{version}/AuditDetails?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (module !== undefined && module !== null)
            url_ += "Module=" + encodeURIComponent("" + module) + "&";
        if (recordId !== undefined && recordId !== null)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        if (action !== undefined && action !== null)
            url_ += "Action=" + encodeURIComponent("" + action) + "&";
        if (changes !== undefined && changes !== null)
            url_ += "Changes=" + encodeURIComponent("" + changes) + "&";
        if (initiator !== undefined && initiator !== null)
            url_ += "Initiator=" + encodeURIComponent("" + initiator) + "&";
        if (eventDateTime !== undefined && eventDateTime !== null)
            url_ += "EventDateTime=" + encodeURIComponent(eventDateTime ? "" + eventDateTime.toISOString() : "") + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfAuditDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfAuditDetail>;
        }));
    }

    protected processAuditDetails(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfAuditDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfAuditDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerContactService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    customerContactGet(id: number | null | undefined, customerId: number | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, phoneNumber: string | null | undefined, emailAddress: string | null | undefined, version: string): Observable<AuditActionResultOfListOfCustomerContactModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerContact?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContactGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContactGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfListOfCustomerContactModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfListOfCustomerContactModel>;
        }));
    }

    protected processCustomerContactGet(response: HttpResponseBase): Observable<AuditActionResultOfListOfCustomerContactModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfListOfCustomerContactModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerContactPost(version: string, request: CreateCustomerContactRequest): Observable<AuditActionResultOfCustomerContactModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerContact";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContactPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContactPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerContactModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerContactModel>;
        }));
    }

    protected processCustomerContactPost(response: HttpResponseBase): Observable<AuditActionResultOfCustomerContactModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerContactModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerContactPatch(version: string, request: UpdateCustomerContactRequest): Observable<AuditActionResultOfCustomerContactModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerContact";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContactPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContactPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerContactModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerContactModel>;
        }));
    }

    protected processCustomerContactPatch(response: HttpResponseBase): Observable<AuditActionResultOfCustomerContactModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerContactModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerContactDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/CustomerContact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContactDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContactDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processCustomerContactDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    customerGet(id: number | null | undefined, name: string | null | undefined, address: string | null | undefined, phone: string | null | undefined, primaryContactUserId: number | null | undefined, secondaryContactUserId: number | null | undefined, locationId: number | null | undefined, isActive: boolean | null | undefined, primaryContactUserFullName: string | null | undefined, secondaryContactUserFullName: string | null | undefined, locationName: string | null | undefined, createdFullName: string | null | undefined, createdOn: Date | null | undefined, status: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfCustomerModel> {
        let url_ = this.baseUrl + "/v{version}/Customer?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (address !== undefined && address !== null)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (primaryContactUserId !== undefined && primaryContactUserId !== null)
            url_ += "PrimaryContactUserId=" + encodeURIComponent("" + primaryContactUserId) + "&";
        if (secondaryContactUserId !== undefined && secondaryContactUserId !== null)
            url_ += "SecondaryContactUserId=" + encodeURIComponent("" + secondaryContactUserId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (primaryContactUserFullName !== undefined && primaryContactUserFullName !== null)
            url_ += "PrimaryContactUserFullName=" + encodeURIComponent("" + primaryContactUserFullName) + "&";
        if (secondaryContactUserFullName !== undefined && secondaryContactUserFullName !== null)
            url_ += "SecondaryContactUserFullName=" + encodeURIComponent("" + secondaryContactUserFullName) + "&";
        if (locationName !== undefined && locationName !== null)
            url_ += "LocationName=" + encodeURIComponent("" + locationName) + "&";
        if (createdFullName !== undefined && createdFullName !== null)
            url_ += "CreatedFullName=" + encodeURIComponent("" + createdFullName) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfCustomerModel>;
        }));
    }

    protected processCustomerGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerPost(version: string, request: CreateCustomerRequest): Observable<AuditActionResultOfCustomerModel> {
        let url_ = this.baseUrl + "/v{version}/Customer";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerModel>;
        }));
    }

    protected processCustomerPost(response: HttpResponseBase): Observable<AuditActionResultOfCustomerModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerPatch(version: string, request: UpdateCustomerRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Customer";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processCustomerPatch(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Customer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processCustomerDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerDepartmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    customerDepartmentGet(id: number | null | undefined, customerId: number | null | undefined, name: string | null | undefined, shipToAddress: string | null | undefined, billToAddress: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfListOfCustomerDepartmentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDepartment?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (shipToAddress !== undefined && shipToAddress !== null)
            url_ += "ShipToAddress=" + encodeURIComponent("" + shipToAddress) + "&";
        if (billToAddress !== undefined && billToAddress !== null)
            url_ += "BillToAddress=" + encodeURIComponent("" + billToAddress) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDepartmentGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDepartmentGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfListOfCustomerDepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfListOfCustomerDepartmentModel>;
        }));
    }

    protected processCustomerDepartmentGet(response: HttpResponseBase): Observable<AuditActionResultOfListOfCustomerDepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfListOfCustomerDepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDepartmentPost(version: string, request: CreateCustomerDepartmentRequest): Observable<AuditActionResultOfCustomerDepartmentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDepartment";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDepartmentPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDepartmentPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
        }));
    }

    protected processCustomerDepartmentPost(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDepartmentPatch(version: string, request: UpdateCustomerDepartmentRequest): Observable<AuditActionResultOfCustomerDepartmentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDepartment";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDepartmentPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDepartmentPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
        }));
    }

    protected processCustomerDepartmentPatch(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDepartmentDelete(id: number, version: string): Observable<AuditActionResultOfCustomerDepartmentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDepartment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDepartmentDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDepartmentDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDepartmentModel>;
        }));
    }

    protected processCustomerDepartmentDelete(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDepartmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDepartmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerDocumentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    customerDocumentGet(id: number | null | undefined, customerId: number | null | undefined, name: string | null | undefined, classification: string | null | undefined, oEMId: number | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfListOfCustomerDocumentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDocument?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (classification !== undefined && classification !== null)
            url_ += "Classification=" + encodeURIComponent("" + classification) + "&";
        if (oEMId !== undefined && oEMId !== null)
            url_ += "OEMId=" + encodeURIComponent("" + oEMId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDocumentGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDocumentGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfListOfCustomerDocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfListOfCustomerDocumentModel>;
        }));
    }

    protected processCustomerDocumentGet(response: HttpResponseBase): Observable<AuditActionResultOfListOfCustomerDocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfListOfCustomerDocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDocumentPost(version: string, request: CreateCustomerDocumentRequest): Observable<AuditActionResultOfCustomerDocumentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDocument";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDocumentPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDocumentPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
        }));
    }

    protected processCustomerDocumentPost(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDocumentPatch(version: string, request: UpdateCustomerDocumentRequest): Observable<AuditActionResultOfCustomerDocumentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDocument";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDocumentPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDocumentPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
        }));
    }

    protected processCustomerDocumentPatch(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerDocumentDelete(id: number, version: string): Observable<AuditActionResultOfCustomerDocumentModel> {
        let url_ = this.baseUrl + "/v{version}/CustomerDocument/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDocumentDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDocumentDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfCustomerDocumentModel>;
        }));
    }

    protected processCustomerDocumentDelete(response: HttpResponseBase): Observable<AuditActionResultOfCustomerDocumentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfCustomerDocumentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Gets a list of Documents or a single Document matching the Id.
     * @param id (optional) 
     * @param name (optional) 
     * @param revision (optional) 
     * @param lastUpdatedOn (optional) 
     * @param lastUpdatedFullName (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    documentGet(id: number | null | undefined, name: string | null | undefined, revision: number | null | undefined, lastUpdatedOn: Date | null | undefined, lastUpdatedFullName: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfDocumentView> {
        let url_ = this.baseUrl + "/v{version}/Document?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (lastUpdatedFullName !== undefined && lastUpdatedFullName !== null)
            url_ += "LastUpdatedFullName=" + encodeURIComponent("" + lastUpdatedFullName) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfDocumentView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfDocumentView>;
        }));
    }

    protected processDocumentGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfDocumentView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfDocumentView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Document or DocumentApproval.
     */
    documentPost(version: string, newDocument: CreateDocumentRequest): Observable<AuditActionResultOfDocumentView> {
        let url_ = this.baseUrl + "/v{version}/Document";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newDocument);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfDocumentView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfDocumentView>;
        }));
    }

    protected processDocumentPost(response: HttpResponseBase): Observable<AuditActionResultOfDocumentView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfDocumentView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a Document or DocumentApproval based on the user privilege. Id is required.
     */
    documentPatch(version: string, request: UpdateDocumentRequest): Observable<AuditActionResultOfDocumentView> {
        let url_ = this.baseUrl + "/v{version}/Document";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfDocumentView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfDocumentView>;
        }));
    }

    protected processDocumentPatch(response: HttpResponseBase): Observable<AuditActionResultOfDocumentView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfDocumentView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes any Document or DocumentApproval with a matching Id.
     */
    documentDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Document/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processDocumentDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets list of files from a folder
     * @param folder (optional) 
     */
    archive(folder: EnumAwsFolders | undefined, version: string): Observable<AuditActionResultOfICollectionOfArchiveDocumentView> {
        let url_ = this.baseUrl + "/v{version}/Document/Archive?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (folder === null)
            throw new globalThis.Error("The parameter 'folder' cannot be null.");
        else if (folder !== undefined)
            url_ += "Folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfArchiveDocumentView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfArchiveDocumentView>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfArchiveDocumentView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfArchiveDocumentView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EquipmentMaintenanceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Gets EM/PM items. Filter the item using Id.
     * @param id (optional) 
     * @param locationName (optional) 
     * @param createdOn (optional) 
     * @param createdFullName (optional) 
     * @param assignedToFullName (optional) 
     * @param troubleState (optional) 
     * @param maintenanceTask (optional) 
     * @param pemLastCompletedDate (optional) 
     * @param frequencyField (optional) 
     * @param comments (optional) 
     * @param statusName (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    equipmentMaintenanceGet(id: number | null | undefined, locationName: string | null | undefined, createdOn: Date | null | undefined, createdFullName: string | null | undefined, assignedToFullName: string | null | undefined, troubleState: boolean | null | undefined, maintenanceTask: string | null | undefined, pemLastCompletedDate: Date | null | undefined, frequencyField: number | null | undefined, comments: string | null | undefined, statusName: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel> {
        let url_ = this.baseUrl + "/v{version}/EquipmentMaintenance?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (locationName !== undefined && locationName !== null)
            url_ += "LocationName=" + encodeURIComponent("" + locationName) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdFullName !== undefined && createdFullName !== null)
            url_ += "CreatedFullName=" + encodeURIComponent("" + createdFullName) + "&";
        if (assignedToFullName !== undefined && assignedToFullName !== null)
            url_ += "AssignedToFullName=" + encodeURIComponent("" + assignedToFullName) + "&";
        if (troubleState !== undefined && troubleState !== null)
            url_ += "TroubleState=" + encodeURIComponent("" + troubleState) + "&";
        if (maintenanceTask !== undefined && maintenanceTask !== null)
            url_ += "MaintenanceTask=" + encodeURIComponent("" + maintenanceTask) + "&";
        if (pemLastCompletedDate !== undefined && pemLastCompletedDate !== null)
            url_ += "PemLastCompletedDate=" + encodeURIComponent(pemLastCompletedDate ? "" + pemLastCompletedDate.toISOString() : "") + "&";
        if (frequencyField !== undefined && frequencyField !== null)
            url_ += "FrequencyField=" + encodeURIComponent("" + frequencyField) + "&";
        if (comments !== undefined && comments !== null)
            url_ += "Comments=" + encodeURIComponent("" + comments) + "&";
        if (statusName !== undefined && statusName !== null)
            statusName && statusName.forEach(item => { url_ += "StatusName=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentMaintenanceGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentMaintenanceGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel>;
        }));
    }

    protected processEquipmentMaintenanceGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new EM/PM entry
     */
    equipmentMaintenancePost(version: string, request: CreateEquipmentMaintenanceRequest): Observable<AuditActionResultOfEquipmentMaintenanceModel> {
        let url_ = this.baseUrl + "/v{version}/EquipmentMaintenance";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentMaintenancePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentMaintenancePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfEquipmentMaintenanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfEquipmentMaintenanceModel>;
        }));
    }

    protected processEquipmentMaintenancePost(response: HttpResponseBase): Observable<AuditActionResultOfEquipmentMaintenanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfEquipmentMaintenanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    equipmentMaintenancePatch(version: string, request: UpdateEquipmentMaintenanceRequest): Observable<AuditActionResultOfEquipmentMaintenanceModel> {
        let url_ = this.baseUrl + "/v{version}/EquipmentMaintenance";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentMaintenancePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentMaintenancePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfEquipmentMaintenanceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfEquipmentMaintenanceModel>;
        }));
    }

    protected processEquipmentMaintenancePatch(response: HttpResponseBase): Observable<AuditActionResultOfEquipmentMaintenanceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfEquipmentMaintenanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    equipmentMaintenanceDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/EquipmentMaintenance/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEquipmentMaintenanceDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEquipmentMaintenanceDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processEquipmentMaintenanceDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FacilityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    facility(partId: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfFacilityModel> {
        let url_ = this.baseUrl + "/v{version}/Facility?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (partId !== undefined && partId !== null)
            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfFacilityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfFacilityModel>;
        }));
    }

    protected processFacility(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfFacilityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfFacilityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FeatureFlagsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get all feature flags
     * @return Dictionary of feature flags
     */
    featureFlags(version: string): Observable<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/v{version}/FeatureFlags";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeatureFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeatureFlags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: boolean; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: boolean; }>;
        }));
    }

    protected processFeatureFlags(response: HttpResponseBase): Observable<{ [key: string]: boolean; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * GetFiles
     * @param entityName (optional) 
     * @param entityId (optional) 
     * @param fileId (optional) 
     */
    fileGet(entityName: string | null | undefined, entityId: number | null | undefined, fileId: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfFileModel> {
        let url_ = this.baseUrl + "/v{version}/File?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (entityName !== undefined && entityName !== null)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (fileId !== undefined && fileId !== null)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfFileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfFileModel>;
        }));
    }

    protected processFileGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfFileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfFileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * AddFile
     */
    filePost(version: string, newfile: CreateFileRequest): Observable<AuditActionResultOfFileModel> {
        let url_ = this.baseUrl + "/v{version}/File";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfFileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfFileModel>;
        }));
    }

    protected processFilePost(response: HttpResponseBase): Observable<AuditActionResultOfFileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfFileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Detach a file from an entity.
     * @param entityName (optional) 
     * @param entityId (optional) 
     * @param fileId (optional) 
     */
    fileDelete(entityName: string | null | undefined, entityId: number | undefined, fileId: number | null | undefined, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/File?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (entityName !== undefined && entityName !== null)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (fileId !== undefined && fileId !== null)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processFileDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Import data file
     */
    import(version: string, request: ImportRequest): Observable<ImportAuditActionResultOfIEnumerableOfImportError> {
        let url_ = this.baseUrl + "/v{version}/File/Import";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportAuditActionResultOfIEnumerableOfImportError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportAuditActionResultOfIEnumerableOfImportError>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ImportAuditActionResultOfIEnumerableOfImportError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportAuditActionResultOfIEnumerableOfImportError.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute import directly
     */
    executeImport(version: string, request: ProcessImportRequest): Observable<AuditActionResultOfInteger> {
        let url_ = this.baseUrl + "/v{version}/File/ExecuteImport";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfInteger>;
        }));
    }

    protected processExecuteImport(response: HttpResponseBase): Observable<AuditActionResultOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hierarchy(purchaseId: number, version: string): Observable<AuditActionResultOfICollectionOfPurchaseHierarchyFileModel> {
        let url_ = this.baseUrl + "/v{version}/File/Purchase/{purchaseId}/Hierarchy";
        if (purchaseId === undefined || purchaseId === null)
            throw new globalThis.Error("The parameter 'purchaseId' must be defined.");
        url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHierarchy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPurchaseHierarchyFileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPurchaseHierarchyFileModel>;
        }));
    }

    protected processHierarchy(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPurchaseHierarchyFileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPurchaseHierarchyFileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    helpGet(id: number | null | undefined, friendlyURL: string | null | undefined, title: string | null | undefined, roles: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfHelpPage> {
        let url_ = this.baseUrl + "/v{version}/Help?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (friendlyURL !== undefined && friendlyURL !== null)
            url_ += "FriendlyURL=" + encodeURIComponent("" + friendlyURL) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfHelpPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfHelpPage>;
        }));
    }

    protected processHelpGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfHelpPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfHelpPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    helpPost(version: string, request: CreateHelpPageRequest): Observable<AuditActionResultOfHelpPage> {
        let url_ = this.baseUrl + "/v{version}/Help";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfHelpPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfHelpPage>;
        }));
    }

    protected processHelpPost(response: HttpResponseBase): Observable<AuditActionResultOfHelpPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfHelpPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    helpPatch(version: string, request: UpdateHelpPageRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Help";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processHelpPatch(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolePost(version: string, request: CreateHelpPageRoleRequest): Observable<AuditActionResultOfHelpPage> {
        let url_ = this.baseUrl + "/v{version}/Help/Role";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfHelpPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfHelpPage>;
        }));
    }

    protected processRolePost(response: HttpResponseBase): Observable<AuditActionResultOfHelpPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfHelpPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roleDelete(helpPageId: number | undefined, roleId: number | undefined, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Help/Role?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (helpPageId === null)
            throw new globalThis.Error("The parameter 'helpPageId' cannot be null.");
        else if (helpPageId !== undefined)
            url_ += "HelpPageId=" + encodeURIComponent("" + helpPageId) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRoleDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    helpDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Help/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processHelpDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    invoiceGet(id: number | null | undefined, customerName: string | null | undefined, description: string | null | undefined, invoiceNumber: string | null | undefined, dueDate: Date[] | null | undefined, createdOn: Date | null | undefined, createdByName: string | null | undefined, lastUpdatedOn: Date | null | undefined, lastUpdatedByName: string | null | undefined, amount: number | null | undefined, statusId: number | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfInvoiceView> {
        let url_ = this.baseUrl + "/v{version}/Invoice?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (dueDate !== undefined && dueDate !== null)
            dueDate && dueDate.forEach(item_ => { url_ += "DueDate=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdByName !== undefined && createdByName !== null)
            url_ += "CreatedByName=" + encodeURIComponent("" + createdByName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (lastUpdatedByName !== undefined && lastUpdatedByName !== null)
            url_ += "LastUpdatedByName=" + encodeURIComponent("" + lastUpdatedByName) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfInvoiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfInvoiceView>;
        }));
    }

    protected processInvoiceGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfInvoiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfInvoiceView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invoicePatch(version: string, request: UpdateInvoiceRequest): Observable<AuditActionResultOfInvoiceView> {
        let url_ = this.baseUrl + "/v{version}/Invoice";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoicePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoicePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfInvoiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfInvoiceView>;
        }));
    }

    protected processInvoicePatch(response: HttpResponseBase): Observable<AuditActionResultOfInvoiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfInvoiceView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOneInvoice(version: string, request: CreateInvoiceRequest): Observable<AuditActionResultOfInvoiceView> {
        let url_ = this.baseUrl + "/v{version}/Invoice/CreateOneInvoice";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOneInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOneInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfInvoiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfInvoiceView>;
        }));
    }

    protected processCreateOneInvoice(response: HttpResponseBase): Observable<AuditActionResultOfInvoiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfInvoiceView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createIndividualInvoices(version: string, request: CreateInvoiceRequest): Observable<AuditActionResultOfIEnumerableOfInvoiceView> {
        let url_ = this.baseUrl + "/v{version}/Invoice/CreateIndividualInvoices";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIndividualInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIndividualInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfInvoiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfInvoiceView>;
        }));
    }

    protected processCreateIndividualInvoices(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfInvoiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfInvoiceView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download(id: number | null | undefined, customerName: string | null | undefined, description: string | null | undefined, invoiceNumber: string | null | undefined, dueDate: Date[] | null | undefined, createdOn: Date | null | undefined, createdByName: string | null | undefined, lastUpdatedOn: Date | null | undefined, lastUpdatedByName: string | null | undefined, amount: number | null | undefined, statusId: number | null | undefined, version: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v{version}/Invoice/Download?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (dueDate !== undefined && dueDate !== null)
            dueDate && dueDate.forEach(item_ => { url_ += "DueDate=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdByName !== undefined && createdByName !== null)
            url_ += "CreatedByName=" + encodeURIComponent("" + createdByName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (lastUpdatedByName !== undefined && lastUpdatedByName !== null)
            url_ += "LastUpdatedByName=" + encodeURIComponent("" + lastUpdatedByName) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    locationGet(parentId: number | null | undefined, id: number | null | undefined, internalAddress: string | null | undefined, name: string | null | undefined, createdFullName: string | null | undefined, createdOn: Date | null | undefined, address1: string | null | undefined, city: string | null | undefined, state: string | null | undefined, postalcode: string | null | undefined, country: string | null | undefined, phone: string | null | undefined, parentName: string | null | undefined, timezoneDescription: string | null | undefined, address2: string | null | undefined, isActive: boolean[] | null | undefined, status: string[] | null | undefined, partId: number | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfLocationModel> {
        let url_ = this.baseUrl + "/v{version}/Location?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (parentId !== undefined && parentId !== null)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (internalAddress !== undefined && internalAddress !== null)
            url_ += "InternalAddress=" + encodeURIComponent("" + internalAddress) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (createdFullName !== undefined && createdFullName !== null)
            url_ += "CreatedFullName=" + encodeURIComponent("" + createdFullName) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (address1 !== undefined && address1 !== null)
            url_ += "Address1=" + encodeURIComponent("" + address1) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (postalcode !== undefined && postalcode !== null)
            url_ += "Postalcode=" + encodeURIComponent("" + postalcode) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (parentName !== undefined && parentName !== null)
            url_ += "ParentName=" + encodeURIComponent("" + parentName) + "&";
        if (timezoneDescription !== undefined && timezoneDescription !== null)
            url_ += "TimezoneDescription=" + encodeURIComponent("" + timezoneDescription) + "&";
        if (address2 !== undefined && address2 !== null)
            url_ += "Address2=" + encodeURIComponent("" + address2) + "&";
        if (isActive !== undefined && isActive !== null)
            isActive && isActive.forEach(item => { url_ += "IsActive=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (partId !== undefined && partId !== null)
            url_ += "PartId=" + encodeURIComponent("" + partId) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfLocationModel>;
        }));
    }

    protected processLocationGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfLocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    locationPost(version: string, request: CreateLocationRequest): Observable<AuditActionResultOfLocationModel> {
        let url_ = this.baseUrl + "/v{version}/Location";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfLocationModel>;
        }));
    }

    protected processLocationPost(response: HttpResponseBase): Observable<AuditActionResultOfLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfLocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    locationPatch(version: string, request: UpdateLocationRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Location";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processLocationPatch(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sensorGet(id: number, version: string): Observable<AuditActionResultOfIEnumerableOfSensorModel> {
        let url_ = this.baseUrl + "/v{version}/Location/{id}/Sensor";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSensorGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSensorGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfSensorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfSensorModel>;
        }));
    }

    protected processSensorGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfSensorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfSensorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sensorPost(locationId: number, sensorId: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Location/{locationId}/Sensor/{sensorId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (sensorId === undefined || sensorId === null)
            throw new globalThis.Error("The parameter 'sensorId' must be defined.");
        url_ = url_.replace("{sensorId}", encodeURIComponent("" + sensorId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSensorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSensorPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processSensorPost(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sensorDelete(locationId: number, sensorId: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Location/{locationId}/Sensor/{sensorId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (sensorId === undefined || sensorId === null)
            throw new globalThis.Error("The parameter 'sensorId' must be defined.");
        url_ = url_.replace("{sensorId}", encodeURIComponent("" + sensorId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSensorDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSensorDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processSensorDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    locationDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processLocationDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    permanent(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Location/{id}/permanent";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processPermanent(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MenuService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    menu(version: string): Observable<AuditActionResultOfIEnumerableOfMenuItem> {
        let url_ = this.baseUrl + "/v{version}/Menu";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfMenuItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfMenuItem>;
        }));
    }

    protected processMenu(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfMenuItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfMenuItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolePost(version: string, request: CreateMenuRoleMapRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/Menu/Role";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processRolePost(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolePatch(version: string, request: UpdateMenuRoleMapRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Menu/Role";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRolePatch(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roleDelete(menuId: number | undefined, roleId: number | undefined, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Menu/Role?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (menuId === null)
            throw new globalThis.Error("The parameter 'menuId' cannot be null.");
        else if (menuId !== undefined)
            url_ += "MenuId=" + encodeURIComponent("" + menuId) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRoleDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NCTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get all NC Types
     */
    nCType(version: string): Observable<AuditActionResultOfICollectionOfNCTypeModel> {
        let url_ = this.baseUrl + "/v{version}/NCType";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNCType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNCType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfNCTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfNCTypeModel>;
        }));
    }

    protected processNCType(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfNCTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfNCTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartBagSizeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Bag Sizes
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partBagSizeGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartBagSizeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagSize?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagSizeGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagSizeGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartBagSizeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartBagSizeModel>;
        }));
    }

    protected processPartBagSizeGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartBagSizeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartBagSizeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Bag Size
     */
    partBagSizePost(version: string, request: CreatePartBagSizeRequest): Observable<AuditActionResultOfPartBagSizeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagSize";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagSizePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagSizePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartBagSizeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartBagSizeModel>;
        }));
    }

    protected processPartBagSizePost(response: HttpResponseBase): Observable<AuditActionResultOfPartBagSizeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartBagSizeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Bag Size
     */
    partBagSizePatch(version: string, request: UpdatePartBagSizeRequest): Observable<AuditActionResultOfPartBagSizeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagSize";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagSizePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagSizePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartBagSizeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartBagSizeModel>;
        }));
    }

    protected processPartBagSizePatch(response: HttpResponseBase): Observable<AuditActionResultOfPartBagSizeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartBagSizeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Bag Size
     */
    partBagSizeDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartBagSize/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagSizeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagSizeDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartBagSizeDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartBagTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Bag Types
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partBagTypeGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartBagTypeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagType?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagTypeGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagTypeGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartBagTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartBagTypeModel>;
        }));
    }

    protected processPartBagTypeGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartBagTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartBagTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Bag Type
     */
    partBagTypePost(version: string, request: CreatePartBagTypeRequest): Observable<AuditActionResultOfPartBagTypeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagType";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagTypePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagTypePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartBagTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartBagTypeModel>;
        }));
    }

    protected processPartBagTypePost(response: HttpResponseBase): Observable<AuditActionResultOfPartBagTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartBagTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Bag Type
     */
    partBagTypePatch(version: string, request: UpdatePartBagTypeRequest): Observable<AuditActionResultOfPartBagTypeModel> {
        let url_ = this.baseUrl + "/v{version}/PartBagType";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagTypePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagTypePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartBagTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartBagTypeModel>;
        }));
    }

    protected processPartBagTypePatch(response: HttpResponseBase): Observable<AuditActionResultOfPartBagTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartBagTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Bag Type
     */
    partBagTypeDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartBagType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartBagTypeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartBagTypeDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartBagTypeDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartCoatingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Coatings
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partCoatingGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartCoatingModel> {
        let url_ = this.baseUrl + "/v{version}/PartCoating?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartCoatingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartCoatingGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartCoatingModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartCoatingModel>;
        }));
    }

    protected processPartCoatingGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartCoatingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartCoatingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Coating
     */
    partCoatingPost(version: string, request: CreatePartCoatingRequest): Observable<AuditActionResultOfPartCoatingModel> {
        let url_ = this.baseUrl + "/v{version}/PartCoating";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartCoatingPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartCoatingPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartCoatingModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartCoatingModel>;
        }));
    }

    protected processPartCoatingPost(response: HttpResponseBase): Observable<AuditActionResultOfPartCoatingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartCoatingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Coating
     */
    partCoatingPatch(version: string, request: UpdatePartCoatingRequest): Observable<AuditActionResultOfPartCoatingModel> {
        let url_ = this.baseUrl + "/v{version}/PartCoating";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartCoatingPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartCoatingPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartCoatingModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartCoatingModel>;
        }));
    }

    protected processPartCoatingPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartCoatingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartCoatingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Coating
     */
    partCoatingDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartCoating/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartCoatingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartCoatingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartCoatingDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get parts (paged list)
     * @param id (optional) 
     * @param name (optional) 
     * @param segregationType (optional) 
     * @param partNumber (optional) 
     * @param nickName (optional) 
     * @param oemPartNumber (optional) 
     * @param isKit (optional) 
     * @param isActive (optional) 
     * @param customerName (optional) 
     * @param maximumCycles (optional) 
     * @param customerId (optional) 
     * @param procedureId (optional) 
     * @param oEMId (optional) 
     * @param createdOn (optional) 
     * @param createdByName (optional) 
     * @param lastUpdatedOn (optional) 
     * @param lastUpdatedByName (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    partGet(id: number | null | undefined, name: string | null | undefined, segregationType: EnumSegregationType[] | null | undefined, partNumber: string | null | undefined, nickName: string | null | undefined, oemPartNumber: string | null | undefined, isKit: boolean | null | undefined, isActive: boolean | null | undefined, customerName: string | null | undefined, maximumCycles: number | null | undefined, customerId: number | null | undefined, procedureId: number | null | undefined, oEMId: number | null | undefined, createdOn: Date | null | undefined, createdByName: string | null | undefined, lastUpdatedOn: Date | null | undefined, lastUpdatedByName: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartModel> {
        let url_ = this.baseUrl + "/v{version}/Part?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (segregationType !== undefined && segregationType !== null)
            segregationType && segregationType.forEach(item => { url_ += "SegregationType=" + encodeURIComponent("" + item) + "&"; });
        if (partNumber !== undefined && partNumber !== null)
            url_ += "PartNumber=" + encodeURIComponent("" + partNumber) + "&";
        if (nickName !== undefined && nickName !== null)
            url_ += "NickName=" + encodeURIComponent("" + nickName) + "&";
        if (oemPartNumber !== undefined && oemPartNumber !== null)
            url_ += "OemPartNumber=" + encodeURIComponent("" + oemPartNumber) + "&";
        if (isKit !== undefined && isKit !== null)
            url_ += "IsKit=" + encodeURIComponent("" + isKit) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (maximumCycles !== undefined && maximumCycles !== null)
            url_ += "MaximumCycles=" + encodeURIComponent("" + maximumCycles) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (procedureId !== undefined && procedureId !== null)
            url_ += "ProcedureId=" + encodeURIComponent("" + procedureId) + "&";
        if (oEMId !== undefined && oEMId !== null)
            url_ += "OEMId=" + encodeURIComponent("" + oEMId) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdByName !== undefined && createdByName !== null)
            url_ += "CreatedByName=" + encodeURIComponent("" + createdByName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "lastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (lastUpdatedByName !== undefined && lastUpdatedByName !== null)
            url_ += "LastUpdatedByName=" + encodeURIComponent("" + lastUpdatedByName) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartModel>;
        }));
    }

    protected processPartGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create part
     */
    partPost(version: string, newpart: CreatePartRequest): Observable<AuditActionResultOfPartModel> {
        let url_ = this.baseUrl + "/v{version}/Part";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newpart);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartModel>;
        }));
    }

    protected processPartPost(response: HttpResponseBase): Observable<AuditActionResultOfPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update part
     */
    partPatch(version: string, newpart: UpdatePartRequest): Observable<AuditActionResultOfPartModel> {
        let url_ = this.baseUrl + "/v{version}/Part";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newpart);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartModel>;
        }));
    }

    protected processPartPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy part
     */
    copy(partId: number, version: string): Observable<AuditActionResultOfPartModel> {
        let url_ = this.baseUrl + "/v{version}/Part/copy/{partId}";
        if (partId === undefined || partId === null)
            throw new globalThis.Error("The parameter 'partId' must be defined.");
        url_ = url_.replace("{partId}", encodeURIComponent("" + partId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartModel>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<AuditActionResultOfPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get delete impact for a part (shows what will be deleted)
     */
    deleteImpact(id: number, version: string): Observable<PartDeleteImpactModel> {
        let url_ = this.baseUrl + "/v{version}/Part/{id}/delete-impact";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImpact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImpact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartDeleteImpactModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartDeleteImpactModel>;
        }));
    }

    protected processDeleteImpact(response: HttpResponseBase): Observable<PartDeleteImpactModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartDeleteImpactModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete part by Id
     * @param deleteSubparts (optional) If part is a kit and true, also delete exclusive subparts
     */
    partDelete(id: number, deleteSubparts: boolean | undefined, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Part/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (deleteSubparts === null)
            throw new globalThis.Error("The parameter 'deleteSubparts' cannot be null.");
        else if (deleteSubparts !== undefined)
            url_ += "deleteSubparts=" + encodeURIComponent("" + deleteSubparts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processPartDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate part by Id (sets IsActive = false)
     */
    deactivate(id: number, version: string): Observable<AuditActionResultOfPartModel> {
        let url_ = this.baseUrl + "/v{version}/Part/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartModel>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<AuditActionResultOfPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partExport(id: number | null | undefined, name: string | null | undefined, segregationType: EnumSegregationType[] | null | undefined, partNumber: string | null | undefined, oEMPartNumber: string | null | undefined, isKit: boolean | null | undefined, isActive: boolean | null | undefined, maximumCycles: number | null | undefined, createdOn: Date | null | undefined, createdByName: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v{version}/Part/partExport?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (segregationType !== undefined && segregationType !== null)
            segregationType && segregationType.forEach(item => { url_ += "SegregationType=" + encodeURIComponent("" + item) + "&"; });
        if (partNumber !== undefined && partNumber !== null)
            url_ += "PartNumber=" + encodeURIComponent("" + partNumber) + "&";
        if (oEMPartNumber !== undefined && oEMPartNumber !== null)
            url_ += "OEMPartNumber=" + encodeURIComponent("" + oEMPartNumber) + "&";
        if (isKit !== undefined && isKit !== null)
            url_ += "IsKit=" + encodeURIComponent("" + isKit) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (maximumCycles !== undefined && maximumCycles !== null)
            url_ += "MaximumCycles=" + encodeURIComponent("" + maximumCycles) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdByName !== undefined && createdByName !== null)
            url_ += "CreatedByName=" + encodeURIComponent("" + createdByName) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPartExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartDepositionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Depositions
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partDepositionGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartDepositionModel> {
        let url_ = this.baseUrl + "/v{version}/PartDeposition?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDepositionGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDepositionGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartDepositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartDepositionModel>;
        }));
    }

    protected processPartDepositionGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartDepositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartDepositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Deposition
     */
    partDepositionPost(version: string, request: CreatePartDepositionRequest): Observable<AuditActionResultOfPartDepositionModel> {
        let url_ = this.baseUrl + "/v{version}/PartDeposition";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDepositionPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDepositionPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartDepositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartDepositionModel>;
        }));
    }

    protected processPartDepositionPost(response: HttpResponseBase): Observable<AuditActionResultOfPartDepositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartDepositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Deposition
     */
    partDepositionPatch(version: string, request: UpdatePartDepositionRequest): Observable<AuditActionResultOfPartDepositionModel> {
        let url_ = this.baseUrl + "/v{version}/PartDeposition";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDepositionPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDepositionPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartDepositionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartDepositionModel>;
        }));
    }

    protected processPartDepositionPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartDepositionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartDepositionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Deposition
     */
    partDepositionDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartDeposition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDepositionDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDepositionDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartDepositionDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartDetailService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Details (by PartId and/or Id)
     * @param partId (optional) 
     * @param id (optional) 
     */
    partDetailGet(partId: number | null | undefined, id: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartDetailModel> {
        let url_ = this.baseUrl + "/v{version}/PartDetail?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (partId !== undefined && partId !== null)
            url_ += "PartId=" + encodeURIComponent("" + partId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDetailGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDetailGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartDetailModel>;
        }));
    }

    protected processPartDetailGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Detail
     */
    partDetailPost(version: string, request: CreatePartDetailRequest): Observable<AuditActionResultOfPartDetailModel> {
        let url_ = this.baseUrl + "/v{version}/PartDetail";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDetailPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDetailPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartDetailModel>;
        }));
    }

    protected processPartDetailPost(response: HttpResponseBase): Observable<AuditActionResultOfPartDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Detail
     */
    partDetailPatch(version: string, request: UpdatePartDetailRequest): Observable<AuditActionResultOfPartDetailModel> {
        let url_ = this.baseUrl + "/v{version}/PartDetail";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDetailPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDetailPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartDetailModel>;
        }));
    }

    protected processPartDetailPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Part Detail
     */
    partDetailDelete(id: number, version: string): Observable<AuditActionResultOfPartDetailModel> {
        let url_ = this.baseUrl + "/v{version}/PartDetail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartDetailDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartDetailDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartDetailModel>;
        }));
    }

    protected processPartDetailDelete(response: HttpResponseBase): Observable<AuditActionResultOfPartDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartLocationMapService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Location Maps (by PartId and/or Id)
     * @param partId (optional) 
     * @param id (optional) 
     */
    partLocationMapGet(partId: number | null | undefined, id: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartLocationMapModel> {
        let url_ = this.baseUrl + "/v{version}/PartLocationMap?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (partId !== undefined && partId !== null)
            url_ += "PartId=" + encodeURIComponent("" + partId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartLocationMapGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartLocationMapGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartLocationMapModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartLocationMapModel>;
        }));
    }

    protected processPartLocationMapGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartLocationMapModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartLocationMapModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Location Map
     */
    partLocationMapPost(version: string, request: CreatePartLocationMapRequest): Observable<AuditActionResultOfPartLocationMapModel> {
        let url_ = this.baseUrl + "/v{version}/PartLocationMap";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartLocationMapPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartLocationMapPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartLocationMapModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartLocationMapModel>;
        }));
    }

    protected processPartLocationMapPost(response: HttpResponseBase): Observable<AuditActionResultOfPartLocationMapModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartLocationMapModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Location Map
     */
    partLocationMapPatch(version: string, request: UpdatePartLocationMapRequest): Observable<AuditActionResultOfPartLocationMapModel> {
        let url_ = this.baseUrl + "/v{version}/PartLocationMap";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartLocationMapPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartLocationMapPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartLocationMapModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartLocationMapModel>;
        }));
    }

    protected processPartLocationMapPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartLocationMapModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartLocationMapModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Part Location Map
     */
    partLocationMapDelete(id: number, version: string): Observable<AuditActionResultOfPartLocationMapModel> {
        let url_ = this.baseUrl + "/v{version}/PartLocationMap/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartLocationMapDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartLocationMapDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartLocationMapModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartLocationMapModel>;
        }));
    }

    protected processPartLocationMapDelete(response: HttpResponseBase): Observable<AuditActionResultOfPartLocationMapModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartLocationMapModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartMonitorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Monitors (by PartId and/or Id)
     * @param partId (optional) 
     * @param id (optional) 
     */
    partMonitorGet(partId: number | null | undefined, id: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartMonitorModel> {
        let url_ = this.baseUrl + "/v{version}/PartMonitor?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (partId !== undefined && partId !== null)
            url_ += "PartId=" + encodeURIComponent("" + partId) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartMonitorGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartMonitorGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartMonitorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartMonitorModel>;
        }));
    }

    protected processPartMonitorGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartMonitorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartMonitorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Monitor
     */
    partMonitorPost(version: string, request: CreatePartMonitorRequest): Observable<AuditActionResultOfPartMonitorModel> {
        let url_ = this.baseUrl + "/v{version}/PartMonitor";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartMonitorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartMonitorPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartMonitorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartMonitorModel>;
        }));
    }

    protected processPartMonitorPost(response: HttpResponseBase): Observable<AuditActionResultOfPartMonitorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartMonitorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Monitor
     */
    partMonitorPatch(version: string, request: UpdatePartMonitorRequest): Observable<AuditActionResultOfPartMonitorModel> {
        let url_ = this.baseUrl + "/v{version}/PartMonitor";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartMonitorPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartMonitorPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartMonitorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartMonitorModel>;
        }));
    }

    protected processPartMonitorPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartMonitorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartMonitorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get monitor definition (input types and list items for dropdowns)
     */
    definition(version: string): Observable<AuditActionResultOfProcedureStepMonitorDefinition> {
        let url_ = this.baseUrl + "/v{version}/PartMonitor/definition";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepMonitorDefinition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepMonitorDefinition>;
        }));
    }

    protected processDefinition(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepMonitorDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepMonitorDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Part Monitor
     */
    partMonitorDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/PartMonitor/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartMonitorDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartMonitorDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processPartMonitorDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartOEMService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part OEMs
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partOEMGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartOEMModel> {
        let url_ = this.baseUrl + "/v{version}/PartOEM?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartOEMGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartOEMGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartOEMModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartOEMModel>;
        }));
    }

    protected processPartOEMGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartOEMModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartOEMModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part OEM
     */
    partOEMPost(version: string, request: CreatePartOEMRequest): Observable<AuditActionResultOfPartOEMModel> {
        let url_ = this.baseUrl + "/v{version}/PartOEM";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartOEMPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartOEMPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartOEMModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartOEMModel>;
        }));
    }

    protected processPartOEMPost(response: HttpResponseBase): Observable<AuditActionResultOfPartOEMModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartOEMModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part OEM
     */
    partOEMPatch(version: string, request: UpdatePartOEMRequest): Observable<AuditActionResultOfPartOEMModel> {
        let url_ = this.baseUrl + "/v{version}/PartOEM";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartOEMPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartOEMPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartOEMModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartOEMModel>;
        }));
    }

    protected processPartOEMPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartOEMModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartOEMModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part OEM
     */
    partOEMDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartOEM/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartOEMDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartOEMDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartOEMDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartProcessAreaService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Process Areas
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partProcessAreaGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartProcessAreaModel> {
        let url_ = this.baseUrl + "/v{version}/PartProcessArea?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartProcessAreaGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartProcessAreaGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartProcessAreaModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartProcessAreaModel>;
        }));
    }

    protected processPartProcessAreaGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartProcessAreaModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartProcessAreaModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Process Area
     */
    partProcessAreaPost(version: string, request: CreatePartProcessAreaRequest): Observable<AuditActionResultOfPartProcessAreaModel> {
        let url_ = this.baseUrl + "/v{version}/PartProcessArea";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartProcessAreaPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartProcessAreaPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartProcessAreaModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartProcessAreaModel>;
        }));
    }

    protected processPartProcessAreaPost(response: HttpResponseBase): Observable<AuditActionResultOfPartProcessAreaModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartProcessAreaModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Process Area
     */
    partProcessAreaPatch(version: string, request: UpdatePartProcessAreaRequest): Observable<AuditActionResultOfPartProcessAreaModel> {
        let url_ = this.baseUrl + "/v{version}/PartProcessArea";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartProcessAreaPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartProcessAreaPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartProcessAreaModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartProcessAreaModel>;
        }));
    }

    protected processPartProcessAreaPatch(response: HttpResponseBase): Observable<AuditActionResultOfPartProcessAreaModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartProcessAreaModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Process Area
     */
    partProcessAreaDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartProcessArea/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartProcessAreaDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartProcessAreaDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartProcessAreaDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartSubstrateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Part Substrates
     * @param id (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     */
    partSubstrateGet(id: number | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPartSubstrateModel> {
        let url_ = this.baseUrl + "/v{version}/PartSubstrate?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartSubstrateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartSubstrateGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPartSubstrateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPartSubstrateModel>;
        }));
    }

    protected processPartSubstrateGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPartSubstrateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPartSubstrateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a Part Substrate
     */
    partSubstratePost(version: string, request: CreatePartSubstrateRequest): Observable<AuditActionResultOfPartSubstrateModel> {
        let url_ = this.baseUrl + "/v{version}/PartSubstrate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartSubstratePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartSubstratePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartSubstrateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartSubstrateModel>;
        }));
    }

    protected processPartSubstratePost(response: HttpResponseBase): Observable<AuditActionResultOfPartSubstrateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartSubstrateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a Part Substrate
     */
    partSubstratePatch(version: string, request: UpdatePartSubstrateRequest): Observable<AuditActionResultOfPartSubstrateModel> {
        let url_ = this.baseUrl + "/v{version}/PartSubstrate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartSubstratePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartSubstratePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPartSubstrateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPartSubstrateModel>;
        }));
    }

    protected processPartSubstratePatch(response: HttpResponseBase): Observable<AuditActionResultOfPartSubstrateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPartSubstrateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Part Substrate
     */
    partSubstrateDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/PartSubstrate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartSubstrateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartSubstrateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processPartSubstrateDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcedureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Add Procedure
     */
    procedurePost(version: string, body: CreateProcedureRequest): Observable<AuditActionResultOfProcedure> {
        let url_ = this.baseUrl + "/v{version}/Procedure";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedurePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedurePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedure>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedure>;
        }));
    }

    protected processProcedurePost(response: HttpResponseBase): Observable<AuditActionResultOfProcedure> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedure.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get one of all Procedures
     * @param id (optional) 
     * @param name (optional) 
     * @param procedureTypeName (optional) 
     * @param duration (optional) 
     * @param durationType (optional) 
     * @param revision (optional) 
     * @param createdFullName (optional) 
     * @param createdOn (optional) 
     * @param lastUpdatedFullName (optional) 
     * @param lastUpdatedOn (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    procedureGet(id: number | null | undefined, name: string | null | undefined, procedureTypeName: string | null | undefined, duration: number | null | undefined, durationType: string | null | undefined, revision: number | null | undefined, createdFullName: string | null | undefined, createdOn: Date | null | undefined, lastUpdatedFullName: string | null | undefined, lastUpdatedOn: Date | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedure> {
        let url_ = this.baseUrl + "/v{version}/Procedure?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (procedureTypeName !== undefined && procedureTypeName !== null)
            url_ += "ProcedureTypeName=" + encodeURIComponent("" + procedureTypeName) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (durationType !== undefined && durationType !== null)
            url_ += "DurationType=" + encodeURIComponent("" + durationType) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (createdFullName !== undefined && createdFullName !== null)
            url_ += "CreatedFullName=" + encodeURIComponent("" + createdFullName) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (lastUpdatedFullName !== undefined && lastUpdatedFullName !== null)
            url_ += "LastUpdatedFullName=" + encodeURIComponent("" + lastUpdatedFullName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedure>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedure>;
        }));
    }

    protected processProcedureGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedure> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedure.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Procedure
     */
    procedurePatch(version: string, body: UpdateProcedureRequest): Observable<AuditActionResultOfProcedure> {
        let url_ = this.baseUrl + "/v{version}/Procedure";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedurePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedurePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedure>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedure>;
        }));
    }

    protected processProcedurePatch(response: HttpResponseBase): Observable<AuditActionResultOfProcedure> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedure.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy Procedure
     */
    copy(procedureId: number, version: string): Observable<AuditActionResultOfProcedure> {
        let url_ = this.baseUrl + "/v{version}/Procedure/copy/{procedureId}";
        if (procedureId === undefined || procedureId === null)
            throw new globalThis.Error("The parameter 'procedureId' must be defined.");
        url_ = url_.replace("{procedureId}", encodeURIComponent("" + procedureId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedure>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedure>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<AuditActionResultOfProcedure> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedure.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Procedure Step
     */
    stepPost(id: number, version: string, body: CreateProcedureStepRequest): Observable<AuditActionResultOfProcedureStepModel> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStepPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStepPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepModel>;
        }));
    }

    protected processStepPost(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Procedure Step
     * @param stepid (optional) 
     */
    stepGet(id: number, stepid: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedureStepModel> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/step?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (stepid !== undefined && stepid !== null)
            url_ += "stepid=" + encodeURIComponent("" + stepid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStepGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStepGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedureStepModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedureStepModel>;
        }));
    }

    protected processStepGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedureStepModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedureStepModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Procedure Step
     */
    stepPatch(id: number, version: string, body: UpdateProcedureStepRequest): Observable<AuditActionResultOfProcedureStepModel> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStepPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStepPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepModel>;
        }));
    }

    protected processStepPatch(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Procedure Delete Impact
     */
    deleteImpact(id: number, version: string): Observable<ProcedureDeleteImpactModel> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/delete-impact";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImpact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImpact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedureDeleteImpactModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedureDeleteImpactModel>;
        }));
    }

    protected processDeleteImpact(response: HttpResponseBase): Observable<ProcedureDeleteImpactModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedureDeleteImpactModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Procedure
     */
    procedureDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processProcedureDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Procedure Step
     */
    stepDelete(id: number, stepid: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/step/{stepid}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepid === undefined || stepid === null)
            throw new globalThis.Error("The parameter 'stepid' must be defined.");
        url_ = url_.replace("{stepid}", encodeURIComponent("" + stepid));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStepDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStepDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processStepDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    export(id: number | null | undefined, name: string | null | undefined, procedureTypeName: string | null | undefined, duration: number | null | undefined, durationType: string | null | undefined, revision: number | null | undefined, createdFullName: string | null | undefined, createdOn: Date | null | undefined, lastUpdatedFullName: string | null | undefined, lastUpdatedOn: Date | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v{version}/Procedure/export?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (procedureTypeName !== undefined && procedureTypeName !== null)
            url_ += "ProcedureTypeName=" + encodeURIComponent("" + procedureTypeName) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (durationType !== undefined && durationType !== null)
            url_ += "DurationType=" + encodeURIComponent("" + durationType) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (createdFullName !== undefined && createdFullName !== null)
            url_ += "CreatedFullName=" + encodeURIComponent("" + createdFullName) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (lastUpdatedFullName !== undefined && lastUpdatedFullName !== null)
            url_ += "LastUpdatedFullName=" + encodeURIComponent("" + lastUpdatedFullName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reorder(id: number, version: string, request: ReorderStepsRequest): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/Procedure/{id}/step/reorder";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processReorder(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcedureStepTemplateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get procedure step template by Id
     * @param id (optional) 
     * @param title (optional) 
     * @param text (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    procedureStepTemplateGet(id: number | null | undefined, title: string | null | undefined, text: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureStepTemplate?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (text !== undefined && text !== null)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureStepTemplateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureStepTemplateGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureStepTemplateGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add procedure step template
     */
    procedureStepTemplatePost(version: string, newTemplate: CreateProcedureStepTemplateRequest): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureStepTemplate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureStepTemplatePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureStepTemplatePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureStepTemplatePost(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update procedure step template
     */
    procedureStepTemplatePatch(version: string, request: UpdateProcedureStepTemplateRequest): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureStepTemplate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureStepTemplatePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureStepTemplatePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureStepTemplatePatch(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes any ProcedureStepTemplate with a matching Id.
     */
    procedureStepTemplateDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/ProcedureStepTemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureStepTemplateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureStepTemplateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processProcedureStepTemplateDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcedureStepTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get procedure step type
     * @param id (optional) 
     */
    procedureStepType(id: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedureStepTypeModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureStepType?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureStepType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureStepType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTypeModel>;
        }));
    }

    protected processProcedureStepType(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedureStepTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedureStepTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcedureTemplateService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Create a procedure template
     */
    procedureTemplatePost(version: string, body: CreateProcedureTemplateRequest): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureTemplate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTemplatePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTemplatePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureTemplatePost(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a procedure template
     * @param id (optional) 
     */
    procedureTemplateGet(id: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureTemplate?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTemplateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTemplateGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureTemplateGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a procedure template
     */
    procedureTemplatePatch(version: string, body: UpdateProcedureTemplateRequest): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        let url_ = this.baseUrl + "/v{version}/ProcedureTemplate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTemplatePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTemplatePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureStepTemplateModel>;
        }));
    }

    protected processProcedureTemplatePatch(response: HttpResponseBase): Observable<AuditActionResultOfProcedureStepTemplateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureStepTemplateModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a procedure template
     */
    procedureTemplateDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/ProcedureTemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTemplateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTemplateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processProcedureTemplateDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProcedureTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Add a procedure type
     */
    procedureTypePost(version: string, body: CreateProcedureTypeRequest): Observable<AuditActionResultOfProcedureType> {
        let url_ = this.baseUrl + "/v{version}/ProcedureType";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTypePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTypePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureType>;
        }));
    }

    protected processProcedureTypePost(response: HttpResponseBase): Observable<AuditActionResultOfProcedureType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get one or all procedure types
     * @param id (optional) 
     * @param name (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    procedureTypeGet(id: number | null | undefined, name: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfProcedureType> {
        let url_ = this.baseUrl + "/v{version}/ProcedureType?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTypeGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTypeGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfProcedureType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfProcedureType>;
        }));
    }

    protected processProcedureTypeGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfProcedureType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfProcedureType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a procedure type
     */
    procedureTypePatch(version: string, body: UpdateProcedureTypeRequest): Observable<AuditActionResultOfProcedureType> {
        let url_ = this.baseUrl + "/v{version}/ProcedureType";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTypePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTypePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfProcedureType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfProcedureType>;
        }));
    }

    protected processProcedureTypePatch(response: HttpResponseBase): Observable<AuditActionResultOfProcedureType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfProcedureType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a procedure type
     */
    procedureTypeDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/ProcedureType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcedureTypeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcedureTypeDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processProcedureTypeDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PurchaseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Purchase by id
     * @param id (optional) 
     * @param mttn (optional) 
     * @param purchaseOrderProductName (optional) 
     * @param statusId (optional) 
     * @param createdOn (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    purchaseGet(id: number | null | undefined, mttn: string | null | undefined, purchaseOrderProductName: string | null | undefined, statusId: string[] | null | undefined, createdOn: Date | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPurchaseModel> {
        let url_ = this.baseUrl + "/v{version}/Purchase?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (mttn !== undefined && mttn !== null)
            url_ += "Mttn=" + encodeURIComponent("" + mttn) + "&";
        if (purchaseOrderProductName !== undefined && purchaseOrderProductName !== null)
            url_ += "PurchaseOrderProductName=" + encodeURIComponent("" + purchaseOrderProductName) + "&";
        if (statusId !== undefined && statusId !== null)
            statusId && statusId.forEach(item => { url_ += "StatusId=" + encodeURIComponent("" + item) + "&"; });
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPurchaseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPurchaseModel>;
        }));
    }

    protected processPurchaseGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPurchaseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPurchaseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new purchase
     */
    purchasePost(version: string, request: CreatePurchaseRequest): Observable<AuditActionResultOfICollectionOfPurchaseModel> {
        let url_ = this.baseUrl + "/v{version}/Purchase";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchasePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchasePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPurchaseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPurchaseModel>;
        }));
    }

    protected processPurchasePost(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPurchaseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPurchaseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PurchaseOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    purchaseOrderGet(id: number | null | undefined, customerId: number | null | undefined, name: string | null | undefined, customerReferencePO: string | null | undefined, invoicedBalance: number | null | undefined, uninvoicedBalance: number | null | undefined, balance: number | null | undefined, customerName: string | null | undefined, openDate: Date | null | undefined, closeDate: Date | null | undefined, totalPurchaseLimit: number | null | undefined, unusedAmount: number | null | undefined, revision: number | null | undefined, status: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (customerReferencePO !== undefined && customerReferencePO !== null)
            url_ += "CustomerReferencePO=" + encodeURIComponent("" + customerReferencePO) + "&";
        if (invoicedBalance !== undefined && invoicedBalance !== null)
            url_ += "InvoicedBalance=" + encodeURIComponent("" + invoicedBalance) + "&";
        if (uninvoicedBalance !== undefined && uninvoicedBalance !== null)
            url_ += "UninvoicedBalance=" + encodeURIComponent("" + uninvoicedBalance) + "&";
        if (balance !== undefined && balance !== null)
            url_ += "Balance=" + encodeURIComponent("" + balance) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (openDate !== undefined && openDate !== null)
            url_ += "OpenDate=" + encodeURIComponent(openDate ? "" + openDate.toISOString() : "") + "&";
        if (closeDate !== undefined && closeDate !== null)
            url_ += "CloseDate=" + encodeURIComponent(closeDate ? "" + closeDate.toISOString() : "") + "&";
        if (totalPurchaseLimit !== undefined && totalPurchaseLimit !== null)
            url_ += "TotalPurchaseLimit=" + encodeURIComponent("" + totalPurchaseLimit) + "&";
        if (unusedAmount !== undefined && unusedAmount !== null)
            url_ += "UnusedAmount=" + encodeURIComponent("" + unusedAmount) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseOrderGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseOrderGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView>;
        }));
    }

    protected processPurchaseOrderGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfPurchaseOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    purchaseOrderPost(version: string, request: CreatePurchaseOrderRequest): Observable<AuditActionResultOfPurchaseOrderView> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseOrderPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseOrderPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPurchaseOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPurchaseOrderView>;
        }));
    }

    protected processPurchaseOrderPost(response: HttpResponseBase): Observable<AuditActionResultOfPurchaseOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPurchaseOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * UpdatePurchaseOrder
     */
    purchaseOrderPatch(version: string, request: UpdatePurchaseOrderRequest): Observable<AuditActionResultOfPurchaseOrderView> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseOrderPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseOrderPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPurchaseOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPurchaseOrderView>;
        }));
    }

    protected processPurchaseOrderPatch(response: HttpResponseBase): Observable<AuditActionResultOfPurchaseOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPurchaseOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * DeletePurchaseOrder
     */
    purchaseOrderDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseOrderDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseOrderDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processPurchaseOrderDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    view(id: number | null | undefined, name: string | null | undefined, customerReferencePO: string | null | undefined, invoicedBalance: number | null | undefined, uninvoicedBalance: number | null | undefined, balance: number | null | undefined, customerName: string | null | undefined, openDate: Date | null | undefined, closeDate: Date | null | undefined, totalPurchaseLimit: number | null | undefined, unusedAmount: number | null | undefined, revision: number | null | undefined, status: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderDBView> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder/View?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (customerReferencePO !== undefined && customerReferencePO !== null)
            url_ += "CustomerReferencePO=" + encodeURIComponent("" + customerReferencePO) + "&";
        if (invoicedBalance !== undefined && invoicedBalance !== null)
            url_ += "InvoicedBalance=" + encodeURIComponent("" + invoicedBalance) + "&";
        if (uninvoicedBalance !== undefined && uninvoicedBalance !== null)
            url_ += "UninvoicedBalance=" + encodeURIComponent("" + uninvoicedBalance) + "&";
        if (balance !== undefined && balance !== null)
            url_ += "Balance=" + encodeURIComponent("" + balance) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (openDate !== undefined && openDate !== null)
            url_ += "OpenDate=" + encodeURIComponent(openDate ? "" + openDate.toISOString() : "") + "&";
        if (closeDate !== undefined && closeDate !== null)
            url_ += "CloseDate=" + encodeURIComponent(closeDate ? "" + closeDate.toISOString() : "") + "&";
        if (totalPurchaseLimit !== undefined && totalPurchaseLimit !== null)
            url_ += "TotalPurchaseLimit=" + encodeURIComponent("" + totalPurchaseLimit) + "&";
        if (unusedAmount !== undefined && unusedAmount !== null)
            url_ += "UnusedAmount=" + encodeURIComponent("" + unusedAmount) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderDBView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderDBView>;
        }));
    }

    protected processView(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderDBView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfPurchaseOrderDBView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    part(id: number | null | undefined, customerId: number | null | undefined, name: string | null | undefined, customerReferencePO: string | null | undefined, invoicedBalance: number | null | undefined, uninvoicedBalance: number | null | undefined, balance: number | null | undefined, customerName: string | null | undefined, openDate: Date | null | undefined, closeDate: Date | null | undefined, totalPurchaseLimit: number | null | undefined, unusedAmount: number | null | undefined, revision: number | null | undefined, status: string[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView> {
        let url_ = this.baseUrl + "/v{version}/PurchaseOrder/Part?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (customerReferencePO !== undefined && customerReferencePO !== null)
            url_ += "CustomerReferencePO=" + encodeURIComponent("" + customerReferencePO) + "&";
        if (invoicedBalance !== undefined && invoicedBalance !== null)
            url_ += "InvoicedBalance=" + encodeURIComponent("" + invoicedBalance) + "&";
        if (uninvoicedBalance !== undefined && uninvoicedBalance !== null)
            url_ += "UninvoicedBalance=" + encodeURIComponent("" + uninvoicedBalance) + "&";
        if (balance !== undefined && balance !== null)
            url_ += "Balance=" + encodeURIComponent("" + balance) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (openDate !== undefined && openDate !== null)
            url_ += "OpenDate=" + encodeURIComponent(openDate ? "" + openDate.toISOString() : "") + "&";
        if (closeDate !== undefined && closeDate !== null)
            url_ += "CloseDate=" + encodeURIComponent(closeDate ? "" + closeDate.toISOString() : "") + "&";
        if (totalPurchaseLimit !== undefined && totalPurchaseLimit !== null)
            url_ += "TotalPurchaseLimit=" + encodeURIComponent("" + totalPurchaseLimit) + "&";
        if (unusedAmount !== undefined && unusedAmount !== null)
            url_ += "UnusedAmount=" + encodeURIComponent("" + unusedAmount) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView>;
        }));
    }

    protected processPart(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfPurchaseOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfPurchaseOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuoteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    paged(submittedDate: Date | null | undefined, company: string | null | undefined, submittedByFullName: string | null | undefined, divisionFab: string | null | undefined, partKitNo: string | null | undefined, segregationType: EnumSegregationType[] | null | undefined, procedureId: number | null | undefined, procedureName: string | null | undefined, productName: string | null | undefined, representative: string | null | undefined, revision: number | null | undefined, equipmentCost: number | null | undefined, materialCost: number | null | undefined, salesTax: number | null | undefined, totalPrice: number | null | undefined, cycleTime: number | null | undefined, lastUpdateOn: Date | null | undefined, lastUpdatedBy: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfQuotesView> {
        let url_ = this.baseUrl + "/v{version}/Quote/Paged?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (submittedDate !== undefined && submittedDate !== null)
            url_ += "SubmittedDate=" + encodeURIComponent(submittedDate ? "" + submittedDate.toISOString() : "") + "&";
        if (company !== undefined && company !== null)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        if (submittedByFullName !== undefined && submittedByFullName !== null)
            url_ += "SubmittedByFullName=" + encodeURIComponent("" + submittedByFullName) + "&";
        if (divisionFab !== undefined && divisionFab !== null)
            url_ += "DivisionFab=" + encodeURIComponent("" + divisionFab) + "&";
        if (partKitNo !== undefined && partKitNo !== null)
            url_ += "PartKitNo=" + encodeURIComponent("" + partKitNo) + "&";
        if (segregationType !== undefined && segregationType !== null)
            segregationType && segregationType.forEach(item => { url_ += "SegregationType=" + encodeURIComponent("" + item) + "&"; });
        if (procedureId !== undefined && procedureId !== null)
            url_ += "ProcedureId=" + encodeURIComponent("" + procedureId) + "&";
        if (procedureName !== undefined && procedureName !== null)
            url_ += "ProcedureName=" + encodeURIComponent("" + procedureName) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (representative !== undefined && representative !== null)
            url_ += "Representative=" + encodeURIComponent("" + representative) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (equipmentCost !== undefined && equipmentCost !== null)
            url_ += "EquipmentCost=" + encodeURIComponent("" + equipmentCost) + "&";
        if (materialCost !== undefined && materialCost !== null)
            url_ += "MaterialCost=" + encodeURIComponent("" + materialCost) + "&";
        if (salesTax !== undefined && salesTax !== null)
            url_ += "SalesTax=" + encodeURIComponent("" + salesTax) + "&";
        if (totalPrice !== undefined && totalPrice !== null)
            url_ += "TotalPrice=" + encodeURIComponent("" + totalPrice) + "&";
        if (cycleTime !== undefined && cycleTime !== null)
            url_ += "CycleTime=" + encodeURIComponent("" + cycleTime) + "&";
        if (lastUpdateOn !== undefined && lastUpdateOn !== null)
            url_ += "LastUpdateOn=" + encodeURIComponent(lastUpdateOn ? "" + lastUpdateOn.toISOString() : "") + "&";
        if (lastUpdatedBy !== undefined && lastUpdatedBy !== null)
            url_ += "LastUpdatedBy=" + encodeURIComponent("" + lastUpdatedBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfQuotesView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfQuotesView>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfQuotesView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfQuotesView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a Quote based on the quote request.
     * @return Quote DTO
     */
    quotePost(version: string, quote: CreateQuoteRequest): Observable<AuditActionResultOfQuoteModel> {
        let url_ = this.baseUrl + "/v{version}/Quote";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuotePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuotePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfQuoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfQuoteModel>;
        }));
    }

    protected processQuotePost(response: HttpResponseBase): Observable<AuditActionResultOfQuoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfQuoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    quoteGet(id: number | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfQuoteModel> {
        let url_ = this.baseUrl + "/v{version}/Quote?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuoteGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuoteGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfQuoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfQuoteModel>;
        }));
    }

    protected processQuoteGet(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfQuoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfQuoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a Quote based on the id parameter
     */
    quoteDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Quote/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuoteDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuoteDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processQuoteDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download(submittedDate: Date | null | undefined, company: string | null | undefined, submittedByFullName: string | null | undefined, divisionFab: string | null | undefined, partKitNo: string | null | undefined, segregationType: EnumSegregationType[] | null | undefined, procedureId: number | null | undefined, procedureName: string | null | undefined, productName: string | null | undefined, representative: string | null | undefined, revision: number | null | undefined, equipmentCost: number | null | undefined, materialCost: number | null | undefined, salesTax: number | null | undefined, totalPrice: number | null | undefined, cycleTime: number | null | undefined, lastUpdateOn: Date | null | undefined, lastUpdatedBy: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v{version}/Quote/Download?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (submittedDate !== undefined && submittedDate !== null)
            url_ += "SubmittedDate=" + encodeURIComponent(submittedDate ? "" + submittedDate.toISOString() : "") + "&";
        if (company !== undefined && company !== null)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        if (submittedByFullName !== undefined && submittedByFullName !== null)
            url_ += "SubmittedByFullName=" + encodeURIComponent("" + submittedByFullName) + "&";
        if (divisionFab !== undefined && divisionFab !== null)
            url_ += "DivisionFab=" + encodeURIComponent("" + divisionFab) + "&";
        if (partKitNo !== undefined && partKitNo !== null)
            url_ += "PartKitNo=" + encodeURIComponent("" + partKitNo) + "&";
        if (segregationType !== undefined && segregationType !== null)
            segregationType && segregationType.forEach(item => { url_ += "SegregationType=" + encodeURIComponent("" + item) + "&"; });
        if (procedureId !== undefined && procedureId !== null)
            url_ += "ProcedureId=" + encodeURIComponent("" + procedureId) + "&";
        if (procedureName !== undefined && procedureName !== null)
            url_ += "ProcedureName=" + encodeURIComponent("" + procedureName) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (representative !== undefined && representative !== null)
            url_ += "Representative=" + encodeURIComponent("" + representative) + "&";
        if (revision !== undefined && revision !== null)
            url_ += "Revision=" + encodeURIComponent("" + revision) + "&";
        if (equipmentCost !== undefined && equipmentCost !== null)
            url_ += "EquipmentCost=" + encodeURIComponent("" + equipmentCost) + "&";
        if (materialCost !== undefined && materialCost !== null)
            url_ += "MaterialCost=" + encodeURIComponent("" + materialCost) + "&";
        if (salesTax !== undefined && salesTax !== null)
            url_ += "SalesTax=" + encodeURIComponent("" + salesTax) + "&";
        if (totalPrice !== undefined && totalPrice !== null)
            url_ += "TotalPrice=" + encodeURIComponent("" + totalPrice) + "&";
        if (cycleTime !== undefined && cycleTime !== null)
            url_ += "CycleTime=" + encodeURIComponent("" + cycleTime) + "&";
        if (lastUpdateOn !== undefined && lastUpdateOn !== null)
            url_ += "LastUpdateOn=" + encodeURIComponent(lastUpdateOn ? "" + lastUpdateOn.toISOString() : "") + "&";
        if (lastUpdatedBy !== undefined && lastUpdatedBy !== null)
            url_ += "LastUpdatedBy=" + encodeURIComponent("" + lastUpdatedBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    report(isPortal: boolean | undefined, version: string): Observable<AuditActionResultOfICollectionOfReportModel> {
        let url_ = this.baseUrl + "/v{version}/Report?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (isPortal === null)
            throw new globalThis.Error("The parameter 'isPortal' cannot be null.");
        else if (isPortal !== undefined)
            url_ += "IsPortal=" + encodeURIComponent("" + isPortal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfReportModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfReportModel>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfReportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    roleGet(id: number | null | undefined, name: string | null | undefined, isCertificationRole: boolean | null | undefined, parentRoles: number[] | null | undefined, assignedUsers: number[] | null | undefined, createdOn: Date | null | undefined, createdByName: string | null | undefined, lastUpdatedOn: Date | null | undefined, lastUpdatedByName: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfRole> {
        let url_ = this.baseUrl + "/v{version}/Role?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isCertificationRole !== undefined && isCertificationRole !== null)
            url_ += "IsCertificationRole=" + encodeURIComponent("" + isCertificationRole) + "&";
        if (parentRoles !== undefined && parentRoles !== null)
            parentRoles && parentRoles.forEach(item => { url_ += "ParentRoles=" + encodeURIComponent("" + item) + "&"; });
        if (assignedUsers !== undefined && assignedUsers !== null)
            assignedUsers && assignedUsers.forEach(item => { url_ += "AssignedUsers=" + encodeURIComponent("" + item) + "&"; });
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (createdByName !== undefined && createdByName !== null)
            url_ += "CreatedByName=" + encodeURIComponent("" + createdByName) + "&";
        if (lastUpdatedOn !== undefined && lastUpdatedOn !== null)
            url_ += "LastUpdatedOn=" + encodeURIComponent(lastUpdatedOn ? "" + lastUpdatedOn.toISOString() : "") + "&";
        if (lastUpdatedByName !== undefined && lastUpdatedByName !== null)
            url_ += "LastUpdatedByName=" + encodeURIComponent("" + lastUpdatedByName) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfRole>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfRole>;
        }));
    }

    protected processRoleGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfRole> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolePost(version: string, request: CreateRoleRequest): Observable<AuditActionResultOfRole> {
        let url_ = this.baseUrl + "/v{version}/Role";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfRole>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfRole>;
        }));
    }

    protected processRolePost(response: HttpResponseBase): Observable<AuditActionResultOfRole> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolePatch(version: string, request: UpdateRoleRequest): Observable<AuditActionResultOfRole> {
        let url_ = this.baseUrl + "/v{version}/Role";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfRole>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfRole>;
        }));
    }

    protected processRolePatch(response: HttpResponseBase): Observable<AuditActionResultOfRole> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfRole.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rolesUsers(roleId: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfRolesUsersView> {
        let url_ = this.baseUrl + "/v{version}/Role/RolesUsers?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (roleId !== undefined && roleId !== null)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfRolesUsersView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfRolesUsersView>;
        }));
    }

    protected processRolesUsers(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfRolesUsersView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfRolesUsersView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roleDelete(id: number, version: string): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/v{version}/Role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRoleDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SearchService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    search(searchTerm: string | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfSearchView> {
        let url_ = this.baseUrl + "/v{version}/Search?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfSearchView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfSearchView>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfSearchView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfSearchView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SensorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    sensor(sensorId: number | null | undefined, siteId: number | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfSensorModel> {
        let url_ = this.baseUrl + "/v{version}/Sensor?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (sensorId !== undefined && sensorId !== null)
            url_ += "SensorId=" + encodeURIComponent("" + sensorId) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSensor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSensor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfSensorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfSensorModel>;
        }));
    }

    protected processSensor(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfSensorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfSensorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    name(version: string): Observable<AuditActionResultOfIEnumerableOfString> {
        let url_ = this.baseUrl + "/v{version}/Sensor/Name";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfString>;
        }));
    }

    protected processName(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    value(sensorName: string | null | undefined, siteId: number | null | undefined, version: string): Observable<AuditActionResultOfSensorValueModel> {
        let url_ = this.baseUrl + "/v{version}/Sensor/Value?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (sensorName !== undefined && sensorName !== null)
            url_ += "SensorName=" + encodeURIComponent("" + sensorName) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfSensorValueModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfSensorValueModel>;
        }));
    }

    protected processValue(response: HttpResponseBase): Observable<AuditActionResultOfSensorValueModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfSensorValueModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimezoneService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    timezone(version: string): Observable<AuditActionResultOfICollectionOfTimeZoneModel> {
        let url_ = this.baseUrl + "/v{version}/Timezone";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimezone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimezone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfTimeZoneModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfTimeZoneModel>;
        }));
    }

    protected processTimezone(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfTimeZoneModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfTimeZoneModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Get Users
     * @param id (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param userName (optional) 
     * @param title (optional) 
     * @param supervisorName (optional) 
     * @param primaryPhone (optional) 
     * @param email (optional) 
     * @param roles (optional) 
     * @param isActive (optional) 
     * @param isAnswerUser (optional) 
     * @param createdOn (optional) 
     * @param locationName (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    userGet(id: number | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, userName: string | null | undefined, title: string | null | undefined, supervisorName: string | null | undefined, primaryPhone: string | null | undefined, email: string | null | undefined, roles: number[] | null | undefined, isActive: boolean | null | undefined, isAnswerUser: boolean | null | undefined, createdOn: Date | null | undefined, locationName: string | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfUserModel> {
        let url_ = this.baseUrl + "/v{version}/User?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (supervisorName !== undefined && supervisorName !== null)
            url_ += "SupervisorName=" + encodeURIComponent("" + supervisorName) + "&";
        if (primaryPhone !== undefined && primaryPhone !== null)
            url_ += "PrimaryPhone=" + encodeURIComponent("" + primaryPhone) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAnswerUser !== undefined && isAnswerUser !== null)
            url_ += "IsAnswerUser=" + encodeURIComponent("" + isAnswerUser) + "&";
        if (createdOn !== undefined && createdOn !== null)
            url_ += "CreatedOn=" + encodeURIComponent(createdOn ? "" + createdOn.toISOString() : "") + "&";
        if (locationName !== undefined && locationName !== null)
            url_ += "LocationName=" + encodeURIComponent("" + locationName) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfUserModel>;
        }));
    }

    protected processUserGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new user
     */
    userPost(version: string, request: CreateUserRequest): Observable<AuditActionResultOfUserModel> {
        let url_ = this.baseUrl + "/v{version}/User";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfUserModel>;
        }));
    }

    protected processUserPost(response: HttpResponseBase): Observable<AuditActionResultOfUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a user
     */
    userPatch(version: string, request: UpdateUserRequest): Observable<AuditActionResultOfUserModel> {
        let url_ = this.baseUrl + "/v{version}/User";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfUserModel>;
        }));
    }

    protected processUserPatch(response: HttpResponseBase): Observable<AuditActionResultOfUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get logged in user data
     */
    loggedInUser(version: string): Observable<AuditActionResultOfUserModel> {
        let url_ = this.baseUrl + "/v{version}/User/LoggedInUser";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoggedInUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfUserModel>;
        }));
    }

    protected processLoggedInUser(response: HttpResponseBase): Observable<AuditActionResultOfUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get training certificates
     * @param userId (optional) 
     * @param employeeName (optional) 
     * @param certificationName (optional) 
     * @param certificationFromDate (optional) 
     * @param certificationToDate (optional) 
     * @param status (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    trainingCertification(userId: number | null | undefined, employeeName: string | null | undefined, certificationName: string | null | undefined, certificationFromDate: Date | null | undefined, certificationToDate: Date | null | undefined, status: boolean | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfIEnumerableOfTrainingCertificationView> {
        let url_ = this.baseUrl + "/v{version}/User/TrainingCertification?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (certificationName !== undefined && certificationName !== null)
            url_ += "CertificationName=" + encodeURIComponent("" + certificationName) + "&";
        if (certificationFromDate !== undefined && certificationFromDate !== null)
            url_ += "CertificationFromDate=" + encodeURIComponent(certificationFromDate ? "" + certificationFromDate.toISOString() : "") + "&";
        if (certificationToDate !== undefined && certificationToDate !== null)
            url_ += "CertificationToDate=" + encodeURIComponent(certificationToDate ? "" + certificationToDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainingCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainingCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfIEnumerableOfTrainingCertificationView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfIEnumerableOfTrainingCertificationView>;
        }));
    }

    protected processTrainingCertification(response: HttpResponseBase): Observable<AuditActionResultOfIEnumerableOfTrainingCertificationView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfIEnumerableOfTrainingCertificationView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a user (toggle active status)
     */
    userDelete(accountId: number, version: string): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/User/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Permanently delete a user and reassign references to Previous User
     */
    permanent(accountId: number, version: string): Observable<void> {
        let url_ = this.baseUrl + "/v{version}/User/{accountId}/permanent";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPermanent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign role
     */
    rolePost(request: CreateUserRoleRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRolePost(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit user role
     */
    rolePatch(request: UpdateUserRoleRequest): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRolePatch(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove user role
     */
    roleDelete(id: number): Observable<AuditActionResult> {
        let url_ = this.baseUrl + "/Role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResult>;
        }));
    }

    protected processRoleDelete(response: HttpResponseBase): Observable<AuditActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Returns a summary of SHIPPED WorkOrders grouped by Purchase
     * @param purchaseId (optional) 
     * @param workOrderItemNumber (optional) 
     * @param customer (optional) 
     * @param location (optional) 
     * @param serialNumber (optional) 
     * @param purchaseOrderNumber (optional) 
     * @param qty (optional) 
     * @param scheduledStartDate (optional) 
     * @param scheduledEndDate (optional) 
     * @param actualStartDate (optional) 
     * @param actualEndDate (optional) 
     * @param product (optional) 
     * @param procedure (optional) 
     * @param status (optional) 
     * @param disposition (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    history(purchaseId: number | null | undefined, workOrderItemNumber: string | null | undefined, customer: string | null | undefined, location: string[] | null | undefined, serialNumber: string | null | undefined, purchaseOrderNumber: string | null | undefined, qty: number | null | undefined, scheduledStartDate: Date | null | undefined, scheduledEndDate: Date | null | undefined, actualStartDate: Date | null | undefined, actualEndDate: Date | null | undefined, product: string | null | undefined, procedure: string | null | undefined, status: string[] | null | undefined, disposition: string | null | undefined, skip: number | null | undefined, take: number | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/History?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (purchaseId !== undefined && purchaseId !== null)
            url_ += "PurchaseId=" + encodeURIComponent("" + purchaseId) + "&";
        if (workOrderItemNumber !== undefined && workOrderItemNumber !== null)
            url_ += "WorkOrderItemNumber=" + encodeURIComponent("" + workOrderItemNumber) + "&";
        if (customer !== undefined && customer !== null)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&";
        if (location !== undefined && location !== null)
            location && location.forEach(item => { url_ += "Location=" + encodeURIComponent("" + item) + "&"; });
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (purchaseOrderNumber !== undefined && purchaseOrderNumber !== null)
            url_ += "PurchaseOrderNumber=" + encodeURIComponent("" + purchaseOrderNumber) + "&";
        if (qty !== undefined && qty !== null)
            url_ += "Qty=" + encodeURIComponent("" + qty) + "&";
        if (scheduledStartDate !== undefined && scheduledStartDate !== null)
            url_ += "ScheduledStartDate=" + encodeURIComponent(scheduledStartDate ? "" + scheduledStartDate.toISOString() : "") + "&";
        if (scheduledEndDate !== undefined && scheduledEndDate !== null)
            url_ += "ScheduledEndDate=" + encodeURIComponent(scheduledEndDate ? "" + scheduledEndDate.toISOString() : "") + "&";
        if (actualStartDate !== undefined && actualStartDate !== null)
            url_ += "ActualStartDate=" + encodeURIComponent(actualStartDate ? "" + actualStartDate.toISOString() : "") + "&";
        if (actualEndDate !== undefined && actualEndDate !== null)
            url_ += "ActualEndDate=" + encodeURIComponent(actualEndDate ? "" + actualEndDate.toISOString() : "") + "&";
        if (product !== undefined && product !== null)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (procedure !== undefined && procedure !== null)
            url_ += "Procedure=" + encodeURIComponent("" + procedure) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (disposition !== undefined && disposition !== null)
            url_ += "Disposition=" + encodeURIComponent("" + disposition) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPurchaseWorkOrderGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns WorkOrder SelectItems
     * @param assignedUserId (optional) 
     */
    selectItems(assignedUserId: number | undefined, version: string): Observable<AuditActionResultOfICollectionOfWorkOrderSelectItem> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/SelectItems?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (assignedUserId === null)
            throw new globalThis.Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined)
            url_ += "AssignedUserId=" + encodeURIComponent("" + assignedUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderSelectItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderSelectItem>;
        }));
    }

    protected processSelectItems(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderSelectItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderSelectItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a summary of NOT SHIPPED WorkOrders grouped by Purchase
     * @param filters (optional) 
     * @param term (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortAscending (optional) 
     */
    menu(filters: Filter[] | null | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Menu?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup>;
        }));
    }

    protected processMenu(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPurchaseWorkOrderGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPurchaseWorkOrderGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the WorkOrders that are either waiting to start or in Process.
     * @return The WorkOrders that are either waiting to start or in Process
     */
    status(version: string): Observable<AuditActionResultOfICollectionOfWorkOrderStatus> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Status";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderStatus>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get work order list by id, customerid, locationid, or date
     * @param id Get work order by ID
     */
    workOrderGet(id: number, version: string): Observable<AuditActionResultOfICollectionOfWorkOrderModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderModel>;
        }));
    }

    protected processWorkOrderGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderDelete(id: number, version: string): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processWorkOrderDelete(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get InvoiceableWorkOrders
     */
    invoiceable(version: string): Observable<AuditActionResultOfICollectionOfInvoiceableWorkOrderView> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Invoiceable";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfInvoiceableWorkOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfInvoiceableWorkOrderView>;
        }));
    }

    protected processInvoiceable(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfInvoiceableWorkOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfInvoiceableWorkOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invoiceablePurchases(version: string): Observable<AuditActionResultOfICollectionOfInvoiceablePurchaseView> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/InvoiceablePurchases";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceablePurchases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceablePurchases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfInvoiceablePurchaseView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfInvoiceablePurchaseView>;
        }));
    }

    protected processInvoiceablePurchases(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfInvoiceablePurchaseView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfInvoiceablePurchaseView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    portal(filters: Filter[] | null | undefined, customerId: number | undefined, subPartName: string | null | undefined, partId: number | null | undefined, fromDate: Date | undefined, toDate: Date | undefined, term: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, sortAscending: boolean | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfPortalWorkOrderView> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Portal?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (filters !== undefined && filters !== null)
            filters && filters.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (subPartName !== undefined && subPartName !== null)
            url_ += "SubPartName=" + encodeURIComponent("" + subPartName) + "&";
        if (partId !== undefined && partId !== null)
            url_ += "PartId=" + encodeURIComponent("" + partId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfPortalWorkOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfPortalWorkOrderView>;
        }));
    }

    protected processPortal(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfPortalWorkOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfPortalWorkOrderView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addReworkWorkOrderTask(version: string, request: AddReworkWorkOrderTaskRequest): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/AddReworkWorkOrderTask";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReworkWorkOrderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReworkWorkOrderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
        }));
    }

    protected processAddReworkWorkOrderTask(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(version: string, request: CreateWorkOrderRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Create";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    message(version: string, request: CreateWorkOrderMessageRequest): Observable<AuditActionResultOfWorkOrderMessageModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/Message";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderMessageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderMessageModel>;
        }));
    }

    protected processMessage(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderMessageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderMessageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    takeOver(version: string, request: TakeOverWorkOrderRequest): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/TakeOver";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTakeOver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTakeOver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
        }));
    }

    protected processTakeOver(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderCancel(version: string, request: CancelWorkOrderRequest): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/WorkOrderCancel";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel>;
        }));
    }

    protected processWorkOrderCancel(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePrice(version: string, request: UpdateWorkOrderPriceRequest): Observable<AuditActionResultOfWorkOrderModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/UpdatePrice";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderModel>;
        }));
    }

    protected processUpdatePrice(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePurchasePrice(version: string, request: UpdatePurchasePriceRequest): Observable<AuditActionResultOfPurchaseModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/UpdatePurchasePrice";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePurchasePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchasePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfPurchaseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfPurchaseModel>;
        }));
    }

    protected processUpdatePurchasePrice(response: HttpResponseBase): Observable<AuditActionResultOfPurchaseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfPurchaseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEndDate(version: string, request: UpdateWorkOrderEndDateRequest): Observable<AuditActionResultOfWorkOrderModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/UpdateEndDate";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEndDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderModel>;
        }));
    }

    protected processUpdateEndDate(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmPurchaseShipped(version: string, request: ConfirmPurchaseShippedRequest): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/ConfirmPurchaseShipped";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPurchaseShipped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPurchaseShipped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processConfirmPurchaseShipped(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transmitXml(version: string, request: TransmitXmlByWorkOrderRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/WorkOrder/TransmitXml";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransmitXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransmitXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processTransmitXml(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderPartService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    workOrderPartGet(id: number | null | undefined, workOrderId: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfWorkOrderPartModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (workOrderId !== undefined && workOrderId !== null)
            url_ += "WorkOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderPartGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderPartGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartModel>;
        }));
    }

    protected processWorkOrderPartGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * WorkOrderPartUpdateWorkOrderPart
     */
    workOrderPartPost(version: string, body: AddWorkOrderPartRequest): Observable<AuditActionResultOfWorkOrderPartModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderPartPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderPartPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderPartModel>;
        }));
    }

    protected processWorkOrderPartPost(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderPartPatch(version: string, body: UpdateWorkOrderPartRequest): Observable<AuditActionResultOfWorkOrderPartModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderPartPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderPartPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderPartModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderPartModel>;
        }));
    }

    protected processWorkOrderPartPatch(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderPartModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderPartModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    detail(id: number, version: string): Observable<AuditActionResultOfNCRPartWODetailView> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/Detail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfNCRPartWODetailView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfNCRPartWODetailView>;
        }));
    }

    protected processDetail(response: HttpResponseBase): Observable<AuditActionResultOfNCRPartWODetailView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfNCRPartWODetailView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulk(version: string, body: BulkUpdateWorkOrderPartRequest): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/Bulk";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processBulk(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cycleCount(version: string, request: CycleCountUpdateRequest): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/CycleCount";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCycleCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCycleCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processCycleCount(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    split(version: string, body: SplitWorkOrderPartRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/Split";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processSplit(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nCRGet(id: number | null | undefined, workOrderPartId: number | null | undefined, workOrderId: number | null | undefined, version: string): Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/NCR?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (workOrderPartId !== undefined && workOrderPartId !== null)
            url_ += "WorkOrderPartId=" + encodeURIComponent("" + workOrderPartId) + "&";
        if (workOrderId !== undefined && workOrderId !== null)
            url_ += "WorkOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNCRGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNCRGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel>;
        }));
    }

    protected processNCRGet(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderPartNCRModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nCRPost(version: string, body: CreateWorkOrderPartNCRRequest): Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/NCR";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNCRPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNCRPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel>;
        }));
    }

    protected processNCRPost(response: HttpResponseBase): Observable<AuditActionResultOfICollectionOfWorkOrderPartNCRModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfICollectionOfWorkOrderPartNCRModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nCRPatch(version: string, body: UpdateWorkOrderPartNCRRequest): Observable<AuditActionResultOfWorkOrderPartNCRModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/NCR";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNCRPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNCRPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderPartNCRModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderPartNCRModel>;
        }));
    }

    protected processNCRPatch(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderPartNCRModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderPartNCRModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send NCR email for a WorkOrderPart and log the event
     */
    sendEmail(version: string, body: SendWorkOrderPartNCREmailRequest): Observable<AuditActionResultOfBoolean> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPart/NCR/SendEmail";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfBoolean>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<AuditActionResultOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderPartMonitorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * Update a WorkOrderPartMonitor
     */
    workOrderPartMonitor(version: string, body: UpdateWorkOrderPartMonitorRequest): Observable<AuditActionResultOfWorkOrderPartMonitorModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderPartMonitor";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderPartMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderPartMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderPartMonitorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderPartMonitorModel>;
        }));
    }

    protected processWorkOrderPartMonitor(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderPartMonitorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderPartMonitorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderTaskService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    /**
     * WorkOrderTaskCreateWorkOrderTask
     */
    workOrderTaskPost(version: string, body: CreateWorkOrderTaskRequest): Observable<AuditActionResultOfWorkOrderTaskModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderTask";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderTaskPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderTaskPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderTaskModel>;
        }));
    }

    protected processWorkOrderTaskPost(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderTaskPatch(version: string, body: UpdateWorkOrderTaskRequest): Observable<AuditActionResultOfWorkOrderTaskModel> {
        let url_ = this.baseUrl + "/v{version}/WorkOrderTask";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderTaskPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderTaskPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfWorkOrderTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfWorkOrderTaskModel>;
        }));
    }

    protected processWorkOrderTaskPatch(response: HttpResponseBase): Observable<AuditActionResultOfWorkOrderTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfWorkOrderTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class XmlService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://qa-api.answer5.msr-fsr.com";
    }

    transmit(version: string, request: XmlTransmissionRequest): Observable<AuditActionResultOfString> {
        let url_ = this.baseUrl + "/v{version}/Xml/Transmit";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfString>;
        }));
    }

    protected processTransmit(response: HttpResponseBase): Observable<AuditActionResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(id: number, version: string): Observable<AuditActionResultOfFileModel> {
        let url_ = this.baseUrl + "/v{version}/Xml/DownloadFile/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditActionResultOfFileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditActionResultOfFileModel>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<AuditActionResultOfFileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditActionResultOfFileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Base class for an API call with a non-typed result */
export class AuditActionResult implements IAuditActionResult {
    /** Gets or Sets SuccessMessage */
    successMessage?: string | undefined;
    /** Gets or Sets ErrorMessages */
    errorMessages?: ErrorMessage[] | undefined;
    /** Gets or Sets Id */
    id?: number;
    term?: string | undefined;
    pageNumber?: number | undefined;
    totalNumberOfRecords?: number | undefined;
    pageSize?: number | undefined;
    sortAscending?: boolean | undefined;
    /** True if any error messages exist */
    hasErrors?: boolean;
    /** True if any validation error messages exist */
    hasValidationErrors?: boolean;

    constructor(data?: IAuditActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successMessage = _data["successMessage"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(ErrorMessage.fromJS(item));
            }
            this.id = _data["id"];
            this.term = _data["term"];
            this.pageNumber = _data["pageNumber"];
            this.totalNumberOfRecords = _data["totalNumberOfRecords"];
            this.pageSize = _data["pageSize"];
            this.sortAscending = _data["sortAscending"];
            this.hasErrors = _data["hasErrors"];
            this.hasValidationErrors = _data["hasValidationErrors"];
        }
    }

    static fromJS(data: any): AuditActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successMessage"] = this.successMessage;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["term"] = this.term;
        data["pageNumber"] = this.pageNumber;
        data["totalNumberOfRecords"] = this.totalNumberOfRecords;
        data["pageSize"] = this.pageSize;
        data["sortAscending"] = this.sortAscending;
        data["hasErrors"] = this.hasErrors;
        data["hasValidationErrors"] = this.hasValidationErrors;
        return data;
    }
}

/** Base class for an API call with a non-typed result */
export interface IAuditActionResult {
    /** Gets or Sets SuccessMessage */
    successMessage?: string | undefined;
    /** Gets or Sets ErrorMessages */
    errorMessages?: ErrorMessage[] | undefined;
    /** Gets or Sets Id */
    id?: number;
    term?: string | undefined;
    pageNumber?: number | undefined;
    totalNumberOfRecords?: number | undefined;
    pageSize?: number | undefined;
    sortAscending?: boolean | undefined;
    /** True if any error messages exist */
    hasErrors?: boolean;
    /** True if any validation error messages exist */
    hasValidationErrors?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfString extends AuditActionResult implements IAuditActionResultOfString {
    object?: string | undefined;

    constructor(data?: IAuditActionResultOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"];
        }
    }

    static override fromJS(data: any): AuditActionResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfString extends IAuditActionResult {
    object?: string | undefined;
}

/**  */
export class ErrorMessage implements IErrorMessage {
    /** Gets or Sets Number */
    number?: number;
    /** Gets or Sets Message */
    message?: string | undefined;
    /** Gets or Sets IsValidationMessage */
    isValidationMessage?: boolean;
    exception?: any | undefined;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.message = _data["message"];
            this.isValidationMessage = _data["isValidationMessage"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["message"] = this.message;
        data["isValidationMessage"] = this.isValidationMessage;
        data["exception"] = this.exception;
        return data;
    }
}

/**  */
export interface IErrorMessage {
    /** Gets or Sets Number */
    number?: number;
    /** Gets or Sets Message */
    message?: string | undefined;
    /** Gets or Sets IsValidationMessage */
    isValidationMessage?: boolean;
    exception?: any | undefined;
}

export class SystemLoginRequest implements ISystemLoginRequest {
    /** User Name */
    userName!: string;
    /** Password */
    password!: string;
    accountId?: number;
    ipAddress?: string | undefined;

    constructor(data?: ISystemLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.accountId = _data["accountId"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): SystemLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["accountId"] = this.accountId;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface ISystemLoginRequest {
    /** User Name */
    userName: string;
    /** Password */
    password: string;
    accountId?: number;
    ipAddress?: string | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    userName!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data;
    }
}

export interface IForgotPasswordRequest {
    userName: string;
}

export class ForgotUserNameRequest implements IForgotUserNameRequest {
    email!: string;

    constructor(data?: IForgotUserNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotUserNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotUserNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotUserNameRequest {
    email: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    token!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordRequest {
    token: string;
    newPassword: string;
}

export class ResetMyPasswordRequest implements IResetMyPasswordRequest {
    newPassword!: string;
    oldPassword!: string;

    constructor(data?: IResetMyPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.oldPassword = _data["oldPassword"];
        }
    }

    static fromJS(data: any): ResetMyPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetMyPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["oldPassword"] = this.oldPassword;
        return data;
    }
}

export interface IResetMyPasswordRequest {
    newPassword: string;
    oldPassword: string;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfAdminCostSettingsModel extends AuditActionResult implements IAuditActionResultOfAdminCostSettingsModel {
    object?: AdminCostSettingsModel | undefined;

    constructor(data?: IAuditActionResultOfAdminCostSettingsModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? AdminCostSettingsModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfAdminCostSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfAdminCostSettingsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfAdminCostSettingsModel extends IAuditActionResult {
    object?: AdminCostSettingsModel | undefined;
}

export class AdminCostSettingsModel implements IAdminCostSettingsModel {
    rmAnnualRate?: number;
    laborRateMinute?: number;
    yearsHours?: number;
    hourMinutes?: number;

    constructor(data?: IAdminCostSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rmAnnualRate = _data["rmAnnualRate"];
            this.laborRateMinute = _data["laborRateMinute"];
            this.yearsHours = _data["yearsHours"];
            this.hourMinutes = _data["hourMinutes"];
        }
    }

    static fromJS(data: any): AdminCostSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCostSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rmAnnualRate"] = this.rmAnnualRate;
        data["laborRateMinute"] = this.laborRateMinute;
        data["yearsHours"] = this.yearsHours;
        data["hourMinutes"] = this.hourMinutes;
        return data;
    }
}

export interface IAdminCostSettingsModel {
    rmAnnualRate?: number;
    laborRateMinute?: number;
    yearsHours?: number;
    hourMinutes?: number;
}

export class UpdateAdminCostSettingRequest implements IUpdateAdminCostSettingRequest {
    rmAnnualRate?: number | undefined;
    laborRateMinute?: number | undefined;
    yearsHours?: number | undefined;
    hourMinutes?: number | undefined;

    constructor(data?: IUpdateAdminCostSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rmAnnualRate = _data["rmAnnualRate"];
            this.laborRateMinute = _data["laborRateMinute"];
            this.yearsHours = _data["yearsHours"];
            this.hourMinutes = _data["hourMinutes"];
        }
    }

    static fromJS(data: any): UpdateAdminCostSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdminCostSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rmAnnualRate"] = this.rmAnnualRate;
        data["laborRateMinute"] = this.laborRateMinute;
        data["yearsHours"] = this.yearsHours;
        data["hourMinutes"] = this.hourMinutes;
        return data;
    }
}

export interface IUpdateAdminCostSettingRequest {
    rmAnnualRate?: number | undefined;
    laborRateMinute?: number | undefined;
    yearsHours?: number | undefined;
    hourMinutes?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfAuditDetail extends AuditActionResult implements IAuditActionResultOfIEnumerableOfAuditDetail {
    object?: AuditDetail[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfAuditDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(AuditDetail.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfAuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfAuditDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfAuditDetail extends IAuditActionResult {
    object?: AuditDetail[] | undefined;
}

export class AuditDetail implements IAuditDetail {
    id?: number;
    module?: string | undefined;
    recordId?: string | undefined;
    action?: string | undefined;
    changes?: string | undefined;
    initiator?: string | undefined;
    eventDateTime?: Date;

    constructor(data?: IAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"];
            this.recordId = _data["recordId"];
            this.action = _data["action"];
            this.changes = _data["changes"];
            this.initiator = _data["initiator"];
            this.eventDateTime = _data["eventDateTime"] ? new Date(_data["eventDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module;
        data["recordId"] = this.recordId;
        data["action"] = this.action;
        data["changes"] = this.changes;
        data["initiator"] = this.initiator;
        data["eventDateTime"] = this.eventDateTime ? this.eventDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IAuditDetail {
    id?: number;
    module?: string | undefined;
    recordId?: string | undefined;
    action?: string | undefined;
    changes?: string | undefined;
    initiator?: string | undefined;
    eventDateTime?: Date;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfListOfCustomerContactModel extends AuditActionResult implements IAuditActionResultOfListOfCustomerContactModel {
    object?: CustomerContactModel[] | undefined;

    constructor(data?: IAuditActionResultOfListOfCustomerContactModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(CustomerContactModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfListOfCustomerContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfListOfCustomerContactModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfListOfCustomerContactModel extends IAuditActionResult {
    object?: CustomerContactModel[] | undefined;
}

export abstract class EntityModel implements IEntityModel {
    id?: number;

    constructor(data?: IEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityModel {
    id?: number;
}

export class CustomerContactModel extends EntityModel implements ICustomerContactModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ICustomerContactModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static override fromJS(data: any): CustomerContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerContactModel extends IEntityModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export class CreatableModel extends EntityModel implements ICreatableModel {
    createdOn?: Date;
    createdBy?: number | undefined;
    created?: UserModel | undefined;

    constructor(data?: ICreatableModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? UserModel.fromJS(_data["created"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CreatableModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatableModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatableModel extends IEntityModel {
    createdOn?: Date;
    createdBy?: number | undefined;
    created?: UserModel | undefined;
}

export abstract class TrackableModel extends CreatableModel implements ITrackableModel {
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: number | undefined;
    lastUpdated?: UserModel | undefined;

    constructor(data?: ITrackableModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdated = _data["lastUpdated"] ? UserModel.fromJS(_data["lastUpdated"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TrackableModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TrackableModel' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITrackableModel extends ICreatableModel {
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: number | undefined;
    lastUpdated?: UserModel | undefined;
}

export class CustomerModel extends TrackableModel implements ICustomerModel {
    name?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    departmentCount?: number;
    contactCount?: number;
    documentCount?: number;
    partsCount?: number;
    customerContacts?: CustomerContactModel[] | undefined;
    customerDepartments?: CustomerDepartmentModel[] | undefined;

    constructor(data?: ICustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.departmentCount = _data["departmentCount"];
            this.contactCount = _data["contactCount"];
            this.documentCount = _data["documentCount"];
            this.partsCount = _data["partsCount"];
            if (Array.isArray(_data["customerContacts"])) {
                this.customerContacts = [] as any;
                for (let item of _data["customerContacts"])
                    this.customerContacts!.push(CustomerContactModel.fromJS(item));
            }
            if (Array.isArray(_data["customerDepartments"])) {
                this.customerDepartments = [] as any;
                for (let item of _data["customerDepartments"])
                    this.customerDepartments!.push(CustomerDepartmentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["departmentCount"] = this.departmentCount;
        data["contactCount"] = this.contactCount;
        data["documentCount"] = this.documentCount;
        data["partsCount"] = this.partsCount;
        if (Array.isArray(this.customerContacts)) {
            data["customerContacts"] = [];
            for (let item of this.customerContacts)
                data["customerContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerDepartments)) {
            data["customerDepartments"] = [];
            for (let item of this.customerDepartments)
                data["customerDepartments"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerModel extends ITrackableModel {
    name?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    departmentCount?: number;
    contactCount?: number;
    documentCount?: number;
    partsCount?: number;
    customerContacts?: CustomerContactModel[] | undefined;
    customerDepartments?: CustomerDepartmentModel[] | undefined;
}

export class CustomerDepartmentModel extends EntityModel implements ICustomerDepartmentModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICustomerDepartmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.name = _data["name"];
            this.shipToAddress = _data["shipToAddress"];
            this.billToAddress = _data["billToAddress"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): CustomerDepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDepartmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["name"] = this.name;
        data["shipToAddress"] = this.shipToAddress;
        data["billToAddress"] = this.billToAddress;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerDepartmentModel extends IEntityModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;
    isActive?: boolean;
}

export class UserModel implements IUserModel {
    id?: number;
    isActive?: boolean;
    userRoleId?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    securityStamp?: string | undefined;
    phone?: string | undefined;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    isAnswerUser?: boolean;
    customerId?: number;
    lockoutEndDateUtc?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    timeZoneId?: number;
    lastUpdatedOn?: Date;
    timeZone?: TimeZoneModel | undefined;
    lastUpdatedBy?: number | undefined;
    createdOn?: Date;
    createdBy?: number | undefined;
    roles?: Role[] | undefined;
    fileModel?: FileModel | undefined;
    temporaryPassword?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.userRoleId = _data["userRoleId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.securityStamp = _data["securityStamp"];
            this.phone = _data["phone"];
            this.supervisorId = _data["supervisorId"];
            this.supervisorName = _data["supervisorName"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.isAnswerUser = _data["isAnswerUser"];
            this.customerId = _data["customerId"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? new Date(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.timeZoneId = _data["timeZoneId"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"] ? TimeZoneModel.fromJS(_data["timeZone"]) : undefined as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            this.fileModel = _data["fileModel"] ? FileModel.fromJS(_data["fileModel"]) : undefined as any;
            this.temporaryPassword = _data["temporaryPassword"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["userRoleId"] = this.userRoleId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["email"] = this.email;
        data["securityStamp"] = this.securityStamp;
        data["phone"] = this.phone;
        data["supervisorId"] = this.supervisorId;
        data["supervisorName"] = this.supervisorName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["isAnswerUser"] = this.isAnswerUser;
        data["customerId"] = this.customerId;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["timeZoneId"] = this.timeZoneId;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : undefined as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["fileModel"] = this.fileModel ? this.fileModel.toJSON() : undefined as any;
        data["temporaryPassword"] = this.temporaryPassword;
        return data;
    }
}

export interface IUserModel {
    id?: number;
    isActive?: boolean;
    userRoleId?: string | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    securityStamp?: string | undefined;
    phone?: string | undefined;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    isAnswerUser?: boolean;
    customerId?: number;
    lockoutEndDateUtc?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    timeZoneId?: number;
    lastUpdatedOn?: Date;
    timeZone?: TimeZoneModel | undefined;
    lastUpdatedBy?: number | undefined;
    createdOn?: Date;
    createdBy?: number | undefined;
    roles?: Role[] | undefined;
    fileModel?: FileModel | undefined;
    temporaryPassword?: string | undefined;
}

export class TimeZoneModel implements ITimeZoneModel {
    id?: number;
    description?: string | undefined;
    offset?: number;
    number?: number;
    useDalightSavings?: number;

    constructor(data?: ITimeZoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.offset = _data["offset"];
            this.number = _data["number"];
            this.useDalightSavings = _data["useDalightSavings"];
        }
    }

    static fromJS(data: any): TimeZoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["offset"] = this.offset;
        data["number"] = this.number;
        data["useDalightSavings"] = this.useDalightSavings;
        return data;
    }
}

export interface ITimeZoneModel {
    id?: number;
    description?: string | undefined;
    offset?: number;
    number?: number;
    useDalightSavings?: number;
}

export class Role extends TrackableModel implements IRole {
    name?: string | undefined;
    isCertificationRole?: boolean | undefined;
    menus?: MenuItem[] | undefined;
    permissions?: Permission | undefined;
    inheritedPermissions?: Permission | undefined;
    parentRoles?: Role[] | undefined;
    hasAssignedUsers?: boolean;

    constructor(data?: IRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isCertificationRole = _data["isCertificationRole"];
            if (Array.isArray(_data["menus"])) {
                this.menus = [] as any;
                for (let item of _data["menus"])
                    this.menus!.push(MenuItem.fromJS(item));
            }
            this.permissions = _data["permissions"] ? Permission.fromJS(_data["permissions"]) : undefined as any;
            this.inheritedPermissions = _data["inheritedPermissions"] ? Permission.fromJS(_data["inheritedPermissions"]) : undefined as any;
            if (Array.isArray(_data["parentRoles"])) {
                this.parentRoles = [] as any;
                for (let item of _data["parentRoles"])
                    this.parentRoles!.push(Role.fromJS(item));
            }
            this.hasAssignedUsers = _data["hasAssignedUsers"];
        }
    }

    static override fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCertificationRole"] = this.isCertificationRole;
        if (Array.isArray(this.menus)) {
            data["menus"] = [];
            for (let item of this.menus)
                data["menus"].push(item ? item.toJSON() : undefined as any);
        }
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        data["inheritedPermissions"] = this.inheritedPermissions ? this.inheritedPermissions.toJSON() : undefined as any;
        if (Array.isArray(this.parentRoles)) {
            data["parentRoles"] = [];
            for (let item of this.parentRoles)
                data["parentRoles"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasAssignedUsers"] = this.hasAssignedUsers;
        super.toJSON(data);
        return data;
    }
}

export interface IRole extends ITrackableModel {
    name?: string | undefined;
    isCertificationRole?: boolean | undefined;
    menus?: MenuItem[] | undefined;
    permissions?: Permission | undefined;
    inheritedPermissions?: Permission | undefined;
    parentRoles?: Role[] | undefined;
    hasAssignedUsers?: boolean;
}

export class MenuItem implements IMenuItem {
    id?: number;
    url?: string | undefined;
    name?: string | undefined;
    info?: string | undefined;
    icon?: string | undefined;
    orderNumber?: number;
    menuGroup?: MenuGroup | undefined;
    permissions?: Permission | undefined;
    inheritedPermissions?: Permission | undefined;
    roles?: Role[] | undefined;
    enumMenuItem?: EnumMenuItem;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.name = _data["name"];
            this.info = _data["info"];
            this.icon = _data["icon"];
            this.orderNumber = _data["orderNumber"];
            this.menuGroup = _data["menuGroup"] ? MenuGroup.fromJS(_data["menuGroup"]) : undefined as any;
            this.permissions = _data["permissions"] ? Permission.fromJS(_data["permissions"]) : undefined as any;
            this.inheritedPermissions = _data["inheritedPermissions"] ? Permission.fromJS(_data["inheritedPermissions"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            this.enumMenuItem = _data["enumMenuItem"];
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["name"] = this.name;
        data["info"] = this.info;
        data["icon"] = this.icon;
        data["orderNumber"] = this.orderNumber;
        data["menuGroup"] = this.menuGroup ? this.menuGroup.toJSON() : undefined as any;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        data["inheritedPermissions"] = this.inheritedPermissions ? this.inheritedPermissions.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["enumMenuItem"] = this.enumMenuItem;
        return data;
    }
}

export interface IMenuItem {
    id?: number;
    url?: string | undefined;
    name?: string | undefined;
    info?: string | undefined;
    icon?: string | undefined;
    orderNumber?: number;
    menuGroup?: MenuGroup | undefined;
    permissions?: Permission | undefined;
    inheritedPermissions?: Permission | undefined;
    roles?: Role[] | undefined;
    enumMenuItem?: EnumMenuItem;
}

export class MenuGroup implements IMenuGroup {
    url?: string | undefined;
    name?: string | undefined;
    info?: string | undefined;
    icon?: string | undefined;
    orderNumber?: number;

    constructor(data?: IMenuGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.name = _data["name"];
            this.info = _data["info"];
            this.icon = _data["icon"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): MenuGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MenuGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["info"] = this.info;
        data["icon"] = this.icon;
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IMenuGroup {
    url?: string | undefined;
    name?: string | undefined;
    info?: string | undefined;
    icon?: string | undefined;
    orderNumber?: number;
}

export class Permission implements IPermission {
    canRead?: boolean;
    canCreate?: boolean;
    canEdit?: boolean;
    canActivate?: boolean;
    canApprove?: boolean;
    canDelete?: boolean;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canRead = _data["canRead"];
            this.canCreate = _data["canCreate"];
            this.canEdit = _data["canEdit"];
            this.canActivate = _data["canActivate"];
            this.canApprove = _data["canApprove"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canCreate"] = this.canCreate;
        data["canEdit"] = this.canEdit;
        data["canActivate"] = this.canActivate;
        data["canApprove"] = this.canApprove;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IPermission {
    canRead?: boolean;
    canCreate?: boolean;
    canEdit?: boolean;
    canActivate?: boolean;
    canApprove?: boolean;
    canDelete?: boolean;
}

export enum EnumMenuItem {
    AdminCostSettings = 0,
    Reserved3 = 1,
    Reserved4 = 2,
    Reserved5 = 3,
    Reserved2 = 4,
    Documents = 5,
    EquipmentMaintenance = 6,
    Financial = 7,
    FreeformQuote = 8,
    HelpPages = 9,
    Invoices = 10,
    Locations = 11,
    Monitors = 12,
    Operational = 13,
    Parts = 14,
    Reserved1 = 15,
    PendingApprovals = 16,
    ProcedureTypes = 17,
    PurchaseOrders = 18,
    Purchases = 19,
    Quotes = 20,
    Reports = 21,
    RoleModulePermission = 22,
    RunnableProcedures = 23,
    SupportTicket = 24,
    StepTemplates = 25,
    TrainingCertifications = 26,
    UserRoles = 27,
    Users = 28,
    WIPHistory = 29,
    WIPMenu = 30,
    WipStatus = 31,
    Roles = 32,
    WorkOrders = 33,
    WorkOrderParts = 34,
    WorkOrderTasks = 35,
    ProcedureStep = 36,
    CycleCountImport = 37,
    CycleCountUpdate = 38,
    Customers = 39,
    PartsLookups = 40,
    AuditDetails = 41,
}

export class FileModel implements IFileModel {
    fileId?: number | undefined;
    entityId?: number | undefined;
    name?: string | undefined;
    base64String?: string | undefined;
    fileContents?: string | undefined;
    contentType?: string | undefined;
    fileURL?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.base64String = _data["base64String"];
            this.fileContents = _data["fileContents"];
            this.contentType = _data["contentType"];
            this.fileURL = _data["fileURL"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["base64String"] = this.base64String;
        data["fileContents"] = this.fileContents;
        data["contentType"] = this.contentType;
        data["fileURL"] = this.fileURL;
        data["description"] = this.description;
        return data;
    }
}

export interface IFileModel {
    fileId?: number | undefined;
    entityId?: number | undefined;
    name?: string | undefined;
    base64String?: string | undefined;
    fileContents?: string | undefined;
    contentType?: string | undefined;
    fileURL?: string | undefined;
    description?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfCustomerContactModel extends AuditActionResult implements IAuditActionResultOfCustomerContactModel {
    object?: CustomerContactModel | undefined;

    constructor(data?: IAuditActionResultOfCustomerContactModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? CustomerContactModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfCustomerContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfCustomerContactModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfCustomerContactModel extends IAuditActionResult {
    object?: CustomerContactModel | undefined;
}

export class CreateCustomerContactRequest implements ICreateCustomerContactRequest {
    customerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ICreateCustomerContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): CreateCustomerContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ICreateCustomerContactRequest {
    customerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export class UpdateCustomerContactRequest implements IUpdateCustomerContactRequest {
    id!: number;
    customerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IUpdateCustomerContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UpdateCustomerContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IUpdateCustomerContactRequest {
    id: number;
    customerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfCustomerModel extends AuditActionResult implements IAuditActionResultOfIEnumerableOfCustomerModel {
    object?: CustomerModel[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfCustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(CustomerModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfCustomerModel extends IAuditActionResult {
    object?: CustomerModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfCustomerModel extends AuditActionResult implements IAuditActionResultOfCustomerModel {
    object?: CustomerModel | undefined;

    constructor(data?: IAuditActionResultOfCustomerModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? CustomerModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfCustomerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfCustomerModel extends IAuditActionResult {
    object?: CustomerModel | undefined;
}

export class CreateCustomerRequest implements ICreateCustomerRequest {
    name?: string | undefined;

    constructor(data?: ICreateCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCustomerRequest {
    name?: string | undefined;
}

export class UpdateCustomerRequest implements IUpdateCustomerRequest {
    name?: string | undefined;
    customerId!: number;
    isActive?: boolean | undefined;

    constructor(data?: IUpdateCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateCustomerRequest {
    name?: string | undefined;
    customerId: number;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfListOfCustomerDepartmentModel extends AuditActionResult implements IAuditActionResultOfListOfCustomerDepartmentModel {
    object?: CustomerDepartmentModel[] | undefined;

    constructor(data?: IAuditActionResultOfListOfCustomerDepartmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(CustomerDepartmentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfListOfCustomerDepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfListOfCustomerDepartmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfListOfCustomerDepartmentModel extends IAuditActionResult {
    object?: CustomerDepartmentModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfCustomerDepartmentModel extends AuditActionResult implements IAuditActionResultOfCustomerDepartmentModel {
    object?: CustomerDepartmentModel | undefined;

    constructor(data?: IAuditActionResultOfCustomerDepartmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? CustomerDepartmentModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfCustomerDepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfCustomerDepartmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfCustomerDepartmentModel extends IAuditActionResult {
    object?: CustomerDepartmentModel | undefined;
}

export class CreateCustomerDepartmentRequest implements ICreateCustomerDepartmentRequest {
    customerId?: number;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;

    constructor(data?: ICreateCustomerDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.shipToAddress = _data["shipToAddress"];
            this.billToAddress = _data["billToAddress"];
        }
    }

    static fromJS(data: any): CreateCustomerDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["shipToAddress"] = this.shipToAddress;
        data["billToAddress"] = this.billToAddress;
        return data;
    }
}

export interface ICreateCustomerDepartmentRequest {
    customerId?: number;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;
}

export class UpdateCustomerDepartmentRequest implements IUpdateCustomerDepartmentRequest {
    id!: number;
    customerId?: number;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;

    constructor(data?: IUpdateCustomerDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.shipToAddress = _data["shipToAddress"];
            this.billToAddress = _data["billToAddress"];
        }
    }

    static fromJS(data: any): UpdateCustomerDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["shipToAddress"] = this.shipToAddress;
        data["billToAddress"] = this.billToAddress;
        return data;
    }
}

export interface IUpdateCustomerDepartmentRequest {
    id: number;
    customerId?: number;
    name?: string | undefined;
    shipToAddress?: string | undefined;
    billToAddress?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfListOfCustomerDocumentModel extends AuditActionResult implements IAuditActionResultOfListOfCustomerDocumentModel {
    object?: CustomerDocumentModel[] | undefined;

    constructor(data?: IAuditActionResultOfListOfCustomerDocumentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(CustomerDocumentModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfListOfCustomerDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfListOfCustomerDocumentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfListOfCustomerDocumentModel extends IAuditActionResult {
    object?: CustomerDocumentModel[] | undefined;
}

export class CustomerDocumentModel extends EntityModel implements ICustomerDocumentModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    oem?: PartOEMModel | undefined;
    isActive?: boolean;
    files?: FileModel[] | undefined;

    constructor(data?: ICustomerDocumentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.name = _data["name"];
            this.classification = _data["classification"];
            this.oemId = _data["oemId"];
            this.oem = _data["oem"] ? PartOEMModel.fromJS(_data["oem"]) : undefined as any;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CustomerDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDocumentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["name"] = this.name;
        data["classification"] = this.classification;
        data["oemId"] = this.oemId;
        data["oem"] = this.oem ? this.oem.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerDocumentModel extends IEntityModel {
    customerId?: number;
    customer?: CustomerModel | undefined;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    oem?: PartOEMModel | undefined;
    isActive?: boolean;
    files?: FileModel[] | undefined;
}

export abstract class PartLookupModelBase extends EntityModel implements IPartLookupModelBase {
    name?: string | undefined;
    isActive?: boolean;
    usageCount?: number;

    constructor(data?: IPartLookupModelBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.usageCount = _data["usageCount"];
        }
    }

    static override fromJS(data: any): PartLookupModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PartLookupModelBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["usageCount"] = this.usageCount;
        super.toJSON(data);
        return data;
    }
}

export interface IPartLookupModelBase extends IEntityModel {
    name?: string | undefined;
    isActive?: boolean;
    usageCount?: number;
}

export class PartOEMModel extends PartLookupModelBase implements IPartOEMModel {

    constructor(data?: IPartOEMModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartOEMModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartOEMModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartOEMModel extends IPartLookupModelBase {
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfCustomerDocumentModel extends AuditActionResult implements IAuditActionResultOfCustomerDocumentModel {
    object?: CustomerDocumentModel | undefined;

    constructor(data?: IAuditActionResultOfCustomerDocumentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? CustomerDocumentModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfCustomerDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfCustomerDocumentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfCustomerDocumentModel extends IAuditActionResult {
    object?: CustomerDocumentModel | undefined;
}

export class CreateCustomerDocumentRequest implements ICreateCustomerDocumentRequest {
    customerId?: number;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;

    constructor(data?: ICreateCustomerDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.classification = _data["classification"];
            this.oemId = _data["oemId"];
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCustomerDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["classification"] = this.classification;
        data["oemId"] = this.oemId;
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateCustomerDocumentRequest {
    customerId?: number;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;
}

export class UpdateCustomerDocumentRequest implements IUpdateCustomerDocumentRequest {
    id!: number;
    customerId?: number;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;

    constructor(data?: IUpdateCustomerDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.classification = _data["classification"];
            this.oemId = _data["oemId"];
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomerDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["classification"] = this.classification;
        data["oemId"] = this.oemId;
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateCustomerDocumentRequest {
    id: number;
    customerId?: number;
    name?: string | undefined;
    classification?: string | undefined;
    oemId?: number | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfDocumentView extends AuditActionResult implements IAuditActionResultOfICollectionOfDocumentView {
    object?: DocumentView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfDocumentView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(DocumentView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfDocumentView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfDocumentView extends IAuditActionResult {
    object?: DocumentView[] | undefined;
}

export class DocumentView extends TrackableModel implements IDocumentView {
    name?: string | undefined;
    revision?: number;
    comments?: string | undefined;
    roleIds?: number[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    referenceFileIds?: number[] | undefined;

    constructor(data?: IDocumentView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): DocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["comments"] = this.comments;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentView extends ITrackableModel {
    name?: string | undefined;
    revision?: number;
    comments?: string | undefined;
    roleIds?: number[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    referenceFileIds?: number[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfDocumentView extends AuditActionResult implements IAuditActionResultOfDocumentView {
    object?: DocumentView | undefined;

    constructor(data?: IAuditActionResultOfDocumentView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? DocumentView.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfDocumentView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfDocumentView extends IAuditActionResult {
    object?: DocumentView | undefined;
}

export class CreateDocumentRequest implements ICreateDocumentRequest {
    name!: string;
    revision!: number;
    comments?: string | undefined;
    roleIds?: (number | undefined)[] | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;

    constructor(data?: ICreateDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["comments"] = this.comments;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateDocumentRequest {
    name: string;
    revision: number;
    comments?: string | undefined;
    roleIds?: (number | undefined)[] | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: FileModel[] | undefined;
}

export class UpdateDocumentRequest implements IUpdateDocumentRequest {
    id!: number;
    name!: string;
    revision!: number;
    comments?: string | undefined;
    roleIds?: (number | undefined)[] | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: (FileModel | undefined)[] | undefined;

    constructor(data?: IUpdateDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["comments"] = this.comments;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateDocumentRequest {
    id: number;
    name: string;
    revision: number;
    comments?: string | undefined;
    roleIds?: (number | undefined)[] | undefined;
    referenceFileIds?: (number | undefined)[] | undefined;
    referenceFiles?: (FileModel | undefined)[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfArchiveDocumentView extends AuditActionResult implements IAuditActionResultOfICollectionOfArchiveDocumentView {
    object?: ArchiveDocumentView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfArchiveDocumentView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ArchiveDocumentView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfArchiveDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfArchiveDocumentView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfArchiveDocumentView extends IAuditActionResult {
    object?: ArchiveDocumentView[] | undefined;
}

export class ArchiveDocumentView implements IArchiveDocumentView {
    fileName?: string | undefined;
    downloadURL?: string | undefined;
    fileSize?: number;
    createDate?: Date;

    constructor(data?: IArchiveDocumentView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.downloadURL = _data["downloadURL"];
            this.fileSize = _data["fileSize"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArchiveDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveDocumentView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["downloadURL"] = this.downloadURL;
        data["fileSize"] = this.fileSize;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IArchiveDocumentView {
    fileName?: string | undefined;
    downloadURL?: string | undefined;
    fileSize?: number;
    createDate?: Date;
}

export enum EnumAwsFolders {
    Combinedfinancialdata = 0,
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel extends AuditActionResult implements IAuditActionResultOfIEnumerableOfEquipmentMaintenanceModel {
    object?: EquipmentMaintenanceModel[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfEquipmentMaintenanceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(EquipmentMaintenanceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfEquipmentMaintenanceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfEquipmentMaintenanceModel extends IAuditActionResult {
    object?: EquipmentMaintenanceModel[] | undefined;
}

export class EquipmentMaintenanceModel extends TrackableModel implements IEquipmentMaintenanceModel {
    locationId?: number;
    assignedToId?: number | undefined;
    troubleState?: boolean | undefined;
    maintenanceTask?: string | undefined;
    statusId?: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;
    location?: LocationModel | undefined;
    assignedTo?: UserModel | undefined;
    status?: StatusModel | undefined;

    constructor(data?: IEquipmentMaintenanceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationId = _data["locationId"];
            this.assignedToId = _data["assignedToId"];
            this.troubleState = _data["troubleState"];
            this.maintenanceTask = _data["maintenanceTask"];
            this.statusId = _data["statusId"];
            this.pemLastCompletedDate = _data["pemLastCompletedDate"] ? new Date(_data["pemLastCompletedDate"].toString()) : undefined as any;
            this.frequencyField = _data["frequencyField"];
            this.comments = _data["comments"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
            this.assignedTo = _data["assignedTo"] ? UserModel.fromJS(_data["assignedTo"]) : undefined as any;
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : undefined as any;
        }
    }

    static override fromJS(data: any): EquipmentMaintenanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentMaintenanceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["assignedToId"] = this.assignedToId;
        data["troubleState"] = this.troubleState;
        data["maintenanceTask"] = this.maintenanceTask;
        data["statusId"] = this.statusId;
        data["pemLastCompletedDate"] = this.pemLastCompletedDate ? this.pemLastCompletedDate.toISOString() : undefined as any;
        data["frequencyField"] = this.frequencyField;
        data["comments"] = this.comments;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEquipmentMaintenanceModel extends ITrackableModel {
    locationId?: number;
    assignedToId?: number | undefined;
    troubleState?: boolean | undefined;
    maintenanceTask?: string | undefined;
    statusId?: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;
    location?: LocationModel | undefined;
    assignedTo?: UserModel | undefined;
    status?: StatusModel | undefined;
}

export class DeletableModel extends TrackableModel implements IDeletableModel {
    isActive?: boolean;

    constructor(data?: IDeletableModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): DeletableModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletableModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IDeletableModel extends ITrackableModel {
    isActive?: boolean;
}

export class LocationModel extends DeletableModel implements ILocationModel {
    oldId?: number;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    emailAddress?: string | undefined;
    parentId?: number | undefined;
    parent?: LocationModel | undefined;
    internalAddress?: string | undefined;
    invoiceClass?: string | undefined;
    timeZone?: TimeZoneModel | undefined;
    status?: string | undefined;
    site?: number | undefined;
    isInUse?: boolean;

    constructor(data?: ILocationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldId = _data["oldId"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.emailAddress = _data["emailAddress"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? LocationModel.fromJS(_data["parent"]) : undefined as any;
            this.internalAddress = _data["internalAddress"];
            this.invoiceClass = _data["invoiceClass"];
            this.timeZone = _data["timeZone"] ? TimeZoneModel.fromJS(_data["timeZone"]) : undefined as any;
            this.status = _data["status"];
            this.site = _data["site"];
            this.isInUse = _data["isInUse"];
        }
    }

    static override fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldId"] = this.oldId;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["internalAddress"] = this.internalAddress;
        data["invoiceClass"] = this.invoiceClass;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : undefined as any;
        data["status"] = this.status;
        data["site"] = this.site;
        data["isInUse"] = this.isInUse;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationModel extends IDeletableModel {
    oldId?: number;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    emailAddress?: string | undefined;
    parentId?: number | undefined;
    parent?: LocationModel | undefined;
    internalAddress?: string | undefined;
    invoiceClass?: string | undefined;
    timeZone?: TimeZoneModel | undefined;
    status?: string | undefined;
    site?: number | undefined;
    isInUse?: boolean;
}

export class StatusModel implements IStatusModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStatusModel {
    id?: number;
    name?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfEquipmentMaintenanceModel extends AuditActionResult implements IAuditActionResultOfEquipmentMaintenanceModel {
    object?: EquipmentMaintenanceModel | undefined;

    constructor(data?: IAuditActionResultOfEquipmentMaintenanceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? EquipmentMaintenanceModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfEquipmentMaintenanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfEquipmentMaintenanceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfEquipmentMaintenanceModel extends IAuditActionResult {
    object?: EquipmentMaintenanceModel | undefined;
}

export class CreateEquipmentMaintenanceRequest implements ICreateEquipmentMaintenanceRequest {
    locationId!: number;
    assignedToId?: number | undefined;
    troubleState!: boolean;
    maintenanceTask?: string | undefined;
    statusId!: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateEquipmentMaintenanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.assignedToId = _data["assignedToId"];
            this.troubleState = _data["troubleState"];
            this.maintenanceTask = _data["maintenanceTask"];
            this.statusId = _data["statusId"];
            this.pemLastCompletedDate = _data["pemLastCompletedDate"] ? new Date(_data["pemLastCompletedDate"].toString()) : undefined as any;
            this.frequencyField = _data["frequencyField"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateEquipmentMaintenanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEquipmentMaintenanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["assignedToId"] = this.assignedToId;
        data["troubleState"] = this.troubleState;
        data["maintenanceTask"] = this.maintenanceTask;
        data["statusId"] = this.statusId;
        data["pemLastCompletedDate"] = this.pemLastCompletedDate ? this.pemLastCompletedDate.toISOString() : undefined as any;
        data["frequencyField"] = this.frequencyField;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateEquipmentMaintenanceRequest {
    locationId: number;
    assignedToId?: number | undefined;
    troubleState: boolean;
    maintenanceTask?: string | undefined;
    statusId: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;
}

export class UpdateEquipmentMaintenanceRequest implements IUpdateEquipmentMaintenanceRequest {
    id!: number;
    locationId!: number;
    assignedToId?: number | undefined;
    troubleState!: boolean;
    maintenanceTask?: string | undefined;
    statusId!: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IUpdateEquipmentMaintenanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.assignedToId = _data["assignedToId"];
            this.troubleState = _data["troubleState"];
            this.maintenanceTask = _data["maintenanceTask"];
            this.statusId = _data["statusId"];
            this.pemLastCompletedDate = _data["pemLastCompletedDate"] ? new Date(_data["pemLastCompletedDate"].toString()) : undefined as any;
            this.frequencyField = _data["frequencyField"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UpdateEquipmentMaintenanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEquipmentMaintenanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["assignedToId"] = this.assignedToId;
        data["troubleState"] = this.troubleState;
        data["maintenanceTask"] = this.maintenanceTask;
        data["statusId"] = this.statusId;
        data["pemLastCompletedDate"] = this.pemLastCompletedDate ? this.pemLastCompletedDate.toISOString() : undefined as any;
        data["frequencyField"] = this.frequencyField;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IUpdateEquipmentMaintenanceRequest {
    id: number;
    locationId: number;
    assignedToId?: number | undefined;
    troubleState: boolean;
    maintenanceTask?: string | undefined;
    statusId: number;
    pemLastCompletedDate?: Date | undefined;
    frequencyField?: number | undefined;
    comments?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfFacilityModel extends AuditActionResult implements IAuditActionResultOfICollectionOfFacilityModel {
    object?: FacilityModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfFacilityModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(FacilityModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfFacilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfFacilityModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfFacilityModel extends IAuditActionResult {
    object?: FacilityModel[] | undefined;
}

export class FacilityModel implements IFacilityModel {
    locationId?: number;
    name?: string | undefined;
    isActive?: boolean;
    parentId?: number | undefined;

    constructor(data?: IFacilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FacilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFacilityModel {
    locationId?: number;
    name?: string | undefined;
    isActive?: boolean;
    parentId?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfFileModel extends AuditActionResult implements IAuditActionResultOfICollectionOfFileModel {
    object?: FileModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(FileModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfFileModel extends IAuditActionResult {
    object?: FileModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfFileModel extends AuditActionResult implements IAuditActionResultOfFileModel {
    object?: FileModel | undefined;

    constructor(data?: IAuditActionResultOfFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? FileModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfFileModel extends IAuditActionResult {
    object?: FileModel | undefined;
}

export class CreateFileRequest implements ICreateFileRequest {
    entityName!: string;
    entityId!: number;
    name!: string;
    base64String!: string;
    contentType!: string;
    description?: string | undefined;

    constructor(data?: ICreateFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.base64String = _data["base64String"];
            this.contentType = _data["contentType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["base64String"] = this.base64String;
        data["contentType"] = this.contentType;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateFileRequest {
    entityName: string;
    entityId: number;
    name: string;
    base64String: string;
    contentType: string;
    description?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfImportError extends AuditActionResult implements IAuditActionResultOfIEnumerableOfImportError {
    object?: ImportError[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfImportError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ImportError.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfImportError {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfImportError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfImportError extends IAuditActionResult {
    object?: ImportError[] | undefined;
}

export class ImportAuditActionResultOfIEnumerableOfImportError extends AuditActionResultOfIEnumerableOfImportError implements IImportAuditActionResultOfIEnumerableOfImportError {
    importErrors?: ImportError[] | undefined;

    constructor(data?: IImportAuditActionResultOfIEnumerableOfImportError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["importErrors"])) {
                this.importErrors = [] as any;
                for (let item of _data["importErrors"])
                    this.importErrors!.push(ImportError.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ImportAuditActionResultOfIEnumerableOfImportError {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAuditActionResultOfIEnumerableOfImportError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importErrors)) {
            data["importErrors"] = [];
            for (let item of this.importErrors)
                data["importErrors"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IImportAuditActionResultOfIEnumerableOfImportError extends IAuditActionResultOfIEnumerableOfImportError {
    importErrors?: ImportError[] | undefined;
}

export class ImportError implements IImportError {
    line?: number;
    errors?: string[] | undefined;

    constructor(data?: IImportError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportError {
        data = typeof data === 'object' ? data : {};
        let result = new ImportError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IImportError {
    line?: number;
    errors?: string[] | undefined;
}

export class ImportRequest implements IImportRequest {
    base64Data!: string;
    menuItem!: EnumMenuItem;

    constructor(data?: IImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64Data = _data["base64Data"];
            this.menuItem = _data["menuItem"];
        }
    }

    static fromJS(data: any): ImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64Data"] = this.base64Data;
        data["menuItem"] = this.menuItem;
        return data;
    }
}

export interface IImportRequest {
    base64Data: string;
    menuItem: EnumMenuItem;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfInteger extends AuditActionResult implements IAuditActionResultOfInteger {
    object?: number;

    constructor(data?: IAuditActionResultOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"];
        }
    }

    static override fromJS(data: any): AuditActionResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfInteger extends IAuditActionResult {
    object?: number;
}

export class ProcessImportRequest implements IProcessImportRequest {
    menuItem?: EnumMenuItem;
    data?: string | undefined;

    constructor(data?: IProcessImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuItem = _data["menuItem"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ProcessImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItem"] = this.menuItem;
        data["data"] = this.data;
        return data;
    }
}

export interface IProcessImportRequest {
    menuItem?: EnumMenuItem;
    data?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPurchaseHierarchyFileModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPurchaseHierarchyFileModel {
    object?: PurchaseHierarchyFileModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPurchaseHierarchyFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PurchaseHierarchyFileModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPurchaseHierarchyFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPurchaseHierarchyFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPurchaseHierarchyFileModel extends IAuditActionResult {
    object?: PurchaseHierarchyFileModel[] | undefined;
}

export class PurchaseHierarchyFileModel extends FileModel implements IPurchaseHierarchyFileModel {
    sourceEntity?: string | undefined;
    sourceEntityId?: number;
    sourceLabel?: string | undefined;

    constructor(data?: IPurchaseHierarchyFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceEntity = _data["sourceEntity"];
            this.sourceEntityId = _data["sourceEntityId"];
            this.sourceLabel = _data["sourceLabel"];
        }
    }

    static override fromJS(data: any): PurchaseHierarchyFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseHierarchyFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEntity"] = this.sourceEntity;
        data["sourceEntityId"] = this.sourceEntityId;
        data["sourceLabel"] = this.sourceLabel;
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseHierarchyFileModel extends IFileModel {
    sourceEntity?: string | undefined;
    sourceEntityId?: number;
    sourceLabel?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfHelpPage extends AuditActionResult implements IAuditActionResultOfIEnumerableOfHelpPage {
    object?: HelpPage[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfHelpPage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(HelpPage.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfHelpPage {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfHelpPage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfHelpPage extends IAuditActionResult {
    object?: HelpPage[] | undefined;
}

export class HelpPage implements IHelpPage {
    id?: number;
    title?: string | undefined;
    friendlyURL?: string | undefined;
    content?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: IHelpPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.friendlyURL = _data["friendlyURL"];
            this.content = _data["content"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HelpPage {
        data = typeof data === 'object' ? data : {};
        let result = new HelpPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["friendlyURL"] = this.friendlyURL;
        data["content"] = this.content;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHelpPage {
    id?: number;
    title?: string | undefined;
    friendlyURL?: string | undefined;
    content?: string | undefined;
    roles?: Role[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfHelpPage extends AuditActionResult implements IAuditActionResultOfHelpPage {
    object?: HelpPage | undefined;

    constructor(data?: IAuditActionResultOfHelpPage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? HelpPage.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfHelpPage {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfHelpPage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfHelpPage extends IAuditActionResult {
    object?: HelpPage | undefined;
}

export class CreateHelpPageRequest implements ICreateHelpPageRequest {
    title?: string | undefined;
    friendlyURL?: string | undefined;
    helpContent?: string | undefined;
    roleIds?: number[] | undefined;

    constructor(data?: ICreateHelpPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.friendlyURL = _data["friendlyURL"];
            this.helpContent = _data["helpContent"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateHelpPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHelpPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["friendlyURL"] = this.friendlyURL;
        data["helpContent"] = this.helpContent;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface ICreateHelpPageRequest {
    title?: string | undefined;
    friendlyURL?: string | undefined;
    helpContent?: string | undefined;
    roleIds?: number[] | undefined;
}

export class CreateHelpPageRoleRequest implements ICreateHelpPageRoleRequest {
    helpPageId?: number;
    roleId?: number;

    constructor(data?: ICreateHelpPageRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpPageId = _data["helpPageId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateHelpPageRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHelpPageRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpPageId"] = this.helpPageId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateHelpPageRoleRequest {
    helpPageId?: number;
    roleId?: number;
}

export class UpdateHelpPageRequest implements IUpdateHelpPageRequest {
    helpPageId?: number;
    title?: string | undefined;
    friendlyURL?: string | undefined;
    helpContent?: string | undefined;
    roleIds?: number[] | undefined;

    constructor(data?: IUpdateHelpPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpPageId = _data["helpPageId"];
            this.title = _data["title"];
            this.friendlyURL = _data["friendlyURL"];
            this.helpContent = _data["helpContent"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateHelpPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHelpPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpPageId"] = this.helpPageId;
        data["title"] = this.title;
        data["friendlyURL"] = this.friendlyURL;
        data["helpContent"] = this.helpContent;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateHelpPageRequest {
    helpPageId?: number;
    title?: string | undefined;
    friendlyURL?: string | undefined;
    helpContent?: string | undefined;
    roleIds?: number[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfInvoiceView extends AuditActionResult implements IAuditActionResultOfIEnumerableOfInvoiceView {
    object?: InvoiceView[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfInvoiceView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(InvoiceView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfInvoiceView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfInvoiceView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfInvoiceView extends IAuditActionResult {
    object?: InvoiceView[] | undefined;
}

export class InvoiceView implements IInvoiceView {
    id?: number;
    customerId?: number;
    customerName?: string | undefined;
    description?: string | undefined;
    invoiceNumber?: string | undefined;
    amount?: number;
    taxPercentage?: number;
    dueDate?: Date;
    createdOn?: Date;
    createdByName?: string | undefined;
    lastUpdatedOn?: Date;
    lastUpdatedByName?: string | undefined;
    statusId?: number;
    locationId?: number;
    invoiceItems?: InvoiceItemView[] | undefined;

    constructor(data?: IInvoiceView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.description = _data["description"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.amount = _data["amount"];
            this.taxPercentage = _data["taxPercentage"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdByName = _data["createdByName"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            this.lastUpdatedByName = _data["lastUpdatedByName"];
            this.statusId = _data["statusId"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceView {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["description"] = this.description;
        data["invoiceNumber"] = this.invoiceNumber;
        data["amount"] = this.amount;
        data["taxPercentage"] = this.taxPercentage;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdByName"] = this.createdByName;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        data["lastUpdatedByName"] = this.lastUpdatedByName;
        data["statusId"] = this.statusId;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceView {
    id?: number;
    customerId?: number;
    customerName?: string | undefined;
    description?: string | undefined;
    invoiceNumber?: string | undefined;
    amount?: number;
    taxPercentage?: number;
    dueDate?: Date;
    createdOn?: Date;
    createdByName?: string | undefined;
    lastUpdatedOn?: Date;
    lastUpdatedByName?: string | undefined;
    statusId?: number;
    locationId?: number;
    invoiceItems?: InvoiceItemView[] | undefined;
}

export class InvoiceItemView implements IInvoiceItemView {
    id?: number;
    purchaseOrderId?: number;
    purchaseNumber?: string | undefined;
    workOrderId?: number | undefined;
    purchaseId?: number | undefined;

    constructor(data?: IInvoiceItemView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseNumber = _data["purchaseNumber"];
            this.workOrderId = _data["workOrderId"];
            this.purchaseId = _data["purchaseId"];
        }
    }

    static fromJS(data: any): InvoiceItemView {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseNumber"] = this.purchaseNumber;
        data["workOrderId"] = this.workOrderId;
        data["purchaseId"] = this.purchaseId;
        return data;
    }
}

export interface IInvoiceItemView {
    id?: number;
    purchaseOrderId?: number;
    purchaseNumber?: string | undefined;
    workOrderId?: number | undefined;
    purchaseId?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfInvoiceView extends AuditActionResult implements IAuditActionResultOfInvoiceView {
    object?: InvoiceView | undefined;

    constructor(data?: IAuditActionResultOfInvoiceView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? InvoiceView.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfInvoiceView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfInvoiceView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfInvoiceView extends IAuditActionResult {
    object?: InvoiceView | undefined;
}

export class CreateInvoiceRequest implements ICreateInvoiceRequest {
    customerId!: number;
    description!: string;
    invoiceDate!: Date;
    invoiceClass!: string;
    taxPercentage?: number | undefined;
    invoiceItems!: CreateInvoiceItemRequest[];

    constructor(data?: ICreateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.invoiceItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.description = _data["description"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceClass = _data["invoiceClass"];
            this.taxPercentage = _data["taxPercentage"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(CreateInvoiceItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["description"] = this.description;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceClass"] = this.invoiceClass;
        data["taxPercentage"] = this.taxPercentage;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateInvoiceRequest {
    customerId: number;
    description: string;
    invoiceDate: Date;
    invoiceClass: string;
    taxPercentage?: number | undefined;
    invoiceItems: CreateInvoiceItemRequest[];
}

export class CreateInvoiceItemRequest implements ICreateInvoiceItemRequest {
    workOrderId?: number | undefined;
    purchaseOrderId!: number;
    purchaseId?: number | undefined;

    constructor(data?: ICreateInvoiceItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseId = _data["purchaseId"];
        }
    }

    static fromJS(data: any): CreateInvoiceItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseId"] = this.purchaseId;
        return data;
    }
}

export interface ICreateInvoiceItemRequest {
    workOrderId?: number | undefined;
    purchaseOrderId: number;
    purchaseId?: number | undefined;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    /**   */
    id!: number;
    /**   */
    description?: string | undefined;
    /**   */
    invoiceDate?: Date;
    /**   */
    taxPercentage?: number | undefined;
    /**   */
    invoiceItems?: UpdateInvoiceItemRequest[] | undefined;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.taxPercentage = _data["taxPercentage"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(UpdateInvoiceItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["taxPercentage"] = this.taxPercentage;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    /**   */
    id: number;
    /**   */
    description?: string | undefined;
    /**   */
    invoiceDate?: Date;
    /**   */
    taxPercentage?: number | undefined;
    /**   */
    invoiceItems?: UpdateInvoiceItemRequest[] | undefined;
}

export class UpdateInvoiceItemRequest implements IUpdateInvoiceItemRequest {
    id?: number | undefined;
    workOrderId?: number | undefined;
    purchaseOrderId?: number | undefined;
    purchaseId?: number | undefined;

    constructor(data?: IUpdateInvoiceItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseId = _data["purchaseId"];
        }
    }

    static fromJS(data: any): UpdateInvoiceItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseId"] = this.purchaseId;
        return data;
    }
}

export interface IUpdateInvoiceItemRequest {
    id?: number | undefined;
    workOrderId?: number | undefined;
    purchaseOrderId?: number | undefined;
    purchaseId?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfLocationModel extends AuditActionResult implements IAuditActionResultOfICollectionOfLocationModel {
    object?: LocationModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfLocationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(LocationModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfLocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfLocationModel extends IAuditActionResult {
    object?: LocationModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfSensorModel extends AuditActionResult implements IAuditActionResultOfIEnumerableOfSensorModel {
    object?: SensorModel[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfSensorModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(SensorModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfSensorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfSensorModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfSensorModel extends IAuditActionResult {
    object?: SensorModel[] | undefined;
}

export class SensorModel extends CreatableModel implements ISensorModel {
    sensorName?: string | undefined;
    site?: LocationModel | undefined;
    assignedLocation?: LocationModel | undefined;

    constructor(data?: ISensorModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sensorName = _data["sensorName"];
            this.site = _data["site"] ? LocationModel.fromJS(_data["site"]) : undefined as any;
            this.assignedLocation = _data["assignedLocation"] ? LocationModel.fromJS(_data["assignedLocation"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SensorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensorName"] = this.sensorName;
        data["site"] = this.site ? this.site.toJSON() : undefined as any;
        data["assignedLocation"] = this.assignedLocation ? this.assignedLocation.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISensorModel extends ICreatableModel {
    sensorName?: string | undefined;
    site?: LocationModel | undefined;
    assignedLocation?: LocationModel | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfLocationModel extends AuditActionResult implements IAuditActionResultOfLocationModel {
    object?: LocationModel | undefined;

    constructor(data?: IAuditActionResultOfLocationModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? LocationModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfLocationModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfLocationModel extends IAuditActionResult {
    object?: LocationModel | undefined;
}

export class CreateLocationRequest implements ICreateLocationRequest {
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    emailAddress?: string | undefined;
    parentId?: number | undefined;
    internalAddress?: string | undefined;
    invoiceClass?: string | undefined;
    timeZoneId?: number | undefined;

    constructor(data?: ICreateLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.emailAddress = _data["emailAddress"];
            this.parentId = _data["parentId"];
            this.internalAddress = _data["internalAddress"];
            this.invoiceClass = _data["invoiceClass"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): CreateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["parentId"] = this.parentId;
        data["internalAddress"] = this.internalAddress;
        data["invoiceClass"] = this.invoiceClass;
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface ICreateLocationRequest {
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    emailAddress?: string | undefined;
    parentId?: number | undefined;
    internalAddress?: string | undefined;
    invoiceClass?: string | undefined;
    timeZoneId?: number | undefined;
}

/**  */
export class UpdateLocationRequest implements IUpdateLocationRequest {
    /**   */
    locationId!: number;
    /**   */
    name?: string | undefined;
    /**   */
    address1?: string | undefined;
    /**   */
    address2?: string | undefined;
    /**   */
    city?: string | undefined;
    /**   */
    state?: string | undefined;
    /**   */
    postalCode?: string | undefined;
    /**   */
    country?: string | undefined;
    /**   */
    phone?: string | undefined;
    emailAddress?: string | undefined;
    /**   */
    parentId?: number | undefined;
    /**   */
    internalAddress?: string | undefined;
    /**   */
    invoiceClass?: string | undefined;
    /**   */
    timeZoneId?: number | undefined;
    /**   */
    isActive?: boolean;

    constructor(data?: IUpdateLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.emailAddress = _data["emailAddress"];
            this.parentId = _data["parentId"];
            this.internalAddress = _data["internalAddress"];
            this.invoiceClass = _data["invoiceClass"];
            this.timeZoneId = _data["timeZoneId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["parentId"] = this.parentId;
        data["internalAddress"] = this.internalAddress;
        data["invoiceClass"] = this.invoiceClass;
        data["timeZoneId"] = this.timeZoneId;
        data["isActive"] = this.isActive;
        return data;
    }
}

/**  */
export interface IUpdateLocationRequest {
    /**   */
    locationId: number;
    /**   */
    name?: string | undefined;
    /**   */
    address1?: string | undefined;
    /**   */
    address2?: string | undefined;
    /**   */
    city?: string | undefined;
    /**   */
    state?: string | undefined;
    /**   */
    postalCode?: string | undefined;
    /**   */
    country?: string | undefined;
    /**   */
    phone?: string | undefined;
    emailAddress?: string | undefined;
    /**   */
    parentId?: number | undefined;
    /**   */
    internalAddress?: string | undefined;
    /**   */
    invoiceClass?: string | undefined;
    /**   */
    timeZoneId?: number | undefined;
    /**   */
    isActive?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfMenuItem extends AuditActionResult implements IAuditActionResultOfIEnumerableOfMenuItem {
    object?: MenuItem[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfMenuItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(MenuItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfMenuItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfMenuItem extends IAuditActionResult {
    object?: MenuItem[] | undefined;
}

export class CreateMenuRoleMapRequest implements ICreateMenuRoleMapRequest {
    menuId!: number;
    roleId!: number;

    constructor(data?: ICreateMenuRoleMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuId = _data["menuId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateMenuRoleMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMenuRoleMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuId"] = this.menuId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateMenuRoleMapRequest {
    menuId: number;
    roleId: number;
}

export class UpdateMenuRoleMapRequest implements IUpdateMenuRoleMapRequest {
    roleId!: number;
    menuId!: number;
    canRead?: boolean;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
    canActivate?: boolean;
    canApprove?: boolean;

    constructor(data?: IUpdateMenuRoleMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.menuId = _data["menuId"];
            this.canRead = _data["canRead"];
            this.canCreate = _data["canCreate"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.canActivate = _data["canActivate"];
            this.canApprove = _data["canApprove"];
        }
    }

    static fromJS(data: any): UpdateMenuRoleMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMenuRoleMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["menuId"] = this.menuId;
        data["canRead"] = this.canRead;
        data["canCreate"] = this.canCreate;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["canActivate"] = this.canActivate;
        data["canApprove"] = this.canApprove;
        return data;
    }
}

export interface IUpdateMenuRoleMapRequest {
    roleId: number;
    menuId: number;
    canRead?: boolean;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
    canActivate?: boolean;
    canApprove?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfNCTypeModel extends AuditActionResult implements IAuditActionResultOfICollectionOfNCTypeModel {
    object?: NCTypeModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfNCTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(NCTypeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfNCTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfNCTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfNCTypeModel extends IAuditActionResult {
    object?: NCTypeModel[] | undefined;
}

export class NCTypeModel implements INCTypeModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: INCTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NCTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NCTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INCTypeModel {
    id?: number;
    name?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartBagSizeModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartBagSizeModel {
    object?: PartBagSizeModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartBagSizeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartBagSizeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartBagSizeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartBagSizeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartBagSizeModel extends IAuditActionResult {
    object?: PartBagSizeModel[] | undefined;
}

export class PartBagSizeModel extends PartLookupModelBase implements IPartBagSizeModel {

    constructor(data?: IPartBagSizeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartBagSizeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartBagSizeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartBagSizeModel extends IPartLookupModelBase {
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartBagSizeModel extends AuditActionResult implements IAuditActionResultOfPartBagSizeModel {
    object?: PartBagSizeModel | undefined;

    constructor(data?: IAuditActionResultOfPartBagSizeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartBagSizeModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartBagSizeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartBagSizeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartBagSizeModel extends IAuditActionResult {
    object?: PartBagSizeModel | undefined;
}

export class CreatePartBagSizeRequest implements ICreatePartBagSizeRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartBagSizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartBagSizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartBagSizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartBagSizeRequest {
    name?: string | undefined;
}

export class UpdatePartBagSizeRequest implements IUpdatePartBagSizeRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartBagSizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartBagSizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartBagSizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartBagSizeRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfBoolean extends AuditActionResult implements IAuditActionResultOfBoolean {
    object?: boolean;

    constructor(data?: IAuditActionResultOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"];
        }
    }

    static override fromJS(data: any): AuditActionResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfBoolean extends IAuditActionResult {
    object?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartBagTypeModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartBagTypeModel {
    object?: PartBagTypeModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartBagTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartBagTypeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartBagTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartBagTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartBagTypeModel extends IAuditActionResult {
    object?: PartBagTypeModel[] | undefined;
}

export class PartBagTypeModel extends PartLookupModelBase implements IPartBagTypeModel {

    constructor(data?: IPartBagTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartBagTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartBagTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartBagTypeModel extends IPartLookupModelBase {
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartBagTypeModel extends AuditActionResult implements IAuditActionResultOfPartBagTypeModel {
    object?: PartBagTypeModel | undefined;

    constructor(data?: IAuditActionResultOfPartBagTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartBagTypeModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartBagTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartBagTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartBagTypeModel extends IAuditActionResult {
    object?: PartBagTypeModel | undefined;
}

export class CreatePartBagTypeRequest implements ICreatePartBagTypeRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartBagTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartBagTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartBagTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartBagTypeRequest {
    name?: string | undefined;
}

export class UpdatePartBagTypeRequest implements IUpdatePartBagTypeRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartBagTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartBagTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartBagTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartBagTypeRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartCoatingModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartCoatingModel {
    object?: PartCoatingModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartCoatingModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartCoatingModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartCoatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartCoatingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartCoatingModel extends IAuditActionResult {
    object?: PartCoatingModel[] | undefined;
}

export class PartCoatingModel extends PartLookupModelBase implements IPartCoatingModel {

    constructor(data?: IPartCoatingModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartCoatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartCoatingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartCoatingModel extends IPartLookupModelBase {
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartCoatingModel extends AuditActionResult implements IAuditActionResultOfPartCoatingModel {
    object?: PartCoatingModel | undefined;

    constructor(data?: IAuditActionResultOfPartCoatingModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartCoatingModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartCoatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartCoatingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartCoatingModel extends IAuditActionResult {
    object?: PartCoatingModel | undefined;
}

export class CreatePartCoatingRequest implements ICreatePartCoatingRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartCoatingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartCoatingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartCoatingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartCoatingRequest {
    name?: string | undefined;
}

export class UpdatePartCoatingRequest implements IUpdatePartCoatingRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartCoatingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartCoatingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartCoatingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartCoatingRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartModel {
    object?: PartModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartModel extends IAuditActionResult {
    object?: PartModel[] | undefined;
}

export class PartModel extends TrackableModel implements IPartModel {
    name?: string | undefined;
    partNumber?: string | undefined;
    oemPartNumber?: string | undefined;
    isKit?: boolean;
    nickName?: string | undefined;
    maximumCycles?: number | undefined;
    customerId?: number | undefined;
    customer?: CustomerModel | undefined;
    customerName?: string | undefined;
    procedureId?: number | undefined;
    procedure?: Procedure | undefined;
    procedureSteps?: ProcedureStepModel[] | undefined;
    oemId?: number | undefined;
    revision?: number;
    price?: number | undefined;
    cycleTime?: number | undefined;
    msrDescription?: string | undefined;
    createdByName?: string | undefined;
    lastUpdatedByName?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    createSubParts?: SubPartModel[] | undefined;
    files?: FileModel[] | undefined;
    partLocationMaps?: PartLocationMapModel[] | undefined;
    isActive?: boolean | undefined;
    facilitiesCount?: number;
    workOrderPartsCount?: number;
    hasProcedure?: boolean;
    partDetail?: PartDetailModel | undefined;
    partDetailFilledCount?: number;

    constructor(data?: IPartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.partNumber = _data["partNumber"];
            this.oemPartNumber = _data["oemPartNumber"];
            this.isKit = _data["isKit"];
            this.nickName = _data["nickName"];
            this.maximumCycles = _data["maximumCycles"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.customerName = _data["customerName"];
            this.procedureId = _data["procedureId"];
            this.procedure = _data["procedure"] ? Procedure.fromJS(_data["procedure"]) : undefined as any;
            if (Array.isArray(_data["procedureSteps"])) {
                this.procedureSteps = [] as any;
                for (let item of _data["procedureSteps"])
                    this.procedureSteps!.push(ProcedureStepModel.fromJS(item));
            }
            this.oemId = _data["oemId"];
            this.revision = _data["revision"];
            this.price = _data["price"];
            this.cycleTime = _data["cycleTime"];
            this.msrDescription = _data["msrDescription"];
            this.createdByName = _data["createdByName"];
            this.lastUpdatedByName = _data["lastUpdatedByName"];
            this.segregationType = _data["segregationType"];
            if (Array.isArray(_data["createSubParts"])) {
                this.createSubParts = [] as any;
                for (let item of _data["createSubParts"])
                    this.createSubParts!.push(SubPartModel.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["partLocationMaps"])) {
                this.partLocationMaps = [] as any;
                for (let item of _data["partLocationMaps"])
                    this.partLocationMaps!.push(PartLocationMapModel.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.facilitiesCount = _data["facilitiesCount"];
            this.workOrderPartsCount = _data["workOrderPartsCount"];
            this.hasProcedure = _data["hasProcedure"];
            this.partDetail = _data["partDetail"] ? PartDetailModel.fromJS(_data["partDetail"]) : undefined as any;
            this.partDetailFilledCount = _data["partDetailFilledCount"];
        }
    }

    static override fromJS(data: any): PartModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["partNumber"] = this.partNumber;
        data["oemPartNumber"] = this.oemPartNumber;
        data["isKit"] = this.isKit;
        data["nickName"] = this.nickName;
        data["maximumCycles"] = this.maximumCycles;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["customerName"] = this.customerName;
        data["procedureId"] = this.procedureId;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : undefined as any;
        if (Array.isArray(this.procedureSteps)) {
            data["procedureSteps"] = [];
            for (let item of this.procedureSteps)
                data["procedureSteps"].push(item ? item.toJSON() : undefined as any);
        }
        data["oemId"] = this.oemId;
        data["revision"] = this.revision;
        data["price"] = this.price;
        data["cycleTime"] = this.cycleTime;
        data["msrDescription"] = this.msrDescription;
        data["createdByName"] = this.createdByName;
        data["lastUpdatedByName"] = this.lastUpdatedByName;
        data["segregationType"] = this.segregationType;
        if (Array.isArray(this.createSubParts)) {
            data["createSubParts"] = [];
            for (let item of this.createSubParts)
                data["createSubParts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partLocationMaps)) {
            data["partLocationMaps"] = [];
            for (let item of this.partLocationMaps)
                data["partLocationMaps"].push(item ? item.toJSON() : undefined as any);
        }
        data["isActive"] = this.isActive;
        data["facilitiesCount"] = this.facilitiesCount;
        data["workOrderPartsCount"] = this.workOrderPartsCount;
        data["hasProcedure"] = this.hasProcedure;
        data["partDetail"] = this.partDetail ? this.partDetail.toJSON() : undefined as any;
        data["partDetailFilledCount"] = this.partDetailFilledCount;
        super.toJSON(data);
        return data;
    }
}

export interface IPartModel extends ITrackableModel {
    name?: string | undefined;
    partNumber?: string | undefined;
    oemPartNumber?: string | undefined;
    isKit?: boolean;
    nickName?: string | undefined;
    maximumCycles?: number | undefined;
    customerId?: number | undefined;
    customer?: CustomerModel | undefined;
    customerName?: string | undefined;
    procedureId?: number | undefined;
    procedure?: Procedure | undefined;
    procedureSteps?: ProcedureStepModel[] | undefined;
    oemId?: number | undefined;
    revision?: number;
    price?: number | undefined;
    cycleTime?: number | undefined;
    msrDescription?: string | undefined;
    createdByName?: string | undefined;
    lastUpdatedByName?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    createSubParts?: SubPartModel[] | undefined;
    files?: FileModel[] | undefined;
    partLocationMaps?: PartLocationMapModel[] | undefined;
    isActive?: boolean | undefined;
    facilitiesCount?: number;
    workOrderPartsCount?: number;
    hasProcedure?: boolean;
    partDetail?: PartDetailModel | undefined;
    partDetailFilledCount?: number;
}

export class Procedure extends TrackableModel implements IProcedure {
    name?: string | undefined;
    procedureTypeId?: number;
    creatorCompany?: string | undefined;
    createdByDepartmentName?: string | undefined;
    revision?: number;
    comments?: string | undefined;
    duration?: number;
    durationType?: string | undefined;
    procedureType?: ProcedureType | undefined;
    referenceFiles?: FileModel[] | undefined;
    approvalStatus?: string | undefined;
    tagType?: string | undefined;
    price?: number | undefined;
    isInUse!: boolean;

    constructor(data?: IProcedure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.procedureTypeId = _data["procedureTypeId"];
            this.creatorCompany = _data["creatorCompany"];
            this.createdByDepartmentName = _data["createdByDepartmentName"];
            this.revision = _data["revision"];
            this.comments = _data["comments"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            this.procedureType = _data["procedureType"] ? ProcedureType.fromJS(_data["procedureType"]) : undefined as any;
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            this.approvalStatus = _data["approvalStatus"];
            this.tagType = _data["tagType"];
            this.price = _data["price"];
            this.isInUse = _data["isInUse"];
        }
    }

    static override fromJS(data: any): Procedure {
        data = typeof data === 'object' ? data : {};
        let result = new Procedure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["procedureTypeId"] = this.procedureTypeId;
        data["creatorCompany"] = this.creatorCompany;
        data["createdByDepartmentName"] = this.createdByDepartmentName;
        data["revision"] = this.revision;
        data["comments"] = this.comments;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        data["procedureType"] = this.procedureType ? this.procedureType.toJSON() : undefined as any;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["approvalStatus"] = this.approvalStatus;
        data["tagType"] = this.tagType;
        data["price"] = this.price;
        data["isInUse"] = this.isInUse;
        super.toJSON(data);
        return data;
    }
}

export interface IProcedure extends ITrackableModel {
    name?: string | undefined;
    procedureTypeId?: number;
    creatorCompany?: string | undefined;
    createdByDepartmentName?: string | undefined;
    revision?: number;
    comments?: string | undefined;
    duration?: number;
    durationType?: string | undefined;
    procedureType?: ProcedureType | undefined;
    referenceFiles?: FileModel[] | undefined;
    approvalStatus?: string | undefined;
    tagType?: string | undefined;
    price?: number | undefined;
    isInUse: boolean;
}

export class ProcedureType implements IProcedureType {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    revision?: number | undefined;
    status?: string | undefined;

    constructor(data?: IProcedureType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.revision = _data["revision"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProcedureType {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["revision"] = this.revision;
        data["status"] = this.status;
        return data;
    }
}

export interface IProcedureType {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    revision?: number | undefined;
    status?: string | undefined;
}

export class ProcedureStepModel implements IProcedureStepModel {
    id?: number;
    procedure?: Procedure | undefined;
    procedureId?: number | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    duration?: number | undefined;
    durationType?: string | undefined;
    procedureStepType?: string | undefined;
    procedureStepTypeId?: number | undefined;
    printOrder?: number | undefined;
    predecessorStepId?: number | undefined;
    laborTime?: number | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    referenceFiles?: FileModel[] | undefined;
    roles?: Role[] | undefined;
    referenceDocumentIds?: number[] | undefined;
    referenceDocument?: FileModel[] | undefined;
    approvalStatus?: string | undefined;
    isUsed?: boolean;

    constructor(data?: IProcedureStepModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.procedure = _data["procedure"] ? Procedure.fromJS(_data["procedure"]) : undefined as any;
            this.procedureId = _data["procedureId"];
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            this.procedureStepType = _data["procedureStepType"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.printOrder = _data["printOrder"];
            this.predecessorStepId = _data["predecessorStepId"];
            this.laborTime = _data["laborTime"];
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            if (Array.isArray(_data["referenceDocumentIds"])) {
                this.referenceDocumentIds = [] as any;
                for (let item of _data["referenceDocumentIds"])
                    this.referenceDocumentIds!.push(item);
            }
            if (Array.isArray(_data["referenceDocument"])) {
                this.referenceDocument = [] as any;
                for (let item of _data["referenceDocument"])
                    this.referenceDocument!.push(FileModel.fromJS(item));
            }
            this.approvalStatus = _data["approvalStatus"];
            this.isUsed = _data["isUsed"];
        }
    }

    static fromJS(data: any): ProcedureStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : undefined as any;
        data["procedureId"] = this.procedureId;
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        data["procedureStepType"] = this.procedureStepType;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["printOrder"] = this.printOrder;
        data["predecessorStepId"] = this.predecessorStepId;
        data["laborTime"] = this.laborTime;
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceDocumentIds)) {
            data["referenceDocumentIds"] = [];
            for (let item of this.referenceDocumentIds)
                data["referenceDocumentIds"].push(item);
        }
        if (Array.isArray(this.referenceDocument)) {
            data["referenceDocument"] = [];
            for (let item of this.referenceDocument)
                data["referenceDocument"].push(item ? item.toJSON() : undefined as any);
        }
        data["approvalStatus"] = this.approvalStatus;
        data["isUsed"] = this.isUsed;
        return data;
    }
}

export interface IProcedureStepModel {
    id?: number;
    procedure?: Procedure | undefined;
    procedureId?: number | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    duration?: number | undefined;
    durationType?: string | undefined;
    procedureStepType?: string | undefined;
    procedureStepTypeId?: number | undefined;
    printOrder?: number | undefined;
    predecessorStepId?: number | undefined;
    laborTime?: number | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    referenceFiles?: FileModel[] | undefined;
    roles?: Role[] | undefined;
    referenceDocumentIds?: number[] | undefined;
    referenceDocument?: FileModel[] | undefined;
    approvalStatus?: string | undefined;
    isUsed?: boolean;
}

export enum EnumSegregationType {
    CU = 1,
    NONCU = 2,
    DESEG = 3,
}

export class SubPartModel implements ISubPartModel {
    id?: number | undefined;
    parentId?: number;
    partId?: number;
    qty?: number;
    workOrderId?: number;
    workOrderPartId?: number;
    serialNumber?: string | undefined;
    partNumber?: string | undefined;
    cycleCount?: number | undefined;
    name?: string | undefined;

    constructor(data?: ISubPartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.partId = _data["partId"];
            this.qty = _data["qty"];
            this.workOrderId = _data["workOrderId"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.serialNumber = _data["serialNumber"];
            this.partNumber = _data["partNumber"];
            this.cycleCount = _data["cycleCount"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubPartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["partId"] = this.partId;
        data["qty"] = this.qty;
        data["workOrderId"] = this.workOrderId;
        data["workOrderPartId"] = this.workOrderPartId;
        data["serialNumber"] = this.serialNumber;
        data["partNumber"] = this.partNumber;
        data["cycleCount"] = this.cycleCount;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubPartModel {
    id?: number | undefined;
    parentId?: number;
    partId?: number;
    qty?: number;
    workOrderId?: number;
    workOrderPartId?: number;
    serialNumber?: string | undefined;
    partNumber?: string | undefined;
    cycleCount?: number | undefined;
    name?: string | undefined;
}

export class PartLocationMapModel extends TrackableModel implements IPartLocationMapModel {
    partId?: number;
    locationId?: number;
    locationName?: string | undefined;
    locationIsActive?: boolean | undefined;
    customerContactId?: number | undefined;

    constructor(data?: IPartLocationMapModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partId = _data["partId"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.locationIsActive = _data["locationIsActive"];
            this.customerContactId = _data["customerContactId"];
        }
    }

    static override fromJS(data: any): PartLocationMapModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationMapModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationIsActive"] = this.locationIsActive;
        data["customerContactId"] = this.customerContactId;
        super.toJSON(data);
        return data;
    }
}

export interface IPartLocationMapModel extends ITrackableModel {
    partId?: number;
    locationId?: number;
    locationName?: string | undefined;
    locationIsActive?: boolean | undefined;
    customerContactId?: number | undefined;
}

export class PartDetailModel extends EntityModel implements IPartDetailModel {
    partId?: number;
    oemCleaningSpecificationId?: number | undefined;
    oemPackagingSpecificationId?: number | undefined;
    bagTypeId?: number | undefined;
    bagSizeId?: number | undefined;
    depositionId?: number | undefined;
    coatingId?: number | undefined;
    processAreaId?: number | undefined;
    weight?: string | undefined;
    substrateId?: number | undefined;
    otherInformation?: string | undefined;
    oemCleaningSpecification?: PartOEMModel | undefined;
    oemPackagingSpecification?: PartOEMModel | undefined;
    bagType?: PartBagTypeModel | undefined;
    bagSize?: PartBagSizeModel | undefined;
    deposition?: PartDepositionModel | undefined;
    coating?: PartCoatingModel | undefined;
    processArea?: PartProcessAreaModel | undefined;
    substrate?: PartSubstrateModel | undefined;

    constructor(data?: IPartDetailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partId = _data["partId"];
            this.oemCleaningSpecificationId = _data["oemCleaningSpecificationId"];
            this.oemPackagingSpecificationId = _data["oemPackagingSpecificationId"];
            this.bagTypeId = _data["bagTypeId"];
            this.bagSizeId = _data["bagSizeId"];
            this.depositionId = _data["depositionId"];
            this.coatingId = _data["coatingId"];
            this.processAreaId = _data["processAreaId"];
            this.weight = _data["weight"];
            this.substrateId = _data["substrateId"];
            this.otherInformation = _data["otherInformation"];
            this.oemCleaningSpecification = _data["oemCleaningSpecification"] ? PartOEMModel.fromJS(_data["oemCleaningSpecification"]) : undefined as any;
            this.oemPackagingSpecification = _data["oemPackagingSpecification"] ? PartOEMModel.fromJS(_data["oemPackagingSpecification"]) : undefined as any;
            this.bagType = _data["bagType"] ? PartBagTypeModel.fromJS(_data["bagType"]) : undefined as any;
            this.bagSize = _data["bagSize"] ? PartBagSizeModel.fromJS(_data["bagSize"]) : undefined as any;
            this.deposition = _data["deposition"] ? PartDepositionModel.fromJS(_data["deposition"]) : undefined as any;
            this.coating = _data["coating"] ? PartCoatingModel.fromJS(_data["coating"]) : undefined as any;
            this.processArea = _data["processArea"] ? PartProcessAreaModel.fromJS(_data["processArea"]) : undefined as any;
            this.substrate = _data["substrate"] ? PartSubstrateModel.fromJS(_data["substrate"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PartDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartDetailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId;
        data["oemCleaningSpecificationId"] = this.oemCleaningSpecificationId;
        data["oemPackagingSpecificationId"] = this.oemPackagingSpecificationId;
        data["bagTypeId"] = this.bagTypeId;
        data["bagSizeId"] = this.bagSizeId;
        data["depositionId"] = this.depositionId;
        data["coatingId"] = this.coatingId;
        data["processAreaId"] = this.processAreaId;
        data["weight"] = this.weight;
        data["substrateId"] = this.substrateId;
        data["otherInformation"] = this.otherInformation;
        data["oemCleaningSpecification"] = this.oemCleaningSpecification ? this.oemCleaningSpecification.toJSON() : undefined as any;
        data["oemPackagingSpecification"] = this.oemPackagingSpecification ? this.oemPackagingSpecification.toJSON() : undefined as any;
        data["bagType"] = this.bagType ? this.bagType.toJSON() : undefined as any;
        data["bagSize"] = this.bagSize ? this.bagSize.toJSON() : undefined as any;
        data["deposition"] = this.deposition ? this.deposition.toJSON() : undefined as any;
        data["coating"] = this.coating ? this.coating.toJSON() : undefined as any;
        data["processArea"] = this.processArea ? this.processArea.toJSON() : undefined as any;
        data["substrate"] = this.substrate ? this.substrate.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPartDetailModel extends IEntityModel {
    partId?: number;
    oemCleaningSpecificationId?: number | undefined;
    oemPackagingSpecificationId?: number | undefined;
    bagTypeId?: number | undefined;
    bagSizeId?: number | undefined;
    depositionId?: number | undefined;
    coatingId?: number | undefined;
    processAreaId?: number | undefined;
    weight?: string | undefined;
    substrateId?: number | undefined;
    otherInformation?: string | undefined;
    oemCleaningSpecification?: PartOEMModel | undefined;
    oemPackagingSpecification?: PartOEMModel | undefined;
    bagType?: PartBagTypeModel | undefined;
    bagSize?: PartBagSizeModel | undefined;
    deposition?: PartDepositionModel | undefined;
    coating?: PartCoatingModel | undefined;
    processArea?: PartProcessAreaModel | undefined;
    substrate?: PartSubstrateModel | undefined;
}

export class PartDepositionModel extends PartLookupModelBase implements IPartDepositionModel {

    constructor(data?: IPartDepositionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartDepositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartDepositionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartDepositionModel extends IPartLookupModelBase {
}

export class PartProcessAreaModel extends PartLookupModelBase implements IPartProcessAreaModel {

    constructor(data?: IPartProcessAreaModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartProcessAreaModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartProcessAreaModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartProcessAreaModel extends IPartLookupModelBase {
}

export class PartSubstrateModel extends PartLookupModelBase implements IPartSubstrateModel {

    constructor(data?: IPartSubstrateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartSubstrateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartSubstrateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartSubstrateModel extends IPartLookupModelBase {
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartModel extends AuditActionResult implements IAuditActionResultOfPartModel {
    object?: PartModel | undefined;

    constructor(data?: IAuditActionResultOfPartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartModel extends IAuditActionResult {
    object?: PartModel | undefined;
}

export class CreatePartRequest implements ICreatePartRequest {
    name!: string;
    partNumber!: string;
    oemPartNumber?: string | undefined;
    nickName?: string | undefined;
    isKit?: boolean;
    isActive?: boolean;
    maximumCycles?: number | undefined;
    customerId?: number | undefined;
    procedureId?: number | undefined;
    oemId?: number | undefined;
    revision?: number;
    price?: number | undefined;
    cycleTime?: number | undefined;
    msrDescription?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    createSubParts?: SubPartModel[] | undefined;
    comment?: string | undefined;
    files?: FileRequest[] | undefined;

    constructor(data?: ICreatePartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.partNumber = _data["partNumber"];
            this.oemPartNumber = _data["oemPartNumber"];
            this.nickName = _data["nickName"];
            this.isKit = _data["isKit"];
            this.isActive = _data["isActive"];
            this.maximumCycles = _data["maximumCycles"];
            this.customerId = _data["customerId"];
            this.procedureId = _data["procedureId"];
            this.oemId = _data["oemId"];
            this.revision = _data["revision"];
            this.price = _data["price"];
            this.cycleTime = _data["cycleTime"];
            this.msrDescription = _data["msrDescription"];
            this.segregationType = _data["segregationType"];
            if (Array.isArray(_data["createSubParts"])) {
                this.createSubParts = [] as any;
                for (let item of _data["createSubParts"])
                    this.createSubParts!.push(SubPartModel.fromJS(item));
            }
            this.comment = _data["comment"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["partNumber"] = this.partNumber;
        data["oemPartNumber"] = this.oemPartNumber;
        data["nickName"] = this.nickName;
        data["isKit"] = this.isKit;
        data["isActive"] = this.isActive;
        data["maximumCycles"] = this.maximumCycles;
        data["customerId"] = this.customerId;
        data["procedureId"] = this.procedureId;
        data["oemId"] = this.oemId;
        data["revision"] = this.revision;
        data["price"] = this.price;
        data["cycleTime"] = this.cycleTime;
        data["msrDescription"] = this.msrDescription;
        data["segregationType"] = this.segregationType;
        if (Array.isArray(this.createSubParts)) {
            data["createSubParts"] = [];
            for (let item of this.createSubParts)
                data["createSubParts"].push(item ? item.toJSON() : undefined as any);
        }
        data["comment"] = this.comment;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreatePartRequest {
    name: string;
    partNumber: string;
    oemPartNumber?: string | undefined;
    nickName?: string | undefined;
    isKit?: boolean;
    isActive?: boolean;
    maximumCycles?: number | undefined;
    customerId?: number | undefined;
    procedureId?: number | undefined;
    oemId?: number | undefined;
    revision?: number;
    price?: number | undefined;
    cycleTime?: number | undefined;
    msrDescription?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    createSubParts?: SubPartModel[] | undefined;
    comment?: string | undefined;
    files?: FileRequest[] | undefined;
}

export class FileRequest implements IFileRequest {
    /** Name */
    name?: string | undefined;
    /** Base 64 String, URL encoded */
    base64String?: string | undefined;
    /** Content Type */
    contentType?: string | undefined;

    constructor(data?: IFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.base64String = _data["base64String"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): FileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["base64String"] = this.base64String;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IFileRequest {
    /** Name */
    name?: string | undefined;
    /** Base 64 String, URL encoded */
    base64String?: string | undefined;
    /** Content Type */
    contentType?: string | undefined;
}

export class UpdatePartRequest extends CreatePartRequest implements IUpdatePartRequest {
    id!: number;

    constructor(data?: IUpdatePartRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdatePartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePartRequest extends ICreatePartRequest {
    id: number;
}

export class PartDeleteImpactModel implements IPartDeleteImpactModel {
    isKit?: boolean;
    exclusiveSubparts?: PartSummaryModel[] | undefined;
    nonExclusiveSubparts?: PartSummaryModel[] | undefined;
    parentKits?: PartSummaryModel[] | undefined;

    constructor(data?: IPartDeleteImpactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isKit = _data["isKit"];
            if (Array.isArray(_data["exclusiveSubparts"])) {
                this.exclusiveSubparts = [] as any;
                for (let item of _data["exclusiveSubparts"])
                    this.exclusiveSubparts!.push(PartSummaryModel.fromJS(item));
            }
            if (Array.isArray(_data["nonExclusiveSubparts"])) {
                this.nonExclusiveSubparts = [] as any;
                for (let item of _data["nonExclusiveSubparts"])
                    this.nonExclusiveSubparts!.push(PartSummaryModel.fromJS(item));
            }
            if (Array.isArray(_data["parentKits"])) {
                this.parentKits = [] as any;
                for (let item of _data["parentKits"])
                    this.parentKits!.push(PartSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartDeleteImpactModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartDeleteImpactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isKit"] = this.isKit;
        if (Array.isArray(this.exclusiveSubparts)) {
            data["exclusiveSubparts"] = [];
            for (let item of this.exclusiveSubparts)
                data["exclusiveSubparts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nonExclusiveSubparts)) {
            data["nonExclusiveSubparts"] = [];
            for (let item of this.nonExclusiveSubparts)
                data["nonExclusiveSubparts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parentKits)) {
            data["parentKits"] = [];
            for (let item of this.parentKits)
                data["parentKits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartDeleteImpactModel {
    isKit?: boolean;
    exclusiveSubparts?: PartSummaryModel[] | undefined;
    nonExclusiveSubparts?: PartSummaryModel[] | undefined;
    parentKits?: PartSummaryModel[] | undefined;
}

export class PartSummaryModel implements IPartSummaryModel {
    id?: number;
    name?: string | undefined;
    partNumber?: string | undefined;

    constructor(data?: IPartSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.partNumber = _data["partNumber"];
        }
    }

    static fromJS(data: any): PartSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["partNumber"] = this.partNumber;
        return data;
    }
}

export interface IPartSummaryModel {
    id?: number;
    name?: string | undefined;
    partNumber?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartDepositionModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartDepositionModel {
    object?: PartDepositionModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartDepositionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartDepositionModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartDepositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartDepositionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartDepositionModel extends IAuditActionResult {
    object?: PartDepositionModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartDepositionModel extends AuditActionResult implements IAuditActionResultOfPartDepositionModel {
    object?: PartDepositionModel | undefined;

    constructor(data?: IAuditActionResultOfPartDepositionModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartDepositionModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartDepositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartDepositionModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartDepositionModel extends IAuditActionResult {
    object?: PartDepositionModel | undefined;
}

export class CreatePartDepositionRequest implements ICreatePartDepositionRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartDepositionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartDepositionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartDepositionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartDepositionRequest {
    name?: string | undefined;
}

export class UpdatePartDepositionRequest implements IUpdatePartDepositionRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartDepositionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartDepositionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartDepositionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartDepositionRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartDetailModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartDetailModel {
    object?: PartDetailModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartDetailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartDetailModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartDetailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartDetailModel extends IAuditActionResult {
    object?: PartDetailModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartDetailModel extends AuditActionResult implements IAuditActionResultOfPartDetailModel {
    object?: PartDetailModel | undefined;

    constructor(data?: IAuditActionResultOfPartDetailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartDetailModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartDetailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartDetailModel extends IAuditActionResult {
    object?: PartDetailModel | undefined;
}

export class CreatePartDetailRequest implements ICreatePartDetailRequest {
    partId!: number;
    oemCleaningSpecificationId?: number | undefined;
    oemPackagingSpecificationId?: number | undefined;
    bagTypeId?: number | undefined;
    bagSizeId?: number | undefined;
    depositionId?: number | undefined;
    coatingId?: number | undefined;
    processAreaId?: number | undefined;
    weight?: string | undefined;
    substrateId?: number | undefined;
    otherInformation?: string | undefined;

    constructor(data?: ICreatePartDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partId = _data["partId"];
            this.oemCleaningSpecificationId = _data["oemCleaningSpecificationId"];
            this.oemPackagingSpecificationId = _data["oemPackagingSpecificationId"];
            this.bagTypeId = _data["bagTypeId"];
            this.bagSizeId = _data["bagSizeId"];
            this.depositionId = _data["depositionId"];
            this.coatingId = _data["coatingId"];
            this.processAreaId = _data["processAreaId"];
            this.weight = _data["weight"];
            this.substrateId = _data["substrateId"];
            this.otherInformation = _data["otherInformation"];
        }
    }

    static fromJS(data: any): CreatePartDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId;
        data["oemCleaningSpecificationId"] = this.oemCleaningSpecificationId;
        data["oemPackagingSpecificationId"] = this.oemPackagingSpecificationId;
        data["bagTypeId"] = this.bagTypeId;
        data["bagSizeId"] = this.bagSizeId;
        data["depositionId"] = this.depositionId;
        data["coatingId"] = this.coatingId;
        data["processAreaId"] = this.processAreaId;
        data["weight"] = this.weight;
        data["substrateId"] = this.substrateId;
        data["otherInformation"] = this.otherInformation;
        return data;
    }
}

export interface ICreatePartDetailRequest {
    partId: number;
    oemCleaningSpecificationId?: number | undefined;
    oemPackagingSpecificationId?: number | undefined;
    bagTypeId?: number | undefined;
    bagSizeId?: number | undefined;
    depositionId?: number | undefined;
    coatingId?: number | undefined;
    processAreaId?: number | undefined;
    weight?: string | undefined;
    substrateId?: number | undefined;
    otherInformation?: string | undefined;
}

export class UpdatePartDetailRequest extends CreatePartDetailRequest implements IUpdatePartDetailRequest {
    id?: number | undefined;

    constructor(data?: IUpdatePartDetailRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdatePartDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartDetailRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePartDetailRequest extends ICreatePartDetailRequest {
    id?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartLocationMapModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartLocationMapModel {
    object?: PartLocationMapModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartLocationMapModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartLocationMapModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartLocationMapModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartLocationMapModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartLocationMapModel extends IAuditActionResult {
    object?: PartLocationMapModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartLocationMapModel extends AuditActionResult implements IAuditActionResultOfPartLocationMapModel {
    object?: PartLocationMapModel | undefined;

    constructor(data?: IAuditActionResultOfPartLocationMapModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartLocationMapModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartLocationMapModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartLocationMapModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartLocationMapModel extends IAuditActionResult {
    object?: PartLocationMapModel | undefined;
}

export class CreatePartLocationMapRequest implements ICreatePartLocationMapRequest {
    partId!: number;
    locationId!: number;
    customerContactId?: number | undefined;

    constructor(data?: ICreatePartLocationMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partId = _data["partId"];
            this.locationId = _data["locationId"];
            this.customerContactId = _data["customerContactId"];
        }
    }

    static fromJS(data: any): CreatePartLocationMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartLocationMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId;
        data["locationId"] = this.locationId;
        data["customerContactId"] = this.customerContactId;
        return data;
    }
}

export interface ICreatePartLocationMapRequest {
    partId: number;
    locationId: number;
    customerContactId?: number | undefined;
}

export class UpdatePartLocationMapRequest extends CreatePartLocationMapRequest implements IUpdatePartLocationMapRequest {
    id!: number;

    constructor(data?: IUpdatePartLocationMapRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdatePartLocationMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartLocationMapRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePartLocationMapRequest extends ICreatePartLocationMapRequest {
    id: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartMonitorModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartMonitorModel {
    object?: PartMonitorModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartMonitorModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartMonitorModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartMonitorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartMonitorModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartMonitorModel extends IAuditActionResult {
    object?: PartMonitorModel[] | undefined;
}

export class PartMonitorModel implements IPartMonitorModel {
    id?: number;
    partId?: number;
    monitorType?: string | undefined;
    monitorTypeId?: number;
    inputType?: string | undefined;
    inputTypeId?: number;
    sensorName?: string | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    failAction?: string | undefined;
    description?: string | undefined;
    sendNCREmail?: boolean | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    monitorListId?: number | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;

    constructor(data?: IPartMonitorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partId = _data["partId"];
            this.monitorType = _data["monitorType"];
            this.monitorTypeId = _data["monitorTypeId"];
            this.inputType = _data["inputType"];
            this.inputTypeId = _data["inputTypeId"];
            this.sensorName = _data["sensorName"];
            this.shouldBe = _data["shouldBe"];
            this.target = _data["target"];
            this.failAction = _data["failAction"];
            this.description = _data["description"];
            this.sendNCREmail = _data["sendNCREmail"];
            this.highTarget = _data["highTarget"];
            this.lowTarget = _data["lowTarget"];
            this.sciTarget = _data["sciTarget"];
            this.sciLowTarget = _data["sciLowTarget"];
            this.sciHighTarget = _data["sciHighTarget"];
            this.monitorListId = _data["monitorListId"];
            this.unitofMeasureId = _data["unitofMeasureId"];
            this.displayInReports = _data["displayInReports"];
        }
    }

    static fromJS(data: any): PartMonitorModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartMonitorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partId"] = this.partId;
        data["monitorType"] = this.monitorType;
        data["monitorTypeId"] = this.monitorTypeId;
        data["inputType"] = this.inputType;
        data["inputTypeId"] = this.inputTypeId;
        data["sensorName"] = this.sensorName;
        data["shouldBe"] = this.shouldBe;
        data["target"] = this.target;
        data["failAction"] = this.failAction;
        data["description"] = this.description;
        data["sendNCREmail"] = this.sendNCREmail;
        data["highTarget"] = this.highTarget;
        data["lowTarget"] = this.lowTarget;
        data["sciTarget"] = this.sciTarget;
        data["sciLowTarget"] = this.sciLowTarget;
        data["sciHighTarget"] = this.sciHighTarget;
        data["monitorListId"] = this.monitorListId;
        data["unitofMeasureId"] = this.unitofMeasureId;
        data["displayInReports"] = this.displayInReports;
        return data;
    }
}

export interface IPartMonitorModel {
    id?: number;
    partId?: number;
    monitorType?: string | undefined;
    monitorTypeId?: number;
    inputType?: string | undefined;
    inputTypeId?: number;
    sensorName?: string | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    failAction?: string | undefined;
    description?: string | undefined;
    sendNCREmail?: boolean | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    monitorListId?: number | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfProcedureStepMonitorDefinition extends AuditActionResult implements IAuditActionResultOfProcedureStepMonitorDefinition {
    object?: ProcedureStepMonitorDefinition | undefined;

    constructor(data?: IAuditActionResultOfProcedureStepMonitorDefinition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? ProcedureStepMonitorDefinition.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfProcedureStepMonitorDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfProcedureStepMonitorDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfProcedureStepMonitorDefinition extends IAuditActionResult {
    object?: ProcedureStepMonitorDefinition | undefined;
}

export class ProcedureStepMonitorDefinition implements IProcedureStepMonitorDefinition {
    types?: ProcedureStepMonitorInputType[] | undefined;
    listItems?: ProcedureStepMonitorListItem[] | undefined;

    constructor(data?: IProcedureStepMonitorDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(ProcedureStepMonitorInputType.fromJS(item));
            }
            if (Array.isArray(_data["listItems"])) {
                this.listItems = [] as any;
                for (let item of _data["listItems"])
                    this.listItems!.push(ProcedureStepMonitorListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedureStepMonitorDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepMonitorDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listItems)) {
            data["listItems"] = [];
            for (let item of this.listItems)
                data["listItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProcedureStepMonitorDefinition {
    types?: ProcedureStepMonitorInputType[] | undefined;
    listItems?: ProcedureStepMonitorListItem[] | undefined;
}

export class ProcedureStepMonitorInputType implements IProcedureStepMonitorInputType {
    inputTypeId?: number;
    monitorTypeId?: number;
    inputTypeName?: string | undefined;
    monitorTypeName?: string | undefined;

    constructor(data?: IProcedureStepMonitorInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputTypeId = _data["inputTypeId"];
            this.monitorTypeId = _data["monitorTypeId"];
            this.inputTypeName = _data["inputTypeName"];
            this.monitorTypeName = _data["monitorTypeName"];
        }
    }

    static fromJS(data: any): ProcedureStepMonitorInputType {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepMonitorInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputTypeId"] = this.inputTypeId;
        data["monitorTypeId"] = this.monitorTypeId;
        data["inputTypeName"] = this.inputTypeName;
        data["monitorTypeName"] = this.monitorTypeName;
        return data;
    }
}

export interface IProcedureStepMonitorInputType {
    inputTypeId?: number;
    monitorTypeId?: number;
    inputTypeName?: string | undefined;
    monitorTypeName?: string | undefined;
}

export class ProcedureStepMonitorListItem implements IProcedureStepMonitorListItem {
    listItemId?: number;
    monitorListId?: number;
    itemName?: string | undefined;
    listName?: string | undefined;

    constructor(data?: IProcedureStepMonitorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listItemId = _data["listItemId"];
            this.monitorListId = _data["monitorListId"];
            this.itemName = _data["itemName"];
            this.listName = _data["listName"];
        }
    }

    static fromJS(data: any): ProcedureStepMonitorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepMonitorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listItemId"] = this.listItemId;
        data["monitorListId"] = this.monitorListId;
        data["itemName"] = this.itemName;
        data["listName"] = this.listName;
        return data;
    }
}

export interface IProcedureStepMonitorListItem {
    listItemId?: number;
    monitorListId?: number;
    itemName?: string | undefined;
    listName?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartMonitorModel extends AuditActionResult implements IAuditActionResultOfPartMonitorModel {
    object?: PartMonitorModel | undefined;

    constructor(data?: IAuditActionResultOfPartMonitorModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartMonitorModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartMonitorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartMonitorModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartMonitorModel extends IAuditActionResult {
    object?: PartMonitorModel | undefined;
}

export class CreatePartMonitorRequest implements ICreatePartMonitorRequest {
    partId!: number;
    monitorType!: string;
    inputType?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    sendNCREmail?: boolean | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;

    constructor(data?: ICreatePartMonitorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partId = _data["partId"];
            this.monitorType = _data["monitorType"];
            this.inputType = _data["inputType"];
            this.description = _data["description"];
            this.monitorListId = _data["monitorListId"];
            this.shouldBe = _data["shouldBe"];
            this.target = _data["target"];
            this.highTarget = _data["highTarget"];
            this.lowTarget = _data["lowTarget"];
            this.sciTarget = _data["sciTarget"];
            this.sciLowTarget = _data["sciLowTarget"];
            this.sciHighTarget = _data["sciHighTarget"];
            this.failAction = _data["failAction"];
            this.sensorName = _data["sensorName"];
            this.sendNCREmail = _data["sendNCREmail"];
            this.unitofMeasureId = _data["unitofMeasureId"];
            this.displayInReports = _data["displayInReports"];
        }
    }

    static fromJS(data: any): CreatePartMonitorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartMonitorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId;
        data["monitorType"] = this.monitorType;
        data["inputType"] = this.inputType;
        data["description"] = this.description;
        data["monitorListId"] = this.monitorListId;
        data["shouldBe"] = this.shouldBe;
        data["target"] = this.target;
        data["highTarget"] = this.highTarget;
        data["lowTarget"] = this.lowTarget;
        data["sciTarget"] = this.sciTarget;
        data["sciLowTarget"] = this.sciLowTarget;
        data["sciHighTarget"] = this.sciHighTarget;
        data["failAction"] = this.failAction;
        data["sensorName"] = this.sensorName;
        data["sendNCREmail"] = this.sendNCREmail;
        data["unitofMeasureId"] = this.unitofMeasureId;
        data["displayInReports"] = this.displayInReports;
        return data;
    }
}

export interface ICreatePartMonitorRequest {
    partId: number;
    monitorType: string;
    inputType?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    sendNCREmail?: boolean | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;
}

export class UpdatePartMonitorRequest implements IUpdatePartMonitorRequest {
    id!: number;
    partId?: number | undefined;
    monitorType?: string | undefined;
    inputType?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    sendNCREmail?: boolean | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;

    constructor(data?: IUpdatePartMonitorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partId = _data["partId"];
            this.monitorType = _data["monitorType"];
            this.inputType = _data["inputType"];
            this.description = _data["description"];
            this.monitorListId = _data["monitorListId"];
            this.shouldBe = _data["shouldBe"];
            this.target = _data["target"];
            this.highTarget = _data["highTarget"];
            this.lowTarget = _data["lowTarget"];
            this.sciTarget = _data["sciTarget"];
            this.sciLowTarget = _data["sciLowTarget"];
            this.sciHighTarget = _data["sciHighTarget"];
            this.failAction = _data["failAction"];
            this.sensorName = _data["sensorName"];
            this.sendNCREmail = _data["sendNCREmail"];
            this.unitofMeasureId = _data["unitofMeasureId"];
            this.displayInReports = _data["displayInReports"];
        }
    }

    static fromJS(data: any): UpdatePartMonitorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartMonitorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partId"] = this.partId;
        data["monitorType"] = this.monitorType;
        data["inputType"] = this.inputType;
        data["description"] = this.description;
        data["monitorListId"] = this.monitorListId;
        data["shouldBe"] = this.shouldBe;
        data["target"] = this.target;
        data["highTarget"] = this.highTarget;
        data["lowTarget"] = this.lowTarget;
        data["sciTarget"] = this.sciTarget;
        data["sciLowTarget"] = this.sciLowTarget;
        data["sciHighTarget"] = this.sciHighTarget;
        data["failAction"] = this.failAction;
        data["sensorName"] = this.sensorName;
        data["sendNCREmail"] = this.sendNCREmail;
        data["unitofMeasureId"] = this.unitofMeasureId;
        data["displayInReports"] = this.displayInReports;
        return data;
    }
}

export interface IUpdatePartMonitorRequest {
    id: number;
    partId?: number | undefined;
    monitorType?: string | undefined;
    inputType?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    target?: number | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    sendNCREmail?: boolean | undefined;
    unitofMeasureId?: number | undefined;
    displayInReports?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartOEMModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartOEMModel {
    object?: PartOEMModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartOEMModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartOEMModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartOEMModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartOEMModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartOEMModel extends IAuditActionResult {
    object?: PartOEMModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartOEMModel extends AuditActionResult implements IAuditActionResultOfPartOEMModel {
    object?: PartOEMModel | undefined;

    constructor(data?: IAuditActionResultOfPartOEMModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartOEMModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartOEMModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartOEMModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartOEMModel extends IAuditActionResult {
    object?: PartOEMModel | undefined;
}

export class CreatePartOEMRequest implements ICreatePartOEMRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartOEMRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartOEMRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartOEMRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartOEMRequest {
    name?: string | undefined;
}

export class UpdatePartOEMRequest implements IUpdatePartOEMRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartOEMRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartOEMRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartOEMRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartOEMRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartProcessAreaModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartProcessAreaModel {
    object?: PartProcessAreaModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartProcessAreaModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartProcessAreaModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartProcessAreaModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartProcessAreaModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartProcessAreaModel extends IAuditActionResult {
    object?: PartProcessAreaModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartProcessAreaModel extends AuditActionResult implements IAuditActionResultOfPartProcessAreaModel {
    object?: PartProcessAreaModel | undefined;

    constructor(data?: IAuditActionResultOfPartProcessAreaModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartProcessAreaModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartProcessAreaModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartProcessAreaModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartProcessAreaModel extends IAuditActionResult {
    object?: PartProcessAreaModel | undefined;
}

export class CreatePartProcessAreaRequest implements ICreatePartProcessAreaRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartProcessAreaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartProcessAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartProcessAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartProcessAreaRequest {
    name?: string | undefined;
}

export class UpdatePartProcessAreaRequest implements IUpdatePartProcessAreaRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartProcessAreaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartProcessAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartProcessAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartProcessAreaRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPartSubstrateModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPartSubstrateModel {
    object?: PartSubstrateModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPartSubstrateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PartSubstrateModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPartSubstrateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPartSubstrateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPartSubstrateModel extends IAuditActionResult {
    object?: PartSubstrateModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPartSubstrateModel extends AuditActionResult implements IAuditActionResultOfPartSubstrateModel {
    object?: PartSubstrateModel | undefined;

    constructor(data?: IAuditActionResultOfPartSubstrateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PartSubstrateModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPartSubstrateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPartSubstrateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPartSubstrateModel extends IAuditActionResult {
    object?: PartSubstrateModel | undefined;
}

export class CreatePartSubstrateRequest implements ICreatePartSubstrateRequest {
    name?: string | undefined;

    constructor(data?: ICreatePartSubstrateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePartSubstrateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartSubstrateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePartSubstrateRequest {
    name?: string | undefined;
}

export class UpdatePartSubstrateRequest implements IUpdatePartSubstrateRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdatePartSubstrateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePartSubstrateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartSubstrateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdatePartSubstrateRequest {
    id?: number;
    name?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfProcedure extends AuditActionResult implements IAuditActionResultOfProcedure {
    object?: Procedure | undefined;

    constructor(data?: IAuditActionResultOfProcedure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? Procedure.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfProcedure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfProcedure extends IAuditActionResult {
    object?: Procedure | undefined;
}

/**  */
export class CreateProcedureRequest implements ICreateProcedureRequest {
    name!: string;
    isRelatedToAProduct?: boolean;
    procedureTypeId!: number;
    comments?: string | undefined;
    duration?: number | undefined;
    durationType!: string;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    tagType?: string | undefined;
    price?: number | undefined;

    constructor(data?: ICreateProcedureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isRelatedToAProduct = _data["isRelatedToAProduct"];
            this.procedureTypeId = _data["procedureTypeId"];
            this.comments = _data["comments"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            this.tagType = _data["tagType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CreateProcedureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isRelatedToAProduct"] = this.isRelatedToAProduct;
        data["procedureTypeId"] = this.procedureTypeId;
        data["comments"] = this.comments;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        data["tagType"] = this.tagType;
        data["price"] = this.price;
        return data;
    }
}

/**  */
export interface ICreateProcedureRequest {
    name: string;
    isRelatedToAProduct?: boolean;
    procedureTypeId: number;
    comments?: string | undefined;
    duration?: number | undefined;
    durationType: string;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    tagType?: string | undefined;
    price?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfProcedureStepModel extends AuditActionResult implements IAuditActionResultOfProcedureStepModel {
    object?: ProcedureStepModel | undefined;

    constructor(data?: IAuditActionResultOfProcedureStepModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? ProcedureStepModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfProcedureStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfProcedureStepModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfProcedureStepModel extends IAuditActionResult {
    object?: ProcedureStepModel | undefined;
}

export class CreateProcedureStepRequest implements ICreateProcedureStepRequest {
    procedureId?: number | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    duration?: number | undefined;
    durationType?: string | undefined;
    procedureStepTypeId?: number | undefined;
    printOrder?: number | undefined;
    predecessorStepId?: number | undefined;
    laborTime?: number | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    roles?: RoleRequest[] | undefined;
    referenceDocumentIds?: number[] | undefined;

    constructor(data?: ICreateProcedureStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureId = _data["procedureId"];
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.printOrder = _data["printOrder"];
            this.predecessorStepId = _data["predecessorStepId"];
            this.laborTime = _data["laborTime"];
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceDocumentIds"])) {
                this.referenceDocumentIds = [] as any;
                for (let item of _data["referenceDocumentIds"])
                    this.referenceDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateProcedureStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedureId"] = this.procedureId;
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["printOrder"] = this.printOrder;
        data["predecessorStepId"] = this.predecessorStepId;
        data["laborTime"] = this.laborTime;
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceDocumentIds)) {
            data["referenceDocumentIds"] = [];
            for (let item of this.referenceDocumentIds)
                data["referenceDocumentIds"].push(item);
        }
        return data;
    }
}

export interface ICreateProcedureStepRequest {
    procedureId?: number | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    duration?: number | undefined;
    durationType?: string | undefined;
    procedureStepTypeId?: number | undefined;
    printOrder?: number | undefined;
    predecessorStepId?: number | undefined;
    laborTime?: number | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    roles?: RoleRequest[] | undefined;
    referenceDocumentIds?: number[] | undefined;
}

/**  */
export class RoleRequest implements IRoleRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;
    /** Gets or Sets IsCertificationRole */
    isCertificationRole?: boolean | undefined;
    /** Gets or Sets Menus */
    menus?: MenuItemRequest[] | undefined;

    constructor(data?: IRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCertificationRole = _data["isCertificationRole"];
            if (Array.isArray(_data["menus"])) {
                this.menus = [] as any;
                for (let item of _data["menus"])
                    this.menus!.push(MenuItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCertificationRole"] = this.isCertificationRole;
        if (Array.isArray(this.menus)) {
            data["menus"] = [];
            for (let item of this.menus)
                data["menus"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/**  */
export interface IRoleRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;
    /** Gets or Sets IsCertificationRole */
    isCertificationRole?: boolean | undefined;
    /** Gets or Sets Menus */
    menus?: MenuItemRequest[] | undefined;
}

/**  */
export class MenuItemRequest implements IMenuItemRequest {
    /** Gets or Sets Url */
    url?: string | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;
    /** Gets or Sets Info */
    info?: string | undefined;
    /** Gets or Sets Icon */
    icon?: string | undefined;
    /** Gets or Sets OrderNumber */
    orderNumber?: number | undefined;
    /** Gets or Sets MenuGroup */
    menuGroup?: OneOfMenuItemMenuGroup | undefined;
    /** Gets or Sets Permissions */
    permissions?: (number | undefined)[] | undefined;
    /** Gets or Sets EnumMenuItem */
    enumMenuItem?: EnumMenuItem | undefined;

    constructor(data?: IMenuItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.name = _data["name"];
            this.info = _data["info"];
            this.icon = _data["icon"];
            this.orderNumber = _data["orderNumber"];
            this.menuGroup = _data["menuGroup"] ? OneOfMenuItemMenuGroup.fromJS(_data["menuGroup"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.enumMenuItem = _data["enumMenuItem"];
        }
    }

    static fromJS(data: any): MenuItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["info"] = this.info;
        data["icon"] = this.icon;
        data["orderNumber"] = this.orderNumber;
        data["menuGroup"] = this.menuGroup ? this.menuGroup.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["enumMenuItem"] = this.enumMenuItem;
        return data;
    }
}

/**  */
export interface IMenuItemRequest {
    /** Gets or Sets Url */
    url?: string | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;
    /** Gets or Sets Info */
    info?: string | undefined;
    /** Gets or Sets Icon */
    icon?: string | undefined;
    /** Gets or Sets OrderNumber */
    orderNumber?: number | undefined;
    /** Gets or Sets MenuGroup */
    menuGroup?: OneOfMenuItemMenuGroup | undefined;
    /** Gets or Sets Permissions */
    permissions?: (number | undefined)[] | undefined;
    /** Gets or Sets EnumMenuItem */
    enumMenuItem?: EnumMenuItem | undefined;
}

/**  */
export class OneOfMenuItemMenuGroup implements IOneOfMenuItemMenuGroup {

    constructor(data?: IOneOfMenuItemMenuGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): OneOfMenuItemMenuGroup {
        data = typeof data === 'object' ? data : {};
        let result = new OneOfMenuItemMenuGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/**  */
export interface IOneOfMenuItemMenuGroup {
}

export class ProcedureDeleteImpactModel implements IProcedureDeleteImpactModel {
    stepCount?: number;
    roleAssignmentCount?: number;
    fileAttachmentCount?: number;
    linkedParts?: PartSummaryModel[] | undefined;

    constructor(data?: IProcedureDeleteImpactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepCount = _data["stepCount"];
            this.roleAssignmentCount = _data["roleAssignmentCount"];
            this.fileAttachmentCount = _data["fileAttachmentCount"];
            if (Array.isArray(_data["linkedParts"])) {
                this.linkedParts = [] as any;
                for (let item of _data["linkedParts"])
                    this.linkedParts!.push(PartSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedureDeleteImpactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureDeleteImpactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepCount"] = this.stepCount;
        data["roleAssignmentCount"] = this.roleAssignmentCount;
        data["fileAttachmentCount"] = this.fileAttachmentCount;
        if (Array.isArray(this.linkedParts)) {
            data["linkedParts"] = [];
            for (let item of this.linkedParts)
                data["linkedParts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProcedureDeleteImpactModel {
    stepCount?: number;
    roleAssignmentCount?: number;
    fileAttachmentCount?: number;
    linkedParts?: PartSummaryModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfProcedure extends AuditActionResult implements IAuditActionResultOfICollectionOfProcedure {
    object?: Procedure[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfProcedure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(Procedure.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfProcedure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfProcedure extends IAuditActionResult {
    object?: Procedure[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfProcedureStepModel extends AuditActionResult implements IAuditActionResultOfICollectionOfProcedureStepModel {
    object?: ProcedureStepModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfProcedureStepModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ProcedureStepModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfProcedureStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfProcedureStepModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfProcedureStepModel extends IAuditActionResult {
    object?: ProcedureStepModel[] | undefined;
}

export class UpdateProcedureRequest implements IUpdateProcedureRequest {
    id?: number;
    name!: string;
    isRelatedToAProduct?: boolean;
    procedureTypeId?: number | undefined;
    comments?: string | undefined;
    duration?: number | undefined;
    durationType!: string;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    tagType?: string | undefined;
    price?: number | undefined;

    constructor(data?: IUpdateProcedureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isRelatedToAProduct = _data["isRelatedToAProduct"];
            this.procedureTypeId = _data["procedureTypeId"];
            this.comments = _data["comments"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            this.tagType = _data["tagType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UpdateProcedureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isRelatedToAProduct"] = this.isRelatedToAProduct;
        data["procedureTypeId"] = this.procedureTypeId;
        data["comments"] = this.comments;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        data["tagType"] = this.tagType;
        data["price"] = this.price;
        return data;
    }
}

export interface IUpdateProcedureRequest {
    id?: number;
    name: string;
    isRelatedToAProduct?: boolean;
    procedureTypeId?: number | undefined;
    comments?: string | undefined;
    duration?: number | undefined;
    durationType: string;
    referenceFiles?: FileRequest[] | undefined;
    referenceFileIds?: number[] | undefined;
    tagType?: string | undefined;
    price?: number | undefined;
}

/**  */
export class UpdateProcedureStepRequest implements IUpdateProcedureStepRequest {
    /** Procedure Step Id to update */
    procedureStepId?: number;
    /** Gets or Sets ProcedureId */
    procedureId?: number | undefined;
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets Text */
    stepText?: string | undefined;
    /** Gets or Sets Duration */
    duration?: number | undefined;
    /** Gets or Sets DurationType */
    durationType?: string | undefined;
    /** Procedure Step Type */
    procedureStepTypeId?: number;
    /** Gets or Sets PrintOrder */
    printOrder?: number | undefined;
    /** Gets or Sets PredecessorStepId */
    predecessorStepId?: number | undefined;
    /** Gets or Sets LaborTime */
    laborTime?: number | undefined;
    /** Gets or Sets EquipmentTime */
    equipmentTime?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets UtilizationTime */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets ReferenceFileIds    */
    referenceFileIds?: number[] | undefined;
    /** Gets or Sets Roles */
    roles?: RoleRequest[] | undefined;
    /** Gets or Sets Documents */
    referenceDocumentIds?: number[] | undefined;

    constructor(data?: IUpdateProcedureStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureStepId = _data["procedureStepId"];
            this.procedureId = _data["procedureId"];
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.duration = _data["duration"];
            this.durationType = _data["durationType"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.printOrder = _data["printOrder"];
            this.predecessorStepId = _data["predecessorStepId"];
            this.laborTime = _data["laborTime"];
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleRequest.fromJS(item));
            }
            if (Array.isArray(_data["referenceDocumentIds"])) {
                this.referenceDocumentIds = [] as any;
                for (let item of _data["referenceDocumentIds"])
                    this.referenceDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProcedureStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedureStepId"] = this.procedureStepId;
        data["procedureId"] = this.procedureId;
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["duration"] = this.duration;
        data["durationType"] = this.durationType;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["printOrder"] = this.printOrder;
        data["predecessorStepId"] = this.predecessorStepId;
        data["laborTime"] = this.laborTime;
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceDocumentIds)) {
            data["referenceDocumentIds"] = [];
            for (let item of this.referenceDocumentIds)
                data["referenceDocumentIds"].push(item);
        }
        return data;
    }
}

/**  */
export interface IUpdateProcedureStepRequest {
    /** Procedure Step Id to update */
    procedureStepId?: number;
    /** Gets or Sets ProcedureId */
    procedureId?: number | undefined;
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets Text */
    stepText?: string | undefined;
    /** Gets or Sets Duration */
    duration?: number | undefined;
    /** Gets or Sets DurationType */
    durationType?: string | undefined;
    /** Procedure Step Type */
    procedureStepTypeId?: number;
    /** Gets or Sets PrintOrder */
    printOrder?: number | undefined;
    /** Gets or Sets PredecessorStepId */
    predecessorStepId?: number | undefined;
    /** Gets or Sets LaborTime */
    laborTime?: number | undefined;
    /** Gets or Sets EquipmentTime */
    equipmentTime?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets UtilizationTime */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets ReferenceFileIds    */
    referenceFileIds?: number[] | undefined;
    /** Gets or Sets Roles */
    roles?: RoleRequest[] | undefined;
    /** Gets or Sets Documents */
    referenceDocumentIds?: number[] | undefined;
}

export class ReorderStepsRequest implements IReorderStepsRequest {
    procedureSteps?: ReorderStepRequest[] | undefined;

    constructor(data?: IReorderStepsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["procedureSteps"])) {
                this.procedureSteps = [] as any;
                for (let item of _data["procedureSteps"])
                    this.procedureSteps!.push(ReorderStepRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReorderStepsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderStepsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.procedureSteps)) {
            data["procedureSteps"] = [];
            for (let item of this.procedureSteps)
                data["procedureSteps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReorderStepsRequest {
    procedureSteps?: ReorderStepRequest[] | undefined;
}

export class ReorderStepRequest implements IReorderStepRequest {
    stepId?: number;
    printOrder?: number;

    constructor(data?: IReorderStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.printOrder = _data["printOrder"];
        }
    }

    static fromJS(data: any): ReorderStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["printOrder"] = this.printOrder;
        return data;
    }
}

export interface IReorderStepRequest {
    stepId?: number;
    printOrder?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfProcedureStepTemplateModel extends AuditActionResult implements IAuditActionResultOfICollectionOfProcedureStepTemplateModel {
    object?: ProcedureStepTemplateModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfProcedureStepTemplateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ProcedureStepTemplateModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfProcedureStepTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfProcedureStepTemplateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfProcedureStepTemplateModel extends IAuditActionResult {
    object?: ProcedureStepTemplateModel[] | undefined;
}

export class ProcedureStepTemplateModel implements IProcedureStepTemplateModel {
    id?: number;
    title?: string | undefined;
    text?: string | undefined;
    systemTaskId?: number | undefined;
    laborTime?: number | undefined;
    referenceProcedures?: number[] | undefined;
    referenceDocuments?: FileModel[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    roles?: number[] | undefined;
    comments?: string | undefined;
    revision?: number | undefined;
    referenceDocumentIds?: number[] | undefined;

    constructor(data?: IProcedureStepTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.systemTaskId = _data["systemTaskId"];
            this.laborTime = _data["laborTime"];
            if (Array.isArray(_data["referenceProcedures"])) {
                this.referenceProcedures = [] as any;
                for (let item of _data["referenceProcedures"])
                    this.referenceProcedures!.push(item);
            }
            if (Array.isArray(_data["referenceDocuments"])) {
                this.referenceDocuments = [] as any;
                for (let item of _data["referenceDocuments"])
                    this.referenceDocuments!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.comments = _data["comments"];
            this.revision = _data["revision"];
            if (Array.isArray(_data["referenceDocumentIds"])) {
                this.referenceDocumentIds = [] as any;
                for (let item of _data["referenceDocumentIds"])
                    this.referenceDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcedureStepTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["text"] = this.text;
        data["systemTaskId"] = this.systemTaskId;
        data["laborTime"] = this.laborTime;
        if (Array.isArray(this.referenceProcedures)) {
            data["referenceProcedures"] = [];
            for (let item of this.referenceProcedures)
                data["referenceProcedures"].push(item);
        }
        if (Array.isArray(this.referenceDocuments)) {
            data["referenceDocuments"] = [];
            for (let item of this.referenceDocuments)
                data["referenceDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["comments"] = this.comments;
        data["revision"] = this.revision;
        if (Array.isArray(this.referenceDocumentIds)) {
            data["referenceDocumentIds"] = [];
            for (let item of this.referenceDocumentIds)
                data["referenceDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IProcedureStepTemplateModel {
    id?: number;
    title?: string | undefined;
    text?: string | undefined;
    systemTaskId?: number | undefined;
    laborTime?: number | undefined;
    referenceProcedures?: number[] | undefined;
    referenceDocuments?: FileModel[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    equipmentTime?: number | undefined;
    replacementCost?: number | undefined;
    price?: number | undefined;
    specialActionEnabled?: number | undefined;
    utilization?: number | undefined;
    usefulLife?: number | undefined;
    roles?: number[] | undefined;
    comments?: string | undefined;
    revision?: number | undefined;
    referenceDocumentIds?: number[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfProcedureStepTemplateModel extends AuditActionResult implements IAuditActionResultOfProcedureStepTemplateModel {
    object?: ProcedureStepTemplateModel | undefined;

    constructor(data?: IAuditActionResultOfProcedureStepTemplateModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? ProcedureStepTemplateModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfProcedureStepTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfProcedureStepTemplateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfProcedureStepTemplateModel extends IAuditActionResult {
    object?: ProcedureStepTemplateModel | undefined;
}

/**  */
export class CreateProcedureStepTemplateRequest implements ICreateProcedureStepTemplateRequest {
    /** Title */
    title?: string | undefined;
    /** StepText */
    stepText?: string | undefined;
    /** ProcedureStepTypeId (SystemTaskId in the DB) */
    procedureStepTypeId?: number | undefined;
    /** LaborTime */
    laborTime?: number | undefined;
    /** ReferenceProcedures */
    referenceProcedures?: number[] | undefined;
    /** ReferenceDocuments */
    referenceDocuments?: number[] | undefined;
    /** EquipmentTime */
    equipmentTime?: number | undefined;
    /** ReplacementCost */
    replacementCost?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Utilization Time */
    utilization?: number | undefined;
    /** UsefulLife */
    usefulLife?: number | undefined;
    /** Comments */
    comments?: string | undefined;
    /** Role list */
    roles?: number[] | undefined;
    /** ReferenceFileIds - Existing fileIds */
    referenceFileIds?: number[] | undefined;
    /** ReferenceFiles - new files */
    referenceFiles?: FileModel[] | undefined;

    constructor(data?: ICreateProcedureStepTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.laborTime = _data["laborTime"];
            if (Array.isArray(_data["referenceProcedures"])) {
                this.referenceProcedures = [] as any;
                for (let item of _data["referenceProcedures"])
                    this.referenceProcedures!.push(item);
            }
            if (Array.isArray(_data["referenceDocuments"])) {
                this.referenceDocuments = [] as any;
                for (let item of _data["referenceDocuments"])
                    this.referenceDocuments!.push(item);
            }
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProcedureStepTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureStepTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["laborTime"] = this.laborTime;
        if (Array.isArray(this.referenceProcedures)) {
            data["referenceProcedures"] = [];
            for (let item of this.referenceProcedures)
                data["referenceProcedures"].push(item);
        }
        if (Array.isArray(this.referenceDocuments)) {
            data["referenceDocuments"] = [];
            for (let item of this.referenceDocuments)
                data["referenceDocuments"].push(item);
        }
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        data["comments"] = this.comments;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/**  */
export interface ICreateProcedureStepTemplateRequest {
    /** Title */
    title?: string | undefined;
    /** StepText */
    stepText?: string | undefined;
    /** ProcedureStepTypeId (SystemTaskId in the DB) */
    procedureStepTypeId?: number | undefined;
    /** LaborTime */
    laborTime?: number | undefined;
    /** ReferenceProcedures */
    referenceProcedures?: number[] | undefined;
    /** ReferenceDocuments */
    referenceDocuments?: number[] | undefined;
    /** EquipmentTime */
    equipmentTime?: number | undefined;
    /** ReplacementCost */
    replacementCost?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Utilization Time */
    utilization?: number | undefined;
    /** UsefulLife */
    usefulLife?: number | undefined;
    /** Comments */
    comments?: string | undefined;
    /** Role list */
    roles?: number[] | undefined;
    /** ReferenceFileIds - Existing fileIds */
    referenceFileIds?: number[] | undefined;
    /** ReferenceFiles - new files */
    referenceFiles?: FileModel[] | undefined;
}

/**  */
export class UpdateProcedureStepTemplateRequest implements IUpdateProcedureStepTemplateRequest {
    /** ProcedureStepTemplate Id */
    id!: number;
    /** Title */
    title?: string | undefined;
    /** StepText */
    stepText?: string | undefined;
    /** ProcedureStepTypeId (SystemTaskId in the DB) */
    procedureStepTypeId?: number | undefined;
    /** LaborTime */
    laborTime?: number | undefined;
    /** ReferenceProcedures */
    referenceProcedures?: number[] | undefined;
    /** ReferenceDocuments */
    referenceDocuments?: number[] | undefined;
    /** EquipmentTime */
    equipmentTime?: number | undefined;
    /** ReplacementCost */
    replacementCost?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Utilization Time */
    utilization?: number | undefined;
    /** UsefulLife */
    usefulLife?: number | undefined;
    /** Comments */
    comments?: string | undefined;
    /** Role list */
    roles?: number[] | undefined;
    /** ReferenceFileIds - Existing fileIds */
    referenceFileIds?: number[] | undefined;
    /** ReferenceFiles - new files */
    referenceFiles?: FileModel[] | undefined;

    constructor(data?: IUpdateProcedureStepTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.laborTime = _data["laborTime"];
            if (Array.isArray(_data["referenceProcedures"])) {
                this.referenceProcedures = [] as any;
                for (let item of _data["referenceProcedures"])
                    this.referenceProcedures!.push(item);
            }
            if (Array.isArray(_data["referenceDocuments"])) {
                this.referenceDocuments = [] as any;
                for (let item of _data["referenceDocuments"])
                    this.referenceDocuments!.push(item);
            }
            this.equipmentTime = _data["equipmentTime"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["referenceFileIds"])) {
                this.referenceFileIds = [] as any;
                for (let item of _data["referenceFileIds"])
                    this.referenceFileIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProcedureStepTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureStepTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["laborTime"] = this.laborTime;
        if (Array.isArray(this.referenceProcedures)) {
            data["referenceProcedures"] = [];
            for (let item of this.referenceProcedures)
                data["referenceProcedures"].push(item);
        }
        if (Array.isArray(this.referenceDocuments)) {
            data["referenceDocuments"] = [];
            for (let item of this.referenceDocuments)
                data["referenceDocuments"].push(item);
        }
        data["equipmentTime"] = this.equipmentTime;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        data["comments"] = this.comments;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.referenceFileIds)) {
            data["referenceFileIds"] = [];
            for (let item of this.referenceFileIds)
                data["referenceFileIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/**  */
export interface IUpdateProcedureStepTemplateRequest {
    /** ProcedureStepTemplate Id */
    id: number;
    /** Title */
    title?: string | undefined;
    /** StepText */
    stepText?: string | undefined;
    /** ProcedureStepTypeId (SystemTaskId in the DB) */
    procedureStepTypeId?: number | undefined;
    /** LaborTime */
    laborTime?: number | undefined;
    /** ReferenceProcedures */
    referenceProcedures?: number[] | undefined;
    /** ReferenceDocuments */
    referenceDocuments?: number[] | undefined;
    /** EquipmentTime */
    equipmentTime?: number | undefined;
    /** ReplacementCost */
    replacementCost?: number | undefined;
    /** Price */
    price?: number | undefined;
    /** SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Utilization Time */
    utilization?: number | undefined;
    /** UsefulLife */
    usefulLife?: number | undefined;
    /** Comments */
    comments?: string | undefined;
    /** Role list */
    roles?: number[] | undefined;
    /** ReferenceFileIds - Existing fileIds */
    referenceFileIds?: number[] | undefined;
    /** ReferenceFiles - new files */
    referenceFiles?: FileModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfProcedureStepTypeModel extends AuditActionResult implements IAuditActionResultOfICollectionOfProcedureStepTypeModel {
    object?: ProcedureStepTypeModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfProcedureStepTypeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ProcedureStepTypeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfProcedureStepTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfProcedureStepTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfProcedureStepTypeModel extends IAuditActionResult {
    object?: ProcedureStepTypeModel[] | undefined;
}

export class ProcedureStepTypeModel implements IProcedureStepTypeModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IProcedureStepTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcedureStepTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureStepTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProcedureStepTypeModel {
    id?: number;
    name?: string | undefined;
}

/**  */
export class CreateProcedureTemplateRequest implements ICreateProcedureTemplateRequest {
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets BaseStartOnCounter */
    baseStartOnCounter?: boolean | undefined;
    /** Gets or Sets EstimatedStepDuration */
    estimatedStepDuration?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets Utilization */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets Text */
    text?: string | undefined;
    /** Gets or Sets ProcedureStepId */
    procedureStepId?: number | undefined;
    /** Gets or Sets NumberOfQuestionsToUse */
    numberOfQuestionsToUse?: number | undefined;
    /** Gets or Sets Comments */
    comments?: string | undefined;
    /** Gets or Sets ReferenceProcedures */
    referenceProcedures?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceDocuments */
    referenceDocuments?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets Roles */
    roles?: number[] | undefined;

    constructor(data?: ICreateProcedureTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.baseStartOnCounter = _data["baseStartOnCounter"];
            this.estimatedStepDuration = _data["estimatedStepDuration"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            this.text = _data["text"];
            this.procedureStepId = _data["procedureStepId"];
            this.numberOfQuestionsToUse = _data["numberOfQuestionsToUse"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["referenceProcedures"])) {
                this.referenceProcedures = [] as any;
                for (let item of _data["referenceProcedures"])
                    this.referenceProcedures!.push(item);
            }
            if (Array.isArray(_data["referenceDocuments"])) {
                this.referenceDocuments = [] as any;
                for (let item of _data["referenceDocuments"])
                    this.referenceDocuments!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateProcedureTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["baseStartOnCounter"] = this.baseStartOnCounter;
        data["estimatedStepDuration"] = this.estimatedStepDuration;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        data["text"] = this.text;
        data["procedureStepId"] = this.procedureStepId;
        data["numberOfQuestionsToUse"] = this.numberOfQuestionsToUse;
        data["comments"] = this.comments;
        if (Array.isArray(this.referenceProcedures)) {
            data["referenceProcedures"] = [];
            for (let item of this.referenceProcedures)
                data["referenceProcedures"].push(item);
        }
        if (Array.isArray(this.referenceDocuments)) {
            data["referenceDocuments"] = [];
            for (let item of this.referenceDocuments)
                data["referenceDocuments"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

/**  */
export interface ICreateProcedureTemplateRequest {
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets BaseStartOnCounter */
    baseStartOnCounter?: boolean | undefined;
    /** Gets or Sets EstimatedStepDuration */
    estimatedStepDuration?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets Utilization */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets Text */
    text?: string | undefined;
    /** Gets or Sets ProcedureStepId */
    procedureStepId?: number | undefined;
    /** Gets or Sets NumberOfQuestionsToUse */
    numberOfQuestionsToUse?: number | undefined;
    /** Gets or Sets Comments */
    comments?: string | undefined;
    /** Gets or Sets ReferenceProcedures */
    referenceProcedures?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceDocuments */
    referenceDocuments?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets Roles */
    roles?: number[] | undefined;
}

/**  */
export class UpdateProcedureTemplateRequest implements IUpdateProcedureTemplateRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets BaseStartOnCounter */
    baseStartOnCounter?: boolean | undefined;
    /** Gets or Sets EstimatedStepDuration */
    estimatedStepDuration?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets Utilization */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets Text */
    text?: string | undefined;
    /** Gets or Sets ProcedureStepId */
    procedureStepId?: number | undefined;
    /** Gets or Sets NumberOfQuestionsToUse */
    numberOfQuestionsToUse?: number | undefined;
    /** Gets or Sets Comments */
    comments?: string | undefined;
    /** Gets or Sets ReferenceDocuments */
    referenceDocuments?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets Roles */
    roles?: number[] | undefined;

    constructor(data?: IUpdateProcedureTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.baseStartOnCounter = _data["baseStartOnCounter"];
            this.estimatedStepDuration = _data["estimatedStepDuration"];
            this.replacementCost = _data["replacementCost"];
            this.price = _data["price"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.utilization = _data["utilization"];
            this.usefulLife = _data["usefulLife"];
            this.text = _data["text"];
            this.procedureStepId = _data["procedureStepId"];
            this.numberOfQuestionsToUse = _data["numberOfQuestionsToUse"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["referenceDocuments"])) {
                this.referenceDocuments = [] as any;
                for (let item of _data["referenceDocuments"])
                    this.referenceDocuments!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileRequest.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProcedureTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["baseStartOnCounter"] = this.baseStartOnCounter;
        data["estimatedStepDuration"] = this.estimatedStepDuration;
        data["replacementCost"] = this.replacementCost;
        data["price"] = this.price;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["utilization"] = this.utilization;
        data["usefulLife"] = this.usefulLife;
        data["text"] = this.text;
        data["procedureStepId"] = this.procedureStepId;
        data["numberOfQuestionsToUse"] = this.numberOfQuestionsToUse;
        data["comments"] = this.comments;
        if (Array.isArray(this.referenceDocuments)) {
            data["referenceDocuments"] = [];
            for (let item of this.referenceDocuments)
                data["referenceDocuments"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

/**  */
export interface IUpdateProcedureTemplateRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Title */
    title?: string | undefined;
    /** Gets or Sets BaseStartOnCounter */
    baseStartOnCounter?: boolean | undefined;
    /** Gets or Sets EstimatedStepDuration */
    estimatedStepDuration?: number | undefined;
    /** Gets or Sets ReplacementCost */
    replacementCost?: number | undefined;
    /** Gets or Sets Price */
    price?: number | undefined;
    /** Gets or Sets SpecialActionEnabled */
    specialActionEnabled?: number | undefined;
    /** Gets or Sets Utilization */
    utilization?: number | undefined;
    /** Gets or Sets UsefulLife */
    usefulLife?: number | undefined;
    /** Gets or Sets Text */
    text?: string | undefined;
    /** Gets or Sets ProcedureStepId */
    procedureStepId?: number | undefined;
    /** Gets or Sets NumberOfQuestionsToUse */
    numberOfQuestionsToUse?: number | undefined;
    /** Gets or Sets Comments */
    comments?: string | undefined;
    /** Gets or Sets ReferenceDocuments */
    referenceDocuments?: (number | undefined)[] | undefined;
    /** Gets or Sets ReferenceFiles */
    referenceFiles?: FileRequest[] | undefined;
    /** Gets or Sets Roles */
    roles?: number[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfProcedureType extends AuditActionResult implements IAuditActionResultOfProcedureType {
    object?: ProcedureType | undefined;

    constructor(data?: IAuditActionResultOfProcedureType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? ProcedureType.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfProcedureType {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfProcedureType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfProcedureType extends IAuditActionResult {
    object?: ProcedureType | undefined;
}

/**  */
export class CreateProcedureTypeRequest implements ICreateProcedureTypeRequest {
    /** Gets or Sets Name */
    name!: string;

    constructor(data?: ICreateProcedureTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateProcedureTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedureTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

/**  */
export interface ICreateProcedureTypeRequest {
    /** Gets or Sets Name */
    name: string;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfProcedureType extends AuditActionResult implements IAuditActionResultOfICollectionOfProcedureType {
    object?: ProcedureType[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfProcedureType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ProcedureType.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfProcedureType {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfProcedureType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfProcedureType extends IAuditActionResult {
    object?: ProcedureType[] | undefined;
}

/**  */
export class UpdateProcedureTypeRequest implements IUpdateProcedureTypeRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;

    constructor(data?: IUpdateProcedureTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateProcedureTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/**  */
export interface IUpdateProcedureTypeRequest {
    /** Gets or Sets Id */
    id?: number | undefined;
    /** Gets or Sets Name */
    name?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPurchaseModel extends AuditActionResult implements IAuditActionResultOfICollectionOfPurchaseModel {
    object?: PurchaseModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPurchaseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PurchaseModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPurchaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPurchaseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPurchaseModel extends IAuditActionResult {
    object?: PurchaseModel[] | undefined;
}

export class PurchaseModel extends CreatableModel implements IPurchaseModel {
    purchaseOrderId?: number;
    customerPurchaseNumber?: string | undefined;
    purchasePrice?: number;
    statusId?: number;
    serializeIndividually?: boolean;
    status?: StatusModel | undefined;
    workOrders?: WorkOrderModel[] | undefined;
    parts?: PurchaseOrderPartView[] | undefined;
    purchaseParts?: string | undefined;
    detailPackingListParts?: DetailPackingListPartView[] | undefined;
    customerId?: number | undefined;
    shippingMethod?: string | undefined;
    trackingNumber?: string | undefined;
    customer?: CustomerModel | undefined;
    customerDepartmentId?: number | undefined;
    customerDepartment?: CustomerDepartmentModel | undefined;
    purchaseOrder?: PurchaseOrderModel | undefined;

    constructor(data?: IPurchaseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.customerPurchaseNumber = _data["customerPurchaseNumber"];
            this.purchasePrice = _data["purchasePrice"];
            this.statusId = _data["statusId"];
            this.serializeIndividually = _data["serializeIndividually"];
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["workOrders"])) {
                this.workOrders = [] as any;
                for (let item of _data["workOrders"])
                    this.workOrders!.push(WorkOrderModel.fromJS(item));
            }
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(PurchaseOrderPartView.fromJS(item));
            }
            this.purchaseParts = _data["purchaseParts"];
            if (Array.isArray(_data["detailPackingListParts"])) {
                this.detailPackingListParts = [] as any;
                for (let item of _data["detailPackingListParts"])
                    this.detailPackingListParts!.push(DetailPackingListPartView.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.shippingMethod = _data["shippingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.customerDepartmentId = _data["customerDepartmentId"];
            this.customerDepartment = _data["customerDepartment"] ? CustomerDepartmentModel.fromJS(_data["customerDepartment"]) : undefined as any;
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrderModel.fromJS(_data["purchaseOrder"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PurchaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["customerPurchaseNumber"] = this.customerPurchaseNumber;
        data["purchasePrice"] = this.purchasePrice;
        data["statusId"] = this.statusId;
        data["serializeIndividually"] = this.serializeIndividually;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.workOrders)) {
            data["workOrders"] = [];
            for (let item of this.workOrders)
                data["workOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        data["purchaseParts"] = this.purchaseParts;
        if (Array.isArray(this.detailPackingListParts)) {
            data["detailPackingListParts"] = [];
            for (let item of this.detailPackingListParts)
                data["detailPackingListParts"].push(item ? item.toJSON() : undefined as any);
        }
        data["customerId"] = this.customerId;
        data["shippingMethod"] = this.shippingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["customerDepartmentId"] = this.customerDepartmentId;
        data["customerDepartment"] = this.customerDepartment ? this.customerDepartment.toJSON() : undefined as any;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseModel extends ICreatableModel {
    purchaseOrderId?: number;
    customerPurchaseNumber?: string | undefined;
    purchasePrice?: number;
    statusId?: number;
    serializeIndividually?: boolean;
    status?: StatusModel | undefined;
    workOrders?: WorkOrderModel[] | undefined;
    parts?: PurchaseOrderPartView[] | undefined;
    purchaseParts?: string | undefined;
    detailPackingListParts?: DetailPackingListPartView[] | undefined;
    customerId?: number | undefined;
    shippingMethod?: string | undefined;
    trackingNumber?: string | undefined;
    customer?: CustomerModel | undefined;
    customerDepartmentId?: number | undefined;
    customerDepartment?: CustomerDepartmentModel | undefined;
    purchaseOrder?: PurchaseOrderModel | undefined;
}

export class WorkOrderModel implements IWorkOrderModel {
    id?: number | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    price?: number | undefined;
    scheduledStartDate?: Date | undefined;
    scheduledEndDate?: Date | undefined;
    scheduledEndDateChangeReason?: string | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    hasNCR?: boolean | undefined;
    locationId?: number | undefined;
    status?: string | undefined;
    location?: LocationModel | undefined;
    partId?: number | undefined;
    part?: PartModel | undefined;
    shipped?: boolean;
    purchaseId?: number | undefined;
    purchase?: PurchaseModel | undefined;
    workOrderParts?: WorkOrderPartModel[] | undefined;
    workOrderTasks?: WorkOrderTaskModel[] | undefined;
    workOrderMessages?: WorkOrderMessageModel[] | undefined;
    workOrderPartNCRs?: WorkOrderPartNCRModel[] | undefined;
    hasSubParts?: boolean;
    customerLastRespondent?: boolean | undefined;
    invoiceable?: boolean | undefined;

    constructor(data?: IWorkOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.customerAddress = _data["customerAddress"];
            this.price = _data["price"];
            this.scheduledStartDate = _data["scheduledStartDate"] ? new Date(_data["scheduledStartDate"].toString()) : undefined as any;
            this.scheduledEndDate = _data["scheduledEndDate"] ? new Date(_data["scheduledEndDate"].toString()) : undefined as any;
            this.scheduledEndDateChangeReason = _data["scheduledEndDateChangeReason"];
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.hasNCR = _data["hasNCR"];
            this.locationId = _data["locationId"];
            this.status = _data["status"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
            this.partId = _data["partId"];
            this.part = _data["part"] ? PartModel.fromJS(_data["part"]) : undefined as any;
            this.shipped = _data["shipped"];
            this.purchaseId = _data["purchaseId"];
            this.purchase = _data["purchase"] ? PurchaseModel.fromJS(_data["purchase"]) : undefined as any;
            if (Array.isArray(_data["workOrderParts"])) {
                this.workOrderParts = [] as any;
                for (let item of _data["workOrderParts"])
                    this.workOrderParts!.push(WorkOrderPartModel.fromJS(item));
            }
            if (Array.isArray(_data["workOrderTasks"])) {
                this.workOrderTasks = [] as any;
                for (let item of _data["workOrderTasks"])
                    this.workOrderTasks!.push(WorkOrderTaskModel.fromJS(item));
            }
            if (Array.isArray(_data["workOrderMessages"])) {
                this.workOrderMessages = [] as any;
                for (let item of _data["workOrderMessages"])
                    this.workOrderMessages!.push(WorkOrderMessageModel.fromJS(item));
            }
            if (Array.isArray(_data["workOrderPartNCRs"])) {
                this.workOrderPartNCRs = [] as any;
                for (let item of _data["workOrderPartNCRs"])
                    this.workOrderPartNCRs!.push(WorkOrderPartNCRModel.fromJS(item));
            }
            this.hasSubParts = _data["hasSubParts"];
            this.customerLastRespondent = _data["customerLastRespondent"];
            this.invoiceable = _data["invoiceable"];
        }
    }

    static fromJS(data: any): WorkOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["customerAddress"] = this.customerAddress;
        data["price"] = this.price;
        data["scheduledStartDate"] = this.scheduledStartDate ? this.scheduledStartDate.toISOString() : undefined as any;
        data["scheduledEndDate"] = this.scheduledEndDate ? this.scheduledEndDate.toISOString() : undefined as any;
        data["scheduledEndDateChangeReason"] = this.scheduledEndDateChangeReason;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["hasNCR"] = this.hasNCR;
        data["locationId"] = this.locationId;
        data["status"] = this.status;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["partId"] = this.partId;
        data["part"] = this.part ? this.part.toJSON() : undefined as any;
        data["shipped"] = this.shipped;
        data["purchaseId"] = this.purchaseId;
        data["purchase"] = this.purchase ? this.purchase.toJSON() : undefined as any;
        if (Array.isArray(this.workOrderParts)) {
            data["workOrderParts"] = [];
            for (let item of this.workOrderParts)
                data["workOrderParts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrderTasks)) {
            data["workOrderTasks"] = [];
            for (let item of this.workOrderTasks)
                data["workOrderTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrderMessages)) {
            data["workOrderMessages"] = [];
            for (let item of this.workOrderMessages)
                data["workOrderMessages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrderPartNCRs)) {
            data["workOrderPartNCRs"] = [];
            for (let item of this.workOrderPartNCRs)
                data["workOrderPartNCRs"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasSubParts"] = this.hasSubParts;
        data["customerLastRespondent"] = this.customerLastRespondent;
        data["invoiceable"] = this.invoiceable;
        return data;
    }
}

export interface IWorkOrderModel {
    id?: number | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    price?: number | undefined;
    scheduledStartDate?: Date | undefined;
    scheduledEndDate?: Date | undefined;
    scheduledEndDateChangeReason?: string | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    hasNCR?: boolean | undefined;
    locationId?: number | undefined;
    status?: string | undefined;
    location?: LocationModel | undefined;
    partId?: number | undefined;
    part?: PartModel | undefined;
    shipped?: boolean;
    purchaseId?: number | undefined;
    purchase?: PurchaseModel | undefined;
    workOrderParts?: WorkOrderPartModel[] | undefined;
    workOrderTasks?: WorkOrderTaskModel[] | undefined;
    workOrderMessages?: WorkOrderMessageModel[] | undefined;
    workOrderPartNCRs?: WorkOrderPartNCRModel[] | undefined;
    hasSubParts?: boolean;
    customerLastRespondent?: boolean | undefined;
    invoiceable?: boolean | undefined;
}

export class WorkOrderPartModel implements IWorkOrderPartModel {
    id?: number;
    workOrderId?: number;
    partId?: number;
    cycleCount?: number;
    parentId?: number | undefined;
    serialNumber?: string | undefined;
    customerLineNumber?: string | undefined;
    qty?: number | undefined;
    segregationType?: EnumSegregationType | undefined;
    part?: PartModel | undefined;
    workOrder?: WorkOrderModel | undefined;
    children?: WorkOrderPartModel[] | undefined;
    parent?: WorkOrderPartModel | undefined;
    ncrHistoryItems?: NCRHistoryItemModel[] | undefined;
    tagType?: string | undefined;
    ncNumber?: string | undefined;
    dataMatrix?: string | undefined;
    detail?: string | undefined;
    partNumber?: string | undefined;
    name?: string | undefined;
    partData?: string | undefined;
    actualPONumber?: string | undefined;
    poNumber?: string | undefined;
    note?: string | undefined;
    isActive?: boolean | undefined;
    removedOn?: Date | undefined;
    hasNCR?: boolean | undefined;
    ncrIsClosed?: boolean | undefined;
    currentLocation?: string | undefined;
    mttn?: string | undefined;
    packagingId?: string | undefined;
    workOrderPartMonitors?: WorkOrderPartMonitorModel[] | undefined;
    workOrderPartNCRs?: WorkOrderPartNCRModel[] | undefined;
    partLocationHistory?: PartLocationHistoryModel[] | undefined;
    status?: string | undefined;

    constructor(data?: IWorkOrderPartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            this.partId = _data["partId"];
            this.cycleCount = _data["cycleCount"];
            this.parentId = _data["parentId"];
            this.serialNumber = _data["serialNumber"];
            this.customerLineNumber = _data["customerLineNumber"];
            this.qty = _data["qty"];
            this.segregationType = _data["segregationType"];
            this.part = _data["part"] ? PartModel.fromJS(_data["part"]) : undefined as any;
            this.workOrder = _data["workOrder"] ? WorkOrderModel.fromJS(_data["workOrder"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(WorkOrderPartModel.fromJS(item));
            }
            this.parent = _data["parent"] ? WorkOrderPartModel.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["ncrHistoryItems"])) {
                this.ncrHistoryItems = [] as any;
                for (let item of _data["ncrHistoryItems"])
                    this.ncrHistoryItems!.push(NCRHistoryItemModel.fromJS(item));
            }
            this.tagType = _data["tagType"];
            this.ncNumber = _data["ncNumber"];
            this.dataMatrix = _data["dataMatrix"];
            this.detail = _data["detail"];
            this.partNumber = _data["partNumber"];
            this.name = _data["name"];
            this.partData = _data["partData"];
            this.actualPONumber = _data["actualPONumber"];
            this.poNumber = _data["poNumber"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.removedOn = _data["removedOn"] ? new Date(_data["removedOn"].toString()) : undefined as any;
            this.hasNCR = _data["hasNCR"];
            this.ncrIsClosed = _data["ncrIsClosed"];
            this.currentLocation = _data["currentLocation"];
            this.mttn = _data["mttn"];
            this.packagingId = _data["packagingId"];
            if (Array.isArray(_data["workOrderPartMonitors"])) {
                this.workOrderPartMonitors = [] as any;
                for (let item of _data["workOrderPartMonitors"])
                    this.workOrderPartMonitors!.push(WorkOrderPartMonitorModel.fromJS(item));
            }
            if (Array.isArray(_data["workOrderPartNCRs"])) {
                this.workOrderPartNCRs = [] as any;
                for (let item of _data["workOrderPartNCRs"])
                    this.workOrderPartNCRs!.push(WorkOrderPartNCRModel.fromJS(item));
            }
            if (Array.isArray(_data["partLocationHistory"])) {
                this.partLocationHistory = [] as any;
                for (let item of _data["partLocationHistory"])
                    this.partLocationHistory!.push(PartLocationHistoryModel.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WorkOrderPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        data["partId"] = this.partId;
        data["cycleCount"] = this.cycleCount;
        data["parentId"] = this.parentId;
        data["serialNumber"] = this.serialNumber;
        data["customerLineNumber"] = this.customerLineNumber;
        data["qty"] = this.qty;
        data["segregationType"] = this.segregationType;
        data["part"] = this.part ? this.part.toJSON() : undefined as any;
        data["workOrder"] = this.workOrder ? this.workOrder.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.ncrHistoryItems)) {
            data["ncrHistoryItems"] = [];
            for (let item of this.ncrHistoryItems)
                data["ncrHistoryItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["tagType"] = this.tagType;
        data["ncNumber"] = this.ncNumber;
        data["dataMatrix"] = this.dataMatrix;
        data["detail"] = this.detail;
        data["partNumber"] = this.partNumber;
        data["name"] = this.name;
        data["partData"] = this.partData;
        data["actualPONumber"] = this.actualPONumber;
        data["poNumber"] = this.poNumber;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["removedOn"] = this.removedOn ? this.removedOn.toISOString() : undefined as any;
        data["hasNCR"] = this.hasNCR;
        data["ncrIsClosed"] = this.ncrIsClosed;
        data["currentLocation"] = this.currentLocation;
        data["mttn"] = this.mttn;
        data["packagingId"] = this.packagingId;
        if (Array.isArray(this.workOrderPartMonitors)) {
            data["workOrderPartMonitors"] = [];
            for (let item of this.workOrderPartMonitors)
                data["workOrderPartMonitors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrderPartNCRs)) {
            data["workOrderPartNCRs"] = [];
            for (let item of this.workOrderPartNCRs)
                data["workOrderPartNCRs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partLocationHistory)) {
            data["partLocationHistory"] = [];
            for (let item of this.partLocationHistory)
                data["partLocationHistory"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IWorkOrderPartModel {
    id?: number;
    workOrderId?: number;
    partId?: number;
    cycleCount?: number;
    parentId?: number | undefined;
    serialNumber?: string | undefined;
    customerLineNumber?: string | undefined;
    qty?: number | undefined;
    segregationType?: EnumSegregationType | undefined;
    part?: PartModel | undefined;
    workOrder?: WorkOrderModel | undefined;
    children?: WorkOrderPartModel[] | undefined;
    parent?: WorkOrderPartModel | undefined;
    ncrHistoryItems?: NCRHistoryItemModel[] | undefined;
    tagType?: string | undefined;
    ncNumber?: string | undefined;
    dataMatrix?: string | undefined;
    detail?: string | undefined;
    partNumber?: string | undefined;
    name?: string | undefined;
    partData?: string | undefined;
    actualPONumber?: string | undefined;
    poNumber?: string | undefined;
    note?: string | undefined;
    isActive?: boolean | undefined;
    removedOn?: Date | undefined;
    hasNCR?: boolean | undefined;
    ncrIsClosed?: boolean | undefined;
    currentLocation?: string | undefined;
    mttn?: string | undefined;
    packagingId?: string | undefined;
    workOrderPartMonitors?: WorkOrderPartMonitorModel[] | undefined;
    workOrderPartNCRs?: WorkOrderPartNCRModel[] | undefined;
    partLocationHistory?: PartLocationHistoryModel[] | undefined;
    status?: string | undefined;
}

export class NCRHistoryItemModel implements INCRHistoryItemModel {
    workOrderId?: number;
    title?: string | undefined;
    workOrderPartId?: number;
    partId?: number;
    serialNumber?: string | undefined;

    constructor(data?: INCRHistoryItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.title = _data["title"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.partId = _data["partId"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): NCRHistoryItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new NCRHistoryItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["title"] = this.title;
        data["workOrderPartId"] = this.workOrderPartId;
        data["partId"] = this.partId;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface INCRHistoryItemModel {
    workOrderId?: number;
    title?: string | undefined;
    workOrderPartId?: number;
    partId?: number;
    serialNumber?: string | undefined;
}

export class WorkOrderPartMonitorModel implements IWorkOrderPartMonitorModel {
    id?: number;
    workOrderPartId?: number;
    partMonitorId?: number | undefined;
    numVal?: number | undefined;
    textVal?: string | undefined;
    multiVal?: string | undefined;
    sensorMappingId?: number | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    target?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    monitorTypeId?: number | undefined;
    monitorTypeName?: string | undefined;
    inputTypeId?: number | undefined;
    lowNumVal?: number | undefined;
    highNumVal?: number | undefined;
    displayInReports?: boolean | undefined;
    status?: string | undefined;
    unitofMeasureName?: string | undefined;

    constructor(data?: IWorkOrderPartMonitorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.partMonitorId = _data["partMonitorId"];
            this.numVal = _data["numVal"];
            this.textVal = _data["textVal"];
            this.multiVal = _data["multiVal"];
            this.sensorMappingId = _data["sensorMappingId"];
            this.comment = _data["comment"];
            this.description = _data["description"];
            this.monitorListId = _data["monitorListId"];
            this.shouldBe = _data["shouldBe"];
            this.highTarget = _data["highTarget"];
            this.lowTarget = _data["lowTarget"];
            this.target = _data["target"];
            this.sciTarget = _data["sciTarget"];
            this.sciLowTarget = _data["sciLowTarget"];
            this.sciHighTarget = _data["sciHighTarget"];
            this.failAction = _data["failAction"];
            this.sensorName = _data["sensorName"];
            this.monitorTypeId = _data["monitorTypeId"];
            this.monitorTypeName = _data["monitorTypeName"];
            this.inputTypeId = _data["inputTypeId"];
            this.lowNumVal = _data["lowNumVal"];
            this.highNumVal = _data["highNumVal"];
            this.displayInReports = _data["displayInReports"];
            this.status = _data["status"];
            this.unitofMeasureName = _data["unitofMeasureName"];
        }
    }

    static fromJS(data: any): WorkOrderPartMonitorModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartMonitorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderPartId"] = this.workOrderPartId;
        data["partMonitorId"] = this.partMonitorId;
        data["numVal"] = this.numVal;
        data["textVal"] = this.textVal;
        data["multiVal"] = this.multiVal;
        data["sensorMappingId"] = this.sensorMappingId;
        data["comment"] = this.comment;
        data["description"] = this.description;
        data["monitorListId"] = this.monitorListId;
        data["shouldBe"] = this.shouldBe;
        data["highTarget"] = this.highTarget;
        data["lowTarget"] = this.lowTarget;
        data["target"] = this.target;
        data["sciTarget"] = this.sciTarget;
        data["sciLowTarget"] = this.sciLowTarget;
        data["sciHighTarget"] = this.sciHighTarget;
        data["failAction"] = this.failAction;
        data["sensorName"] = this.sensorName;
        data["monitorTypeId"] = this.monitorTypeId;
        data["monitorTypeName"] = this.monitorTypeName;
        data["inputTypeId"] = this.inputTypeId;
        data["lowNumVal"] = this.lowNumVal;
        data["highNumVal"] = this.highNumVal;
        data["displayInReports"] = this.displayInReports;
        data["status"] = this.status;
        data["unitofMeasureName"] = this.unitofMeasureName;
        return data;
    }
}

export interface IWorkOrderPartMonitorModel {
    id?: number;
    workOrderPartId?: number;
    partMonitorId?: number | undefined;
    numVal?: number | undefined;
    textVal?: string | undefined;
    multiVal?: string | undefined;
    sensorMappingId?: number | undefined;
    comment?: string | undefined;
    description?: string | undefined;
    monitorListId?: number | undefined;
    shouldBe?: string | undefined;
    highTarget?: number | undefined;
    lowTarget?: number | undefined;
    target?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
    failAction?: string | undefined;
    sensorName?: string | undefined;
    monitorTypeId?: number | undefined;
    monitorTypeName?: string | undefined;
    inputTypeId?: number | undefined;
    lowNumVal?: number | undefined;
    highNumVal?: number | undefined;
    displayInReports?: boolean | undefined;
    status?: string | undefined;
    unitofMeasureName?: string | undefined;
}

export class WorkOrderPartNCRModel implements IWorkOrderPartNCRModel {
    id?: number;
    workOrderId?: number;
    workOrderPartIds?: number[] | undefined;
    linkedParts?: WorkOrderPartNCRLinkedPartModel[] | undefined;
    typeId?: number | undefined;
    typeName?: string | undefined;
    type?: NCTypeModel | undefined;
    tagType?: string | undefined;
    description?: string | undefined;
    recommendation?: string | undefined;
    disposition?: string | undefined;
    closedOn?: Date | undefined;
    createdOn?: Date;
    createdBy?: number;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: number | undefined;
    lastUpdated?: UserModel | undefined;
    emailLogs?: WorkOrderPartNCREmailLogModel[] | undefined;
    files?: FileModel[] | undefined;

    constructor(data?: IWorkOrderPartNCRModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            if (Array.isArray(_data["workOrderPartIds"])) {
                this.workOrderPartIds = [] as any;
                for (let item of _data["workOrderPartIds"])
                    this.workOrderPartIds!.push(item);
            }
            if (Array.isArray(_data["linkedParts"])) {
                this.linkedParts = [] as any;
                for (let item of _data["linkedParts"])
                    this.linkedParts!.push(WorkOrderPartNCRLinkedPartModel.fromJS(item));
            }
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.type = _data["type"] ? NCTypeModel.fromJS(_data["type"]) : undefined as any;
            this.tagType = _data["tagType"];
            this.description = _data["description"];
            this.recommendation = _data["recommendation"];
            this.disposition = _data["disposition"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdated = _data["lastUpdated"] ? UserModel.fromJS(_data["lastUpdated"]) : undefined as any;
            if (Array.isArray(_data["emailLogs"])) {
                this.emailLogs = [] as any;
                for (let item of _data["emailLogs"])
                    this.emailLogs!.push(WorkOrderPartNCREmailLogModel.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderPartNCRModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartNCRModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        if (Array.isArray(this.workOrderPartIds)) {
            data["workOrderPartIds"] = [];
            for (let item of this.workOrderPartIds)
                data["workOrderPartIds"].push(item);
        }
        if (Array.isArray(this.linkedParts)) {
            data["linkedParts"] = [];
            for (let item of this.linkedParts)
                data["linkedParts"].push(item ? item.toJSON() : undefined as any);
        }
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["tagType"] = this.tagType;
        data["description"] = this.description;
        data["recommendation"] = this.recommendation;
        data["disposition"] = this.disposition;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toJSON() : undefined as any;
        if (Array.isArray(this.emailLogs)) {
            data["emailLogs"] = [];
            for (let item of this.emailLogs)
                data["emailLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkOrderPartNCRModel {
    id?: number;
    workOrderId?: number;
    workOrderPartIds?: number[] | undefined;
    linkedParts?: WorkOrderPartNCRLinkedPartModel[] | undefined;
    typeId?: number | undefined;
    typeName?: string | undefined;
    type?: NCTypeModel | undefined;
    tagType?: string | undefined;
    description?: string | undefined;
    recommendation?: string | undefined;
    disposition?: string | undefined;
    closedOn?: Date | undefined;
    createdOn?: Date;
    createdBy?: number;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: number | undefined;
    lastUpdated?: UserModel | undefined;
    emailLogs?: WorkOrderPartNCREmailLogModel[] | undefined;
    files?: FileModel[] | undefined;
}

export class WorkOrderPartNCRLinkedPartModel implements IWorkOrderPartNCRLinkedPartModel {
    workOrderPartId?: number;
    partNumber?: string | undefined;
    oemPartNumber?: string | undefined;
    serialNumber?: string | undefined;
    tagType?: string | undefined;

    constructor(data?: IWorkOrderPartNCRLinkedPartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartId = _data["workOrderPartId"];
            this.partNumber = _data["partNumber"];
            this.oemPartNumber = _data["oemPartNumber"];
            this.serialNumber = _data["serialNumber"];
            this.tagType = _data["tagType"];
        }
    }

    static fromJS(data: any): WorkOrderPartNCRLinkedPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartNCRLinkedPartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartId"] = this.workOrderPartId;
        data["partNumber"] = this.partNumber;
        data["oemPartNumber"] = this.oemPartNumber;
        data["serialNumber"] = this.serialNumber;
        data["tagType"] = this.tagType;
        return data;
    }
}

export interface IWorkOrderPartNCRLinkedPartModel {
    workOrderPartId?: number;
    partNumber?: string | undefined;
    oemPartNumber?: string | undefined;
    serialNumber?: string | undefined;
    tagType?: string | undefined;
}

export class WorkOrderPartNCREmailLogModel implements IWorkOrderPartNCREmailLogModel {
    id?: number;
    workOrderPartNCRId?: number;
    emailRecipient?: string | undefined;
    sentOn?: Date;

    constructor(data?: IWorkOrderPartNCREmailLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderPartNCRId = _data["workOrderPartNCRId"];
            this.emailRecipient = _data["emailRecipient"];
            this.sentOn = _data["sentOn"] ? new Date(_data["sentOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderPartNCREmailLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartNCREmailLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderPartNCRId"] = this.workOrderPartNCRId;
        data["emailRecipient"] = this.emailRecipient;
        data["sentOn"] = this.sentOn ? this.sentOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderPartNCREmailLogModel {
    id?: number;
    workOrderPartNCRId?: number;
    emailRecipient?: string | undefined;
    sentOn?: Date;
}

export class PartLocationHistoryModel implements IPartLocationHistoryModel {
    id?: number;
    workOrderId?: number | undefined;
    workOrderPartId?: number | undefined;
    userName?: string | undefined;
    locationName?: string | undefined;
    partName?: string | undefined;
    oemPartNumber?: string | undefined;
    customerPartNumber?: string | undefined;
    serialNumber?: string | undefined;
    enteredOn?: Date | undefined;
    exitedOn?: Date | undefined;
    removedOn?: Date | undefined;

    constructor(data?: IPartLocationHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.userName = _data["userName"];
            this.locationName = _data["locationName"];
            this.partName = _data["partName"];
            this.oemPartNumber = _data["oemPartNumber"];
            this.customerPartNumber = _data["customerPartNumber"];
            this.serialNumber = _data["serialNumber"];
            this.enteredOn = _data["enteredOn"] ? new Date(_data["enteredOn"].toString()) : undefined as any;
            this.exitedOn = _data["exitedOn"] ? new Date(_data["exitedOn"].toString()) : undefined as any;
            this.removedOn = _data["removedOn"] ? new Date(_data["removedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PartLocationHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PartLocationHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        data["workOrderPartId"] = this.workOrderPartId;
        data["userName"] = this.userName;
        data["locationName"] = this.locationName;
        data["partName"] = this.partName;
        data["oemPartNumber"] = this.oemPartNumber;
        data["customerPartNumber"] = this.customerPartNumber;
        data["serialNumber"] = this.serialNumber;
        data["enteredOn"] = this.enteredOn ? this.enteredOn.toISOString() : undefined as any;
        data["exitedOn"] = this.exitedOn ? this.exitedOn.toISOString() : undefined as any;
        data["removedOn"] = this.removedOn ? this.removedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPartLocationHistoryModel {
    id?: number;
    workOrderId?: number | undefined;
    workOrderPartId?: number | undefined;
    userName?: string | undefined;
    locationName?: string | undefined;
    partName?: string | undefined;
    oemPartNumber?: string | undefined;
    customerPartNumber?: string | undefined;
    serialNumber?: string | undefined;
    enteredOn?: Date | undefined;
    exitedOn?: Date | undefined;
    removedOn?: Date | undefined;
}

export class WorkOrderTaskModel implements IWorkOrderTaskModel {
    id?: number;
    workOrderId?: number;
    procedureStepId?: number | undefined;
    procedureStepTypeId?: number | undefined;
    statusId?: number;
    taskStepOrder?: number;
    assignedTo?: number | undefined;
    assignedToUser?: UserModel | undefined;
    totalTaskTime?: number | undefined;
    taskIsRunning?: boolean | undefined;
    taskStarted?: boolean;
    taskRunningSince?: Date | undefined;
    startedOn?: Date | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    procedureStepType?: ProcedureStepTypeModel | undefined;
    status?: StatusModel | undefined;
    workOrder?: WorkOrderModel | undefined;
    lastUpdatedOn?: Date | undefined;
    referenceFiles?: FileModel[] | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    isNCRTask?: boolean | undefined;
    ncNumber?: string | undefined;
    specialActionEnabled?: number | undefined;
    isRework?: boolean;
    workOrderPartId?: number | undefined;
    reworkPrice?: number | undefined;
    addToWOPrice?: boolean | undefined;
    workOrderPrice?: number | undefined;
    ncrHistoryItems?: NCRHistoryItemModel[] | undefined;
    mappedWorkOrderParts?: MappedWorkOrderPart[] | undefined;

    constructor(data?: IWorkOrderTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            this.procedureStepId = _data["procedureStepId"];
            this.procedureStepTypeId = _data["procedureStepTypeId"];
            this.statusId = _data["statusId"];
            this.taskStepOrder = _data["taskStepOrder"];
            this.assignedTo = _data["assignedTo"];
            this.assignedToUser = _data["assignedToUser"] ? UserModel.fromJS(_data["assignedToUser"]) : undefined as any;
            this.totalTaskTime = _data["totalTaskTime"];
            this.taskIsRunning = _data["taskIsRunning"];
            this.taskStarted = _data["taskStarted"];
            this.taskRunningSince = _data["taskRunningSince"] ? new Date(_data["taskRunningSince"].toString()) : undefined as any;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : undefined as any;
            this.procedureStep = _data["procedureStep"] ? ProcedureStepModel.fromJS(_data["procedureStep"]) : undefined as any;
            this.procedureStepType = _data["procedureStepType"] ? ProcedureStepTypeModel.fromJS(_data["procedureStepType"]) : undefined as any;
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : undefined as any;
            this.workOrder = _data["workOrder"] ? WorkOrderModel.fromJS(_data["workOrder"]) : undefined as any;
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            this.title = _data["title"];
            this.stepText = _data["stepText"];
            this.isNCRTask = _data["isNCRTask"];
            this.ncNumber = _data["ncNumber"];
            this.specialActionEnabled = _data["specialActionEnabled"];
            this.isRework = _data["isRework"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.reworkPrice = _data["reworkPrice"];
            this.addToWOPrice = _data["addToWOPrice"];
            this.workOrderPrice = _data["workOrderPrice"];
            if (Array.isArray(_data["ncrHistoryItems"])) {
                this.ncrHistoryItems = [] as any;
                for (let item of _data["ncrHistoryItems"])
                    this.ncrHistoryItems!.push(NCRHistoryItemModel.fromJS(item));
            }
            if (Array.isArray(_data["mappedWorkOrderParts"])) {
                this.mappedWorkOrderParts = [] as any;
                for (let item of _data["mappedWorkOrderParts"])
                    this.mappedWorkOrderParts!.push(MappedWorkOrderPart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        data["procedureStepId"] = this.procedureStepId;
        data["procedureStepTypeId"] = this.procedureStepTypeId;
        data["statusId"] = this.statusId;
        data["taskStepOrder"] = this.taskStepOrder;
        data["assignedTo"] = this.assignedTo;
        data["assignedToUser"] = this.assignedToUser ? this.assignedToUser.toJSON() : undefined as any;
        data["totalTaskTime"] = this.totalTaskTime;
        data["taskIsRunning"] = this.taskIsRunning;
        data["taskStarted"] = this.taskStarted;
        data["taskRunningSince"] = this.taskRunningSince ? this.taskRunningSince.toISOString() : undefined as any;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["procedureStep"] = this.procedureStep ? this.procedureStep.toJSON() : undefined as any;
        data["procedureStepType"] = this.procedureStepType ? this.procedureStepType.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["workOrder"] = this.workOrder ? this.workOrder.toJSON() : undefined as any;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title;
        data["stepText"] = this.stepText;
        data["isNCRTask"] = this.isNCRTask;
        data["ncNumber"] = this.ncNumber;
        data["specialActionEnabled"] = this.specialActionEnabled;
        data["isRework"] = this.isRework;
        data["workOrderPartId"] = this.workOrderPartId;
        data["reworkPrice"] = this.reworkPrice;
        data["addToWOPrice"] = this.addToWOPrice;
        data["workOrderPrice"] = this.workOrderPrice;
        if (Array.isArray(this.ncrHistoryItems)) {
            data["ncrHistoryItems"] = [];
            for (let item of this.ncrHistoryItems)
                data["ncrHistoryItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mappedWorkOrderParts)) {
            data["mappedWorkOrderParts"] = [];
            for (let item of this.mappedWorkOrderParts)
                data["mappedWorkOrderParts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkOrderTaskModel {
    id?: number;
    workOrderId?: number;
    procedureStepId?: number | undefined;
    procedureStepTypeId?: number | undefined;
    statusId?: number;
    taskStepOrder?: number;
    assignedTo?: number | undefined;
    assignedToUser?: UserModel | undefined;
    totalTaskTime?: number | undefined;
    taskIsRunning?: boolean | undefined;
    taskStarted?: boolean;
    taskRunningSince?: Date | undefined;
    startedOn?: Date | undefined;
    procedureStep?: ProcedureStepModel | undefined;
    procedureStepType?: ProcedureStepTypeModel | undefined;
    status?: StatusModel | undefined;
    workOrder?: WorkOrderModel | undefined;
    lastUpdatedOn?: Date | undefined;
    referenceFiles?: FileModel[] | undefined;
    title?: string | undefined;
    stepText?: string | undefined;
    isNCRTask?: boolean | undefined;
    ncNumber?: string | undefined;
    specialActionEnabled?: number | undefined;
    isRework?: boolean;
    workOrderPartId?: number | undefined;
    reworkPrice?: number | undefined;
    addToWOPrice?: boolean | undefined;
    workOrderPrice?: number | undefined;
    ncrHistoryItems?: NCRHistoryItemModel[] | undefined;
    mappedWorkOrderParts?: MappedWorkOrderPart[] | undefined;
}

export class MappedWorkOrderPart implements IMappedWorkOrderPart {
    id?: number;
    tagType?: string | undefined;
    detail?: string | undefined;

    constructor(data?: IMappedWorkOrderPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagType = _data["tagType"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): MappedWorkOrderPart {
        data = typeof data === 'object' ? data : {};
        let result = new MappedWorkOrderPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagType"] = this.tagType;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IMappedWorkOrderPart {
    id?: number;
    tagType?: string | undefined;
    detail?: string | undefined;
}

export class WorkOrderMessageModel implements IWorkOrderMessageModel {
    name?: string | undefined;
    message?: string | undefined;
    date?: Date;

    constructor(data?: IWorkOrderMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.message = _data["message"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["message"] = this.message;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderMessageModel {
    name?: string | undefined;
    message?: string | undefined;
    date?: Date;
}

export class PurchaseOrderPartView implements IPurchaseOrderPartView {
    id?: number;
    partId?: number;
    partName?: string | undefined;
    partNumber?: string | undefined;
    procedureId?: number;
    procedureName?: string | undefined;
    partRevision?: number;
    price?: number | undefined;
    qty?: number;
    mttn?: string | undefined;
    customerLineNumber?: number | undefined;
    packagingId?: string | undefined;
    locationId?: number;
    serialNumber?: string | undefined;
    dueDate?: Date;

    constructor(data?: IPurchaseOrderPartView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partId = _data["partId"];
            this.partName = _data["partName"];
            this.partNumber = _data["partNumber"];
            this.procedureId = _data["procedureId"];
            this.procedureName = _data["procedureName"];
            this.partRevision = _data["partRevision"];
            this.price = _data["price"];
            this.qty = _data["qty"];
            this.mttn = _data["mttn"];
            this.customerLineNumber = _data["customerLineNumber"];
            this.packagingId = _data["packagingId"];
            this.locationId = _data["locationId"];
            this.serialNumber = _data["serialNumber"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PurchaseOrderPartView {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderPartView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partId"] = this.partId;
        data["partName"] = this.partName;
        data["partNumber"] = this.partNumber;
        data["procedureId"] = this.procedureId;
        data["procedureName"] = this.procedureName;
        data["partRevision"] = this.partRevision;
        data["price"] = this.price;
        data["qty"] = this.qty;
        data["mttn"] = this.mttn;
        data["customerLineNumber"] = this.customerLineNumber;
        data["packagingId"] = this.packagingId;
        data["locationId"] = this.locationId;
        data["serialNumber"] = this.serialNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPurchaseOrderPartView {
    id?: number;
    partId?: number;
    partName?: string | undefined;
    partNumber?: string | undefined;
    procedureId?: number;
    procedureName?: string | undefined;
    partRevision?: number;
    price?: number | undefined;
    qty?: number;
    mttn?: string | undefined;
    customerLineNumber?: number | undefined;
    packagingId?: string | undefined;
    locationId?: number;
    serialNumber?: string | undefined;
    dueDate?: Date;
}

export class DetailPackingListPartView implements IDetailPackingListPartView {
    purchaseId?: number;
    mttn?: string | undefined;
    customerPN?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    note?: string | undefined;
    poName?: string | undefined;
    customerLineNumber?: string | undefined;

    constructor(data?: IDetailPackingListPartView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            this.mttn = _data["mttn"];
            this.customerPN = _data["customerPN"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.note = _data["note"];
            this.poName = _data["poName"];
            this.customerLineNumber = _data["customerLineNumber"];
        }
    }

    static fromJS(data: any): DetailPackingListPartView {
        data = typeof data === 'object' ? data : {};
        let result = new DetailPackingListPartView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        data["mttn"] = this.mttn;
        data["customerPN"] = this.customerPN;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["note"] = this.note;
        data["poName"] = this.poName;
        data["customerLineNumber"] = this.customerLineNumber;
        return data;
    }
}

export interface IDetailPackingListPartView {
    purchaseId?: number;
    mttn?: string | undefined;
    customerPN?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    note?: string | undefined;
    poName?: string | undefined;
    customerLineNumber?: string | undefined;
}

export class PurchaseOrderModel extends CreatableModel implements IPurchaseOrderModel {
    customer?: CustomerModel | undefined;
    customerId?: number;
    name?: string | undefined;
    referencePO?: string | undefined;
    referenceName?: string | undefined;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number | undefined;
    customerReference?: string | undefined;
    locationId?: number;
    location?: LocationModel | undefined;

    constructor(data?: IPurchaseOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.referencePO = _data["referencePO"];
            this.referenceName = _data["referenceName"];
            this.openDate = _data["openDate"] ? new Date(_data["openDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            this.totalPurchaseLimit = _data["totalPurchaseLimit"];
            this.customerReference = _data["customerReference"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PurchaseOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["referencePO"] = this.referencePO;
        data["referenceName"] = this.referenceName;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        data["totalPurchaseLimit"] = this.totalPurchaseLimit;
        data["customerReference"] = this.customerReference;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseOrderModel extends ICreatableModel {
    customer?: CustomerModel | undefined;
    customerId?: number;
    name?: string | undefined;
    referencePO?: string | undefined;
    referenceName?: string | undefined;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number | undefined;
    customerReference?: string | undefined;
    locationId?: number;
    location?: LocationModel | undefined;
}

/** CreatePurchaseRequest */
export class CreatePurchaseRequest implements ICreatePurchaseRequest {
    groupLines?: boolean;
    purchaseRequests?: PurchaseRequest[] | undefined;
    customerDepartmentId?: number | undefined;

    constructor(data?: ICreatePurchaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupLines = _data["groupLines"];
            if (Array.isArray(_data["purchaseRequests"])) {
                this.purchaseRequests = [] as any;
                for (let item of _data["purchaseRequests"])
                    this.purchaseRequests!.push(PurchaseRequest.fromJS(item));
            }
            this.customerDepartmentId = _data["customerDepartmentId"];
        }
    }

    static fromJS(data: any): CreatePurchaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupLines"] = this.groupLines;
        if (Array.isArray(this.purchaseRequests)) {
            data["purchaseRequests"] = [];
            for (let item of this.purchaseRequests)
                data["purchaseRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["customerDepartmentId"] = this.customerDepartmentId;
        return data;
    }
}

/** CreatePurchaseRequest */
export interface ICreatePurchaseRequest {
    groupLines?: boolean;
    purchaseRequests?: PurchaseRequest[] | undefined;
    customerDepartmentId?: number | undefined;
}

export class PurchaseRequest implements IPurchaseRequest {
    purchaseOrderId?: number;
    statusId?: number;
    purchaseOrderPartId?: number;
    customerPurchaseNumber?: string | undefined;
    locationId?: number;
    serialNumbers?: string[] | undefined;
    customerLineNumbers?: string[] | undefined;
    qty?: number;
    mttn?: string | undefined;
    customerLineNumber?: number | undefined;
    packagingId?: string | undefined;
    dueDate?: Date;
    purchasePrice?: number;
    serializeIndividually?: boolean;
    groupAllOnWorkOrder?: boolean;

    constructor(data?: IPurchaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.statusId = _data["statusId"];
            this.purchaseOrderPartId = _data["purchaseOrderPartId"];
            this.customerPurchaseNumber = _data["customerPurchaseNumber"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(item);
            }
            if (Array.isArray(_data["customerLineNumbers"])) {
                this.customerLineNumbers = [] as any;
                for (let item of _data["customerLineNumbers"])
                    this.customerLineNumbers!.push(item);
            }
            this.qty = _data["qty"];
            this.mttn = _data["mttn"];
            this.customerLineNumber = _data["customerLineNumber"];
            this.packagingId = _data["packagingId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.purchasePrice = _data["purchasePrice"];
            this.serializeIndividually = _data["serializeIndividually"];
            this.groupAllOnWorkOrder = _data["groupAllOnWorkOrder"];
        }
    }

    static fromJS(data: any): PurchaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["statusId"] = this.statusId;
        data["purchaseOrderPartId"] = this.purchaseOrderPartId;
        data["customerPurchaseNumber"] = this.customerPurchaseNumber;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item);
        }
        if (Array.isArray(this.customerLineNumbers)) {
            data["customerLineNumbers"] = [];
            for (let item of this.customerLineNumbers)
                data["customerLineNumbers"].push(item);
        }
        data["qty"] = this.qty;
        data["mttn"] = this.mttn;
        data["customerLineNumber"] = this.customerLineNumber;
        data["packagingId"] = this.packagingId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["purchasePrice"] = this.purchasePrice;
        data["serializeIndividually"] = this.serializeIndividually;
        data["groupAllOnWorkOrder"] = this.groupAllOnWorkOrder;
        return data;
    }
}

export interface IPurchaseRequest {
    purchaseOrderId?: number;
    statusId?: number;
    purchaseOrderPartId?: number;
    customerPurchaseNumber?: string | undefined;
    locationId?: number;
    serialNumbers?: string[] | undefined;
    customerLineNumbers?: string[] | undefined;
    qty?: number;
    mttn?: string | undefined;
    customerLineNumber?: number | undefined;
    packagingId?: string | undefined;
    dueDate?: Date;
    purchasePrice?: number;
    serializeIndividually?: boolean;
    groupAllOnWorkOrder?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfPurchaseOrderView extends AuditActionResult implements IAuditActionResultOfIEnumerableOfPurchaseOrderView {
    object?: PurchaseOrderView[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfPurchaseOrderView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PurchaseOrderView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfPurchaseOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfPurchaseOrderView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfPurchaseOrderView extends IAuditActionResult {
    object?: PurchaseOrderView[] | undefined;
}

export class PurchaseOrderView extends CreatableModel implements IPurchaseOrderView {
    customerId?: number;
    customerName?: string | undefined;
    referenceName?: string | undefined;
    name?: string | undefined;
    customerReferencePO?: string | undefined;
    customerReferenceNo?: string | undefined;
    invoicedBalance?: number;
    uninvoicedBalance?: number;
    balance?: number;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number;
    customerReference?: string | undefined;
    parts?: PurchaseOrderPartView[] | undefined;
    isDeletable?: boolean;
    status?: string | undefined;
    revision?: number | undefined;
    unusedAmount?: number;

    constructor(data?: IPurchaseOrderView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.referenceName = _data["referenceName"];
            this.name = _data["name"];
            this.customerReferencePO = _data["customerReferencePO"];
            this.customerReferenceNo = _data["customerReferenceNo"];
            this.invoicedBalance = _data["invoicedBalance"];
            this.uninvoicedBalance = _data["uninvoicedBalance"];
            this.balance = _data["balance"];
            this.openDate = _data["openDate"] ? new Date(_data["openDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            this.totalPurchaseLimit = _data["totalPurchaseLimit"];
            this.customerReference = _data["customerReference"];
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(PurchaseOrderPartView.fromJS(item));
            }
            this.isDeletable = _data["isDeletable"];
            this.status = _data["status"];
            this.revision = _data["revision"];
            this.unusedAmount = _data["unusedAmount"];
        }
    }

    static override fromJS(data: any): PurchaseOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["referenceName"] = this.referenceName;
        data["name"] = this.name;
        data["customerReferencePO"] = this.customerReferencePO;
        data["customerReferenceNo"] = this.customerReferenceNo;
        data["invoicedBalance"] = this.invoicedBalance;
        data["uninvoicedBalance"] = this.uninvoicedBalance;
        data["balance"] = this.balance;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        data["totalPurchaseLimit"] = this.totalPurchaseLimit;
        data["customerReference"] = this.customerReference;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeletable"] = this.isDeletable;
        data["status"] = this.status;
        data["revision"] = this.revision;
        data["unusedAmount"] = this.unusedAmount;
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseOrderView extends ICreatableModel {
    customerId?: number;
    customerName?: string | undefined;
    referenceName?: string | undefined;
    name?: string | undefined;
    customerReferencePO?: string | undefined;
    customerReferenceNo?: string | undefined;
    invoicedBalance?: number;
    uninvoicedBalance?: number;
    balance?: number;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number;
    customerReference?: string | undefined;
    parts?: PurchaseOrderPartView[] | undefined;
    isDeletable?: boolean;
    status?: string | undefined;
    revision?: number | undefined;
    unusedAmount?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPurchaseOrderView extends AuditActionResult implements IAuditActionResultOfPurchaseOrderView {
    object?: PurchaseOrderView | undefined;

    constructor(data?: IAuditActionResultOfPurchaseOrderView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PurchaseOrderView.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPurchaseOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPurchaseOrderView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPurchaseOrderView extends IAuditActionResult {
    object?: PurchaseOrderView | undefined;
}

export class CreatePurchaseOrderRequest implements ICreatePurchaseOrderRequest {
    customerId!: number;
    name?: string | undefined;
    customerReferencePO!: string;
    referenceName?: string | undefined;
    parts!: number[];
    openDate?: Date;
    closeDate?: Date | undefined;
    customerReferenceNo?: string | undefined;
    totalPurchaseLimit?: number;
    tax?: number;

    constructor(data?: ICreatePurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.customerReferencePO = _data["customerReferencePO"];
            this.referenceName = _data["referenceName"];
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(item);
            }
            this.openDate = _data["openDate"] ? new Date(_data["openDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            this.customerReferenceNo = _data["customerReferenceNo"];
            this.totalPurchaseLimit = _data["totalPurchaseLimit"];
            this.tax = _data["tax"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["customerReferencePO"] = this.customerReferencePO;
        data["referenceName"] = this.referenceName;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item);
        }
        data["openDate"] = this.openDate ? this.openDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        data["customerReferenceNo"] = this.customerReferenceNo;
        data["totalPurchaseLimit"] = this.totalPurchaseLimit;
        data["tax"] = this.tax;
        return data;
    }
}

export interface ICreatePurchaseOrderRequest {
    customerId: number;
    name?: string | undefined;
    customerReferencePO: string;
    referenceName?: string | undefined;
    parts: number[];
    openDate?: Date;
    closeDate?: Date | undefined;
    customerReferenceNo?: string | undefined;
    totalPurchaseLimit?: number;
    tax?: number;
}

export class UpdatePurchaseOrderRequest extends CreatePurchaseOrderRequest implements IUpdatePurchaseOrderRequest {
    id!: number;
    closePurchaseOrder?: boolean;

    constructor(data?: IUpdatePurchaseOrderRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.closePurchaseOrder = _data["closePurchaseOrder"];
        }
    }

    static override fromJS(data: any): UpdatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["closePurchaseOrder"] = this.closePurchaseOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePurchaseOrderRequest extends ICreatePurchaseOrderRequest {
    id: number;
    closePurchaseOrder?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfPurchaseOrderDBView extends AuditActionResult implements IAuditActionResultOfIEnumerableOfPurchaseOrderDBView {
    object?: PurchaseOrderDBView[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfPurchaseOrderDBView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PurchaseOrderDBView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfPurchaseOrderDBView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfPurchaseOrderDBView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfPurchaseOrderDBView extends IAuditActionResult {
    object?: PurchaseOrderDBView[] | undefined;
}

export class PurchaseOrderDBView implements IPurchaseOrderDBView {
    id?: number;
    customerId?: number;
    customerName?: string | undefined;
    referenceName?: string | undefined;
    name?: string | undefined;
    customerReferencePO?: string | undefined;
    customerReferenceNo?: string | undefined;
    invoicedBalance?: number;
    uninvoicedBalance?: number;
    balance?: number;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number;
    customerReference?: string | undefined;
    isDeletable?: boolean;
    status?: string | undefined;
    revision?: number | undefined;
    unusedAmount?: number;

    constructor(data?: IPurchaseOrderDBView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.referenceName = _data["referenceName"];
            this.name = _data["name"];
            this.customerReferencePO = _data["customerReferencePO"];
            this.customerReferenceNo = _data["customerReferenceNo"];
            this.invoicedBalance = _data["invoicedBalance"];
            this.uninvoicedBalance = _data["uninvoicedBalance"];
            this.balance = _data["balance"];
            this.openDate = _data["openDate"] ? new Date(_data["openDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            this.totalPurchaseLimit = _data["totalPurchaseLimit"];
            this.customerReference = _data["customerReference"];
            this.isDeletable = _data["isDeletable"];
            this.status = _data["status"];
            this.revision = _data["revision"];
            this.unusedAmount = _data["unusedAmount"];
        }
    }

    static fromJS(data: any): PurchaseOrderDBView {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDBView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["referenceName"] = this.referenceName;
        data["name"] = this.name;
        data["customerReferencePO"] = this.customerReferencePO;
        data["customerReferenceNo"] = this.customerReferenceNo;
        data["invoicedBalance"] = this.invoicedBalance;
        data["uninvoicedBalance"] = this.uninvoicedBalance;
        data["balance"] = this.balance;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        data["totalPurchaseLimit"] = this.totalPurchaseLimit;
        data["customerReference"] = this.customerReference;
        data["isDeletable"] = this.isDeletable;
        data["status"] = this.status;
        data["revision"] = this.revision;
        data["unusedAmount"] = this.unusedAmount;
        return data;
    }
}

export interface IPurchaseOrderDBView {
    id?: number;
    customerId?: number;
    customerName?: string | undefined;
    referenceName?: string | undefined;
    name?: string | undefined;
    customerReferencePO?: string | undefined;
    customerReferenceNo?: string | undefined;
    invoicedBalance?: number;
    uninvoicedBalance?: number;
    balance?: number;
    openDate?: Date;
    closeDate?: Date | undefined;
    totalPurchaseLimit?: number;
    customerReference?: string | undefined;
    isDeletable?: boolean;
    status?: string | undefined;
    revision?: number | undefined;
    unusedAmount?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfQuotesView extends AuditActionResult implements IAuditActionResultOfIEnumerableOfQuotesView {
    object?: QuotesView[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfQuotesView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(QuotesView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfQuotesView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfQuotesView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfQuotesView extends IAuditActionResult {
    object?: QuotesView[] | undefined;
}

export class QuotesView implements IQuotesView {
    id?: number;
    isDeletable?: boolean;
    submittedDate?: Date;
    company?: string | undefined;
    submittedById?: number;
    submittedBy?: UserModel | undefined;
    partKitNo?: string | undefined;
    procedureId?: number;
    procedureName?: string | undefined;
    representative?: string | undefined;
    revision?: number;
    equipmentCost?: number;
    materialCost?: number;
    salesTax?: number;
    totalPrice?: number;
    cycleTime?: number;
    divisionFab?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    lastUpdateOn?: Date | undefined;
    lastUpdateBy?: string | undefined;

    constructor(data?: IQuotesView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeletable = _data["isDeletable"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : undefined as any;
            this.company = _data["company"];
            this.submittedById = _data["submittedById"];
            this.submittedBy = _data["submittedBy"] ? UserModel.fromJS(_data["submittedBy"]) : undefined as any;
            this.partKitNo = _data["partKitNo"];
            this.procedureId = _data["procedureId"];
            this.procedureName = _data["procedureName"];
            this.representative = _data["representative"];
            this.revision = _data["revision"];
            this.equipmentCost = _data["equipmentCost"];
            this.materialCost = _data["materialCost"];
            this.salesTax = _data["salesTax"];
            this.totalPrice = _data["totalPrice"];
            this.cycleTime = _data["cycleTime"];
            this.divisionFab = _data["divisionFab"];
            this.segregationType = _data["segregationType"];
            this.lastUpdateOn = _data["lastUpdateOn"] ? new Date(_data["lastUpdateOn"].toString()) : undefined as any;
            this.lastUpdateBy = _data["lastUpdateBy"];
        }
    }

    static fromJS(data: any): QuotesView {
        data = typeof data === 'object' ? data : {};
        let result = new QuotesView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeletable"] = this.isDeletable;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : undefined as any;
        data["company"] = this.company;
        data["submittedById"] = this.submittedById;
        data["submittedBy"] = this.submittedBy ? this.submittedBy.toJSON() : undefined as any;
        data["partKitNo"] = this.partKitNo;
        data["procedureId"] = this.procedureId;
        data["procedureName"] = this.procedureName;
        data["representative"] = this.representative;
        data["revision"] = this.revision;
        data["equipmentCost"] = this.equipmentCost;
        data["materialCost"] = this.materialCost;
        data["salesTax"] = this.salesTax;
        data["totalPrice"] = this.totalPrice;
        data["cycleTime"] = this.cycleTime;
        data["divisionFab"] = this.divisionFab;
        data["segregationType"] = this.segregationType;
        data["lastUpdateOn"] = this.lastUpdateOn ? this.lastUpdateOn.toISOString() : undefined as any;
        data["lastUpdateBy"] = this.lastUpdateBy;
        return data;
    }
}

export interface IQuotesView {
    id?: number;
    isDeletable?: boolean;
    submittedDate?: Date;
    company?: string | undefined;
    submittedById?: number;
    submittedBy?: UserModel | undefined;
    partKitNo?: string | undefined;
    procedureId?: number;
    procedureName?: string | undefined;
    representative?: string | undefined;
    revision?: number;
    equipmentCost?: number;
    materialCost?: number;
    salesTax?: number;
    totalPrice?: number;
    cycleTime?: number;
    divisionFab?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    lastUpdateOn?: Date | undefined;
    lastUpdateBy?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfQuoteModel extends AuditActionResult implements IAuditActionResultOfQuoteModel {
    object?: QuoteModel | undefined;

    constructor(data?: IAuditActionResultOfQuoteModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? QuoteModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfQuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfQuoteModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfQuoteModel extends IAuditActionResult {
    object?: QuoteModel | undefined;
}

export class QuoteModel implements IQuoteModel {
    id?: number;
    submittedDate?: Date;
    customerId?: number;
    customer?: CustomerModel | undefined;
    submittedById?: number;
    submittedBy?: UserModel | undefined;
    contact?: string | undefined;
    delivery?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;
    processName?: string | undefined;
    description?: string | undefined;
    representative?: string | undefined;
    representativeTitle?: string | undefined;
    representativeAddress?: string | undefined;
    partKitNo?: string | undefined;
    statusId?: number;
    status?: StatusModel | undefined;
    quoteJson?: string | undefined;
    customerRequirementJson?: string | undefined;
    quoteItems?: QuoteItemModel[] | undefined;

    constructor(data?: IQuoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : undefined as any;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : undefined as any;
            this.submittedById = _data["submittedById"];
            this.submittedBy = _data["submittedBy"] ? UserModel.fromJS(_data["submittedBy"]) : undefined as any;
            this.contact = _data["contact"];
            this.delivery = _data["delivery"];
            this.title = _data["title"];
            this.phone = _data["phone"];
            this.processName = _data["processName"];
            this.description = _data["description"];
            this.representative = _data["representative"];
            this.representativeTitle = _data["representativeTitle"];
            this.representativeAddress = _data["representativeAddress"];
            this.partKitNo = _data["partKitNo"];
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : undefined as any;
            this.quoteJson = _data["quoteJson"];
            this.customerRequirementJson = _data["customerRequirementJson"];
            if (Array.isArray(_data["quoteItems"])) {
                this.quoteItems = [] as any;
                for (let item of _data["quoteItems"])
                    this.quoteItems!.push(QuoteItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : undefined as any;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["submittedById"] = this.submittedById;
        data["submittedBy"] = this.submittedBy ? this.submittedBy.toJSON() : undefined as any;
        data["contact"] = this.contact;
        data["delivery"] = this.delivery;
        data["title"] = this.title;
        data["phone"] = this.phone;
        data["processName"] = this.processName;
        data["description"] = this.description;
        data["representative"] = this.representative;
        data["representativeTitle"] = this.representativeTitle;
        data["representativeAddress"] = this.representativeAddress;
        data["partKitNo"] = this.partKitNo;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["quoteJson"] = this.quoteJson;
        data["customerRequirementJson"] = this.customerRequirementJson;
        if (Array.isArray(this.quoteItems)) {
            data["quoteItems"] = [];
            for (let item of this.quoteItems)
                data["quoteItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuoteModel {
    id?: number;
    submittedDate?: Date;
    customerId?: number;
    customer?: CustomerModel | undefined;
    submittedById?: number;
    submittedBy?: UserModel | undefined;
    contact?: string | undefined;
    delivery?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;
    processName?: string | undefined;
    description?: string | undefined;
    representative?: string | undefined;
    representativeTitle?: string | undefined;
    representativeAddress?: string | undefined;
    partKitNo?: string | undefined;
    statusId?: number;
    status?: StatusModel | undefined;
    quoteJson?: string | undefined;
    customerRequirementJson?: string | undefined;
    quoteItems?: QuoteItemModel[] | undefined;
}

export class QuoteItemModel implements IQuoteItemModel {
    id?: number;
    quoteId?: number;
    itemNo?: string | undefined;
    qty?: number | undefined;
    description?: string | undefined;
    leadTime?: string | undefined;
    customerPartNo?: string | undefined;
    price?: number | undefined;
    extension?: number | undefined;

    constructor(data?: IQuoteItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quoteId = _data["quoteId"];
            this.itemNo = _data["itemNo"];
            this.qty = _data["qty"];
            this.description = _data["description"];
            this.leadTime = _data["leadTime"];
            this.customerPartNo = _data["customerPartNo"];
            this.price = _data["price"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): QuoteItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quoteId"] = this.quoteId;
        data["itemNo"] = this.itemNo;
        data["qty"] = this.qty;
        data["description"] = this.description;
        data["leadTime"] = this.leadTime;
        data["customerPartNo"] = this.customerPartNo;
        data["price"] = this.price;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IQuoteItemModel {
    id?: number;
    quoteId?: number;
    itemNo?: string | undefined;
    qty?: number | undefined;
    description?: string | undefined;
    leadTime?: string | undefined;
    customerPartNo?: string | undefined;
    price?: number | undefined;
    extension?: number | undefined;
}

/** CreateQuoteRequest */
export class CreateQuoteRequest implements ICreateQuoteRequest {
    /** CustomerId */
    customerId!: number;
    /** Contact */
    contact?: string | undefined;
    /** Delivery */
    delivery?: string | undefined;
    /** Title */
    title?: string | undefined;
    /** Phone */
    phone?: string | undefined;
    /** ProcessName, a.k.a Procedure Name */
    processName?: string | undefined;
    /** Description */
    description?: string | undefined;
    /** Representative */
    representative?: string | undefined;
    /** RepresentativeTitle */
    representativeTitle?: string | undefined;
    /** RepresentativeAddress */
    representativeAddress?: string | undefined;
    /** QuoteJson */
    quoteJson?: string | undefined;
    /** CustomerRequirementJson */
    customerRequirementJson?: string | undefined;
    /** ProductId */
    productId?: number | undefined;
    /** PartKitNo */
    partKitNo?: string | undefined;
    /** QuoteItems */
    quoteItems!: CreateQuoteItemRequest[];

    constructor(data?: ICreateQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.quoteItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.contact = _data["contact"];
            this.delivery = _data["delivery"];
            this.title = _data["title"];
            this.phone = _data["phone"];
            this.processName = _data["processName"];
            this.description = _data["description"];
            this.representative = _data["representative"];
            this.representativeTitle = _data["representativeTitle"];
            this.representativeAddress = _data["representativeAddress"];
            this.quoteJson = _data["quoteJson"];
            this.customerRequirementJson = _data["customerRequirementJson"];
            this.productId = _data["productId"];
            this.partKitNo = _data["partKitNo"];
            if (Array.isArray(_data["quoteItems"])) {
                this.quoteItems = [] as any;
                for (let item of _data["quoteItems"])
                    this.quoteItems!.push(CreateQuoteItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["contact"] = this.contact;
        data["delivery"] = this.delivery;
        data["title"] = this.title;
        data["phone"] = this.phone;
        data["processName"] = this.processName;
        data["description"] = this.description;
        data["representative"] = this.representative;
        data["representativeTitle"] = this.representativeTitle;
        data["representativeAddress"] = this.representativeAddress;
        data["quoteJson"] = this.quoteJson;
        data["customerRequirementJson"] = this.customerRequirementJson;
        data["productId"] = this.productId;
        data["partKitNo"] = this.partKitNo;
        if (Array.isArray(this.quoteItems)) {
            data["quoteItems"] = [];
            for (let item of this.quoteItems)
                data["quoteItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** CreateQuoteRequest */
export interface ICreateQuoteRequest {
    /** CustomerId */
    customerId: number;
    /** Contact */
    contact?: string | undefined;
    /** Delivery */
    delivery?: string | undefined;
    /** Title */
    title?: string | undefined;
    /** Phone */
    phone?: string | undefined;
    /** ProcessName, a.k.a Procedure Name */
    processName?: string | undefined;
    /** Description */
    description?: string | undefined;
    /** Representative */
    representative?: string | undefined;
    /** RepresentativeTitle */
    representativeTitle?: string | undefined;
    /** RepresentativeAddress */
    representativeAddress?: string | undefined;
    /** QuoteJson */
    quoteJson?: string | undefined;
    /** CustomerRequirementJson */
    customerRequirementJson?: string | undefined;
    /** ProductId */
    productId?: number | undefined;
    /** PartKitNo */
    partKitNo?: string | undefined;
    /** QuoteItems */
    quoteItems: CreateQuoteItemRequest[];
}

export class CreateQuoteItemRequest implements ICreateQuoteItemRequest {
    itemNo?: string | undefined;
    qty?: number | undefined;
    description?: string | undefined;
    leadTime?: string | undefined;
    customerPartNo?: string | undefined;
    price?: number | undefined;
    extension?: number | undefined;

    constructor(data?: ICreateQuoteItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNo = _data["itemNo"];
            this.qty = _data["qty"];
            this.description = _data["description"];
            this.leadTime = _data["leadTime"];
            this.customerPartNo = _data["customerPartNo"];
            this.price = _data["price"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): CreateQuoteItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNo"] = this.itemNo;
        data["qty"] = this.qty;
        data["description"] = this.description;
        data["leadTime"] = this.leadTime;
        data["customerPartNo"] = this.customerPartNo;
        data["price"] = this.price;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ICreateQuoteItemRequest {
    itemNo?: string | undefined;
    qty?: number | undefined;
    description?: string | undefined;
    leadTime?: string | undefined;
    customerPartNo?: string | undefined;
    price?: number | undefined;
    extension?: number | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfQuoteModel extends AuditActionResult implements IAuditActionResultOfIEnumerableOfQuoteModel {
    object?: QuoteModel[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfQuoteModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(QuoteModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfQuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfQuoteModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfQuoteModel extends IAuditActionResult {
    object?: QuoteModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfReportModel extends AuditActionResult implements IAuditActionResultOfICollectionOfReportModel {
    object?: ReportModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfReportModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(ReportModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfReportModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfReportModel extends IAuditActionResult {
    object?: ReportModel[] | undefined;
}

export class ReportModel implements IReportModel {
    id?: number;
    name?: string | undefined;
    subtitle?: string | undefined;
    description?: string | undefined;
    apiEndPointURL?: string | undefined;
    imageUrl?: string | undefined;
    categories?: ReportCategoryModel[] | undefined;

    constructor(data?: IReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subtitle = _data["subtitle"];
            this.description = _data["description"];
            this.apiEndPointURL = _data["apiEndPointURL"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ReportCategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["apiEndPointURL"] = this.apiEndPointURL;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportModel {
    id?: number;
    name?: string | undefined;
    subtitle?: string | undefined;
    description?: string | undefined;
    apiEndPointURL?: string | undefined;
    imageUrl?: string | undefined;
    categories?: ReportCategoryModel[] | undefined;
}

export class ReportCategoryModel implements IReportCategoryModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IReportCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ReportCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IReportCategoryModel {
    id?: number;
    name?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfRole extends AuditActionResult implements IAuditActionResultOfICollectionOfRole {
    object?: Role[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(Role.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfRole {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfRole extends IAuditActionResult {
    object?: Role[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfRolesUsersView extends AuditActionResult implements IAuditActionResultOfICollectionOfRolesUsersView {
    object?: RolesUsersView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfRolesUsersView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(RolesUsersView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfRolesUsersView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfRolesUsersView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfRolesUsersView extends IAuditActionResult {
    object?: RolesUsersView[] | undefined;
}

export class RolesUsersView implements IRolesUsersView {
    id?: number;
    roleId?: number;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
    userId?: number;
    user?: UserModel | undefined;

    constructor(data?: IRolesUsersView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.certificationFromDate = _data["certificationFromDate"] ? new Date(_data["certificationFromDate"].toString()) : undefined as any;
            this.certificationToDate = _data["certificationToDate"] ? new Date(_data["certificationToDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): RolesUsersView {
        data = typeof data === 'object' ? data : {};
        let result = new RolesUsersView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["certificationFromDate"] = this.certificationFromDate ? this.certificationFromDate.toISOString() : undefined as any;
        data["certificationToDate"] = this.certificationToDate ? this.certificationToDate.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IRolesUsersView {
    id?: number;
    roleId?: number;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
    userId?: number;
    user?: UserModel | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfRole extends AuditActionResult implements IAuditActionResultOfRole {
    object?: Role | undefined;

    constructor(data?: IAuditActionResultOfRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? Role.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfRole {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfRole extends IAuditActionResult {
    object?: Role | undefined;
}

export class CreateRoleRequest implements ICreateRoleRequest {
    name?: string | undefined;
    isCertificationRole?: boolean;
    parentRoleIds?: number[] | undefined;
    userRoles?: UserRoleModel[] | undefined;

    constructor(data?: ICreateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isCertificationRole = _data["isCertificationRole"];
            if (Array.isArray(_data["parentRoleIds"])) {
                this.parentRoleIds = [] as any;
                for (let item of _data["parentRoleIds"])
                    this.parentRoleIds!.push(item);
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRoleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCertificationRole"] = this.isCertificationRole;
        if (Array.isArray(this.parentRoleIds)) {
            data["parentRoleIds"] = [];
            for (let item of this.parentRoleIds)
                data["parentRoleIds"].push(item);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateRoleRequest {
    name?: string | undefined;
    isCertificationRole?: boolean;
    parentRoleIds?: number[] | undefined;
    userRoles?: UserRoleModel[] | undefined;
}

export class UserRoleModel implements IUserRoleModel {
    userRoleId!: number;
    userId?: number | undefined;
    roleId?: number | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRoleId = _data["userRoleId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.certificationFromDate = _data["certificationFromDate"] ? new Date(_data["certificationFromDate"].toString()) : undefined as any;
            this.certificationToDate = _data["certificationToDate"] ? new Date(_data["certificationToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRoleId"] = this.userRoleId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["certificationFromDate"] = this.certificationFromDate ? this.certificationFromDate.toISOString() : undefined as any;
        data["certificationToDate"] = this.certificationToDate ? this.certificationToDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserRoleModel {
    userRoleId: number;
    userId?: number | undefined;
    roleId?: number | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
}

export class UpdateRoleRequest extends CreateRoleRequest implements IUpdateRoleRequest {
    id?: number;

    constructor(data?: IUpdateRoleRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRoleRequest extends ICreateRoleRequest {
    id?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfSearchView extends AuditActionResult implements IAuditActionResultOfICollectionOfSearchView {
    object?: SearchView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfSearchView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(SearchView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfSearchView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfSearchView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfSearchView extends IAuditActionResult {
    object?: SearchView[] | undefined;
}

export class SearchView implements ISearchView {
    itemId?: number;
    itemName?: string | undefined;
    itemType?: string | undefined;
    description?: string | undefined;
    lastUpdatedOn?: Date;
    lastUpdatedBy?: string | undefined;

    constructor(data?: ISearchView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.itemType = _data["itemType"];
            this.description = _data["description"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : undefined as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
        }
    }

    static fromJS(data: any): SearchView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemType"] = this.itemType;
        data["description"] = this.description;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : undefined as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        return data;
    }
}

export interface ISearchView {
    itemId?: number;
    itemName?: string | undefined;
    itemType?: string | undefined;
    description?: string | undefined;
    lastUpdatedOn?: Date;
    lastUpdatedBy?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfString extends AuditActionResult implements IAuditActionResultOfIEnumerableOfString {
    object?: string[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(item);
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfString extends IAuditActionResult {
    object?: string[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfSensorValueModel extends AuditActionResult implements IAuditActionResultOfSensorValueModel {
    object?: SensorValueModel | undefined;

    constructor(data?: IAuditActionResultOfSensorValueModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? SensorValueModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfSensorValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfSensorValueModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfSensorValueModel extends IAuditActionResult {
    object?: SensorValueModel | undefined;
}

export class SensorValueModel extends CreatableModel implements ISensorValueModel {
    sensor?: SensorModel | undefined;
    itemCurrentValue?: string | undefined;
    alarmDescription?: string | undefined;
    isAlarm?: boolean | undefined;

    constructor(data?: ISensorValueModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sensor = _data["sensor"] ? SensorModel.fromJS(_data["sensor"]) : undefined as any;
            this.itemCurrentValue = _data["itemCurrentValue"];
            this.alarmDescription = _data["alarmDescription"];
            this.isAlarm = _data["isAlarm"];
        }
    }

    static override fromJS(data: any): SensorValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensorValueModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensor"] = this.sensor ? this.sensor.toJSON() : undefined as any;
        data["itemCurrentValue"] = this.itemCurrentValue;
        data["alarmDescription"] = this.alarmDescription;
        data["isAlarm"] = this.isAlarm;
        super.toJSON(data);
        return data;
    }
}

export interface ISensorValueModel extends ICreatableModel {
    sensor?: SensorModel | undefined;
    itemCurrentValue?: string | undefined;
    alarmDescription?: string | undefined;
    isAlarm?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfTimeZoneModel extends AuditActionResult implements IAuditActionResultOfICollectionOfTimeZoneModel {
    object?: TimeZoneModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfTimeZoneModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(TimeZoneModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfTimeZoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfTimeZoneModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfTimeZoneModel extends IAuditActionResult {
    object?: TimeZoneModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfUserModel extends AuditActionResult implements IAuditActionResultOfICollectionOfUserModel {
    object?: UserModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(UserModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfUserModel extends IAuditActionResult {
    object?: UserModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfUserModel extends AuditActionResult implements IAuditActionResultOfUserModel {
    object?: UserModel | undefined;

    constructor(data?: IAuditActionResultOfUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? UserModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfUserModel extends IAuditActionResult {
    object?: UserModel | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfIEnumerableOfTrainingCertificationView extends AuditActionResult implements IAuditActionResultOfIEnumerableOfTrainingCertificationView {
    object?: TrainingCertificationView[] | undefined;

    constructor(data?: IAuditActionResultOfIEnumerableOfTrainingCertificationView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(TrainingCertificationView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfIEnumerableOfTrainingCertificationView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfIEnumerableOfTrainingCertificationView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfIEnumerableOfTrainingCertificationView extends IAuditActionResult {
    object?: TrainingCertificationView[] | undefined;
}

export class TrainingCertificationView implements ITrainingCertificationView {
    id?: number;
    userId?: number;
    employeeName?: string | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
    status?: string | undefined;
    certificationName?: string | undefined;

    constructor(data?: ITrainingCertificationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.employeeName = _data["employeeName"];
            this.certificationFromDate = _data["certificationFromDate"] ? new Date(_data["certificationFromDate"].toString()) : undefined as any;
            this.certificationToDate = _data["certificationToDate"] ? new Date(_data["certificationToDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.certificationName = _data["certificationName"];
        }
    }

    static fromJS(data: any): TrainingCertificationView {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCertificationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["employeeName"] = this.employeeName;
        data["certificationFromDate"] = this.certificationFromDate ? this.certificationFromDate.toISOString() : undefined as any;
        data["certificationToDate"] = this.certificationToDate ? this.certificationToDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["certificationName"] = this.certificationName;
        return data;
    }
}

export interface ITrainingCertificationView {
    id?: number;
    userId?: number;
    employeeName?: string | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
    status?: string | undefined;
    certificationName?: string | undefined;
}

export class CreateUserRequest implements ICreateUserRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    securityStamp?: string | undefined;
    phone?: string | undefined;
    supervisorId?: number | undefined;
    locationId?: number | undefined;
    isActive?: boolean;
    isAnswerUser?: boolean | undefined;
    customerId?: number | undefined;
    lockoutEndDateUtc?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    timeZoneId?: number | undefined;
    roles?: Role[] | undefined;
    file?: FileModel | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.securityStamp = _data["securityStamp"];
            this.phone = _data["phone"];
            this.supervisorId = _data["supervisorId"];
            this.locationId = _data["locationId"];
            this.isActive = _data["isActive"];
            this.isAnswerUser = _data["isAnswerUser"];
            this.customerId = _data["customerId"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? new Date(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            this.file = _data["file"] ? FileModel.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["title"] = this.title;
        data["email"] = this.email;
        data["securityStamp"] = this.securityStamp;
        data["phone"] = this.phone;
        data["supervisorId"] = this.supervisorId;
        data["locationId"] = this.locationId;
        data["isActive"] = this.isActive;
        data["isAnswerUser"] = this.isAnswerUser;
        data["customerId"] = this.customerId;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateUserRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    securityStamp?: string | undefined;
    phone?: string | undefined;
    supervisorId?: number | undefined;
    locationId?: number | undefined;
    isActive?: boolean;
    isAnswerUser?: boolean | undefined;
    customerId?: number | undefined;
    lockoutEndDateUtc?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    timeZoneId?: number | undefined;
    roles?: Role[] | undefined;
    file?: FileModel | undefined;
}

export class UpdateUserRequest extends CreateUserRequest implements IUpdateUserRequest {
    id!: number;

    constructor(data?: IUpdateUserRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUserRequest extends ICreateUserRequest {
    id: number;
}

export class CreateUserRoleRequest implements ICreateUserRoleRequest {
    userId!: number;
    roleId!: number;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;

    constructor(data?: ICreateUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.certificationFromDate = _data["certificationFromDate"] ? new Date(_data["certificationFromDate"].toString()) : undefined as any;
            this.certificationToDate = _data["certificationToDate"] ? new Date(_data["certificationToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["certificationFromDate"] = this.certificationFromDate ? this.certificationFromDate.toISOString() : undefined as any;
        data["certificationToDate"] = this.certificationToDate ? this.certificationToDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateUserRoleRequest {
    userId: number;
    roleId: number;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
}

export class UpdateUserRoleRequest implements IUpdateUserRoleRequest {
    userRoleId!: number;
    userId?: number | undefined;
    roleId?: number | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;

    constructor(data?: IUpdateUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRoleId = _data["userRoleId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.certificationFromDate = _data["certificationFromDate"] ? new Date(_data["certificationFromDate"].toString()) : undefined as any;
            this.certificationToDate = _data["certificationToDate"] ? new Date(_data["certificationToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRoleId"] = this.userRoleId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["certificationFromDate"] = this.certificationFromDate ? this.certificationFromDate.toISOString() : undefined as any;
        data["certificationToDate"] = this.certificationToDate ? this.certificationToDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateUserRoleRequest {
    userRoleId: number;
    userId?: number | undefined;
    roleId?: number | undefined;
    certificationFromDate?: Date | undefined;
    certificationToDate?: Date | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPurchaseWorkOrderGroup extends AuditActionResult implements IAuditActionResultOfICollectionOfPurchaseWorkOrderGroup {
    object?: PurchaseWorkOrderGroup[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPurchaseWorkOrderGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PurchaseWorkOrderGroup.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPurchaseWorkOrderGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPurchaseWorkOrderGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPurchaseWorkOrderGroup extends IAuditActionResult {
    object?: PurchaseWorkOrderGroup[] | undefined;
}

export class PurchaseWorkOrderGroup implements IPurchaseWorkOrderGroup {
    purchaseId?: number | undefined;
    purchaseNumber?: string | undefined;
    purchaseOrderName?: string | undefined;
    referencePO?: string | undefined;
    customerName?: string | undefined;
    locationName?: string | undefined;
    multipleParts?: boolean;
    purchaseReadyToShipStatus?: number;
    purchaseShippedStatus?: string | undefined;
    purchasePartMapSerialNumber?: string | undefined;
    purchaseParts?: string | undefined;
    purchasePrice?: number | undefined;
    hasPurchaseFiles?: boolean;
    workOrders?: WorkOrderGridDataItem[] | undefined;

    constructor(data?: IPurchaseWorkOrderGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            this.purchaseNumber = _data["purchaseNumber"];
            this.purchaseOrderName = _data["purchaseOrderName"];
            this.referencePO = _data["referencePO"];
            this.customerName = _data["customerName"];
            this.locationName = _data["locationName"];
            this.multipleParts = _data["multipleParts"];
            this.purchaseReadyToShipStatus = _data["purchaseReadyToShipStatus"];
            this.purchaseShippedStatus = _data["purchaseShippedStatus"];
            this.purchasePartMapSerialNumber = _data["purchasePartMapSerialNumber"];
            this.purchaseParts = _data["purchaseParts"];
            this.purchasePrice = _data["purchasePrice"];
            this.hasPurchaseFiles = _data["hasPurchaseFiles"];
            if (Array.isArray(_data["workOrders"])) {
                this.workOrders = [] as any;
                for (let item of _data["workOrders"])
                    this.workOrders!.push(WorkOrderGridDataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseWorkOrderGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseWorkOrderGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        data["purchaseNumber"] = this.purchaseNumber;
        data["purchaseOrderName"] = this.purchaseOrderName;
        data["referencePO"] = this.referencePO;
        data["customerName"] = this.customerName;
        data["locationName"] = this.locationName;
        data["multipleParts"] = this.multipleParts;
        data["purchaseReadyToShipStatus"] = this.purchaseReadyToShipStatus;
        data["purchaseShippedStatus"] = this.purchaseShippedStatus;
        data["purchasePartMapSerialNumber"] = this.purchasePartMapSerialNumber;
        data["purchaseParts"] = this.purchaseParts;
        data["purchasePrice"] = this.purchasePrice;
        data["hasPurchaseFiles"] = this.hasPurchaseFiles;
        if (Array.isArray(this.workOrders)) {
            data["workOrders"] = [];
            for (let item of this.workOrders)
                data["workOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchaseWorkOrderGroup {
    purchaseId?: number | undefined;
    purchaseNumber?: string | undefined;
    purchaseOrderName?: string | undefined;
    referencePO?: string | undefined;
    customerName?: string | undefined;
    locationName?: string | undefined;
    multipleParts?: boolean;
    purchaseReadyToShipStatus?: number;
    purchaseShippedStatus?: string | undefined;
    purchasePartMapSerialNumber?: string | undefined;
    purchaseParts?: string | undefined;
    purchasePrice?: number | undefined;
    hasPurchaseFiles?: boolean;
    workOrders?: WorkOrderGridDataItem[] | undefined;
}

export class WorkOrderGridDataItem implements IWorkOrderGridDataItem {
    workOrderNumber?: number;
    workOrderItemNumber?: string | undefined;
    serialNumber?: string | undefined;
    allSerialNumbers?: string | undefined;
    purchasePartMapSerialNumber?: string | undefined;
    quantity?: number | undefined;
    scheduledStartDate?: Date | undefined;
    scheduledEndDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    partName?: string | undefined;
    procedureName?: string | undefined;
    procedureId?: number | undefined;
    status?: string | undefined;
    disposition?: string | undefined;
    customerLastRespondent?: boolean;
    currentActiveTaskName?: string | undefined;
    percentageOfTasksCompleted?: number | undefined;
    percentageOfTasksCompletedNumerator?: number | undefined;
    percentageOfTasksCompletedDenominator?: number | undefined;
    percentageOfExpectedDurationTimeLogged?: number | undefined;
    percentageOfExpectedDurationTimeLoggedNumerator?: number | undefined;
    percentageOfExpectedDurationTimeLoggedDenominator?: number | undefined;
    hasNCR?: boolean;
    segregationType?: string | undefined;
    price?: number | undefined;
    endDateChangeReason?: string | undefined;
    endDateChanged?: number | undefined;
    woShippedStatus?: boolean;
    workOrderPartId?: number | undefined;
    isKit?: boolean;
    hasPurchaseFiles?: boolean;
    workOrderMessages?: WorkOrderMessageModel[] | undefined;

    constructor(data?: IWorkOrderGridDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderNumber = _data["workOrderNumber"];
            this.workOrderItemNumber = _data["workOrderItemNumber"];
            this.serialNumber = _data["serialNumber"];
            this.allSerialNumbers = _data["allSerialNumbers"];
            this.purchasePartMapSerialNumber = _data["purchasePartMapSerialNumber"];
            this.quantity = _data["quantity"];
            this.scheduledStartDate = _data["scheduledStartDate"] ? new Date(_data["scheduledStartDate"].toString()) : undefined as any;
            this.scheduledEndDate = _data["scheduledEndDate"] ? new Date(_data["scheduledEndDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.partName = _data["partName"];
            this.procedureName = _data["procedureName"];
            this.procedureId = _data["procedureId"];
            this.status = _data["status"];
            this.disposition = _data["disposition"];
            this.customerLastRespondent = _data["customerLastRespondent"];
            this.currentActiveTaskName = _data["currentActiveTaskName"];
            this.percentageOfTasksCompleted = _data["percentageOfTasksCompleted"];
            this.percentageOfTasksCompletedNumerator = _data["percentageOfTasksCompletedNumerator"];
            this.percentageOfTasksCompletedDenominator = _data["percentageOfTasksCompletedDenominator"];
            this.percentageOfExpectedDurationTimeLogged = _data["percentageOfExpectedDurationTimeLogged"];
            this.percentageOfExpectedDurationTimeLoggedNumerator = _data["percentageOfExpectedDurationTimeLoggedNumerator"];
            this.percentageOfExpectedDurationTimeLoggedDenominator = _data["percentageOfExpectedDurationTimeLoggedDenominator"];
            this.hasNCR = _data["hasNCR"];
            this.segregationType = _data["segregationType"];
            this.price = _data["price"];
            this.endDateChangeReason = _data["endDateChangeReason"];
            this.endDateChanged = _data["endDateChanged"];
            this.woShippedStatus = _data["woShippedStatus"];
            this.workOrderPartId = _data["workOrderPartId"];
            this.isKit = _data["isKit"];
            this.hasPurchaseFiles = _data["hasPurchaseFiles"];
            if (Array.isArray(_data["workOrderMessages"])) {
                this.workOrderMessages = [] as any;
                for (let item of _data["workOrderMessages"])
                    this.workOrderMessages!.push(WorkOrderMessageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderGridDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderGridDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderNumber"] = this.workOrderNumber;
        data["workOrderItemNumber"] = this.workOrderItemNumber;
        data["serialNumber"] = this.serialNumber;
        data["allSerialNumbers"] = this.allSerialNumbers;
        data["purchasePartMapSerialNumber"] = this.purchasePartMapSerialNumber;
        data["quantity"] = this.quantity;
        data["scheduledStartDate"] = this.scheduledStartDate ? this.scheduledStartDate.toISOString() : undefined as any;
        data["scheduledEndDate"] = this.scheduledEndDate ? this.scheduledEndDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["partName"] = this.partName;
        data["procedureName"] = this.procedureName;
        data["procedureId"] = this.procedureId;
        data["status"] = this.status;
        data["disposition"] = this.disposition;
        data["customerLastRespondent"] = this.customerLastRespondent;
        data["currentActiveTaskName"] = this.currentActiveTaskName;
        data["percentageOfTasksCompleted"] = this.percentageOfTasksCompleted;
        data["percentageOfTasksCompletedNumerator"] = this.percentageOfTasksCompletedNumerator;
        data["percentageOfTasksCompletedDenominator"] = this.percentageOfTasksCompletedDenominator;
        data["percentageOfExpectedDurationTimeLogged"] = this.percentageOfExpectedDurationTimeLogged;
        data["percentageOfExpectedDurationTimeLoggedNumerator"] = this.percentageOfExpectedDurationTimeLoggedNumerator;
        data["percentageOfExpectedDurationTimeLoggedDenominator"] = this.percentageOfExpectedDurationTimeLoggedDenominator;
        data["hasNCR"] = this.hasNCR;
        data["segregationType"] = this.segregationType;
        data["price"] = this.price;
        data["endDateChangeReason"] = this.endDateChangeReason;
        data["endDateChanged"] = this.endDateChanged;
        data["woShippedStatus"] = this.woShippedStatus;
        data["workOrderPartId"] = this.workOrderPartId;
        data["isKit"] = this.isKit;
        data["hasPurchaseFiles"] = this.hasPurchaseFiles;
        if (Array.isArray(this.workOrderMessages)) {
            data["workOrderMessages"] = [];
            for (let item of this.workOrderMessages)
                data["workOrderMessages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkOrderGridDataItem {
    workOrderNumber?: number;
    workOrderItemNumber?: string | undefined;
    serialNumber?: string | undefined;
    allSerialNumbers?: string | undefined;
    purchasePartMapSerialNumber?: string | undefined;
    quantity?: number | undefined;
    scheduledStartDate?: Date | undefined;
    scheduledEndDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    partName?: string | undefined;
    procedureName?: string | undefined;
    procedureId?: number | undefined;
    status?: string | undefined;
    disposition?: string | undefined;
    customerLastRespondent?: boolean;
    currentActiveTaskName?: string | undefined;
    percentageOfTasksCompleted?: number | undefined;
    percentageOfTasksCompletedNumerator?: number | undefined;
    percentageOfTasksCompletedDenominator?: number | undefined;
    percentageOfExpectedDurationTimeLogged?: number | undefined;
    percentageOfExpectedDurationTimeLoggedNumerator?: number | undefined;
    percentageOfExpectedDurationTimeLoggedDenominator?: number | undefined;
    hasNCR?: boolean;
    segregationType?: string | undefined;
    price?: number | undefined;
    endDateChangeReason?: string | undefined;
    endDateChanged?: number | undefined;
    woShippedStatus?: boolean;
    workOrderPartId?: number | undefined;
    isKit?: boolean;
    hasPurchaseFiles?: boolean;
    workOrderMessages?: WorkOrderMessageModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderSelectItem extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderSelectItem {
    object?: WorkOrderSelectItem[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderSelectItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderSelectItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderSelectItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderSelectItem extends IAuditActionResult {
    object?: WorkOrderSelectItem[] | undefined;
}

export class WorkOrderSelectItem implements IWorkOrderSelectItem {
    workOrderId?: number;
    customerPurchaseNumber?: string | undefined;
    procedureName?: string | undefined;
    purchaseSerialNumber?: string | undefined;
    workOrderStatusId?: string | undefined;

    constructor(data?: IWorkOrderSelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.customerPurchaseNumber = _data["customerPurchaseNumber"];
            this.procedureName = _data["procedureName"];
            this.purchaseSerialNumber = _data["purchaseSerialNumber"];
            this.workOrderStatusId = _data["workOrderStatusId"];
        }
    }

    static fromJS(data: any): WorkOrderSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderSelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["customerPurchaseNumber"] = this.customerPurchaseNumber;
        data["procedureName"] = this.procedureName;
        data["purchaseSerialNumber"] = this.purchaseSerialNumber;
        data["workOrderStatusId"] = this.workOrderStatusId;
        return data;
    }
}

export interface IWorkOrderSelectItem {
    workOrderId?: number;
    customerPurchaseNumber?: string | undefined;
    procedureName?: string | undefined;
    purchaseSerialNumber?: string | undefined;
    workOrderStatusId?: string | undefined;
}

export class Filter implements IFilter {
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;
    logic?: string | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this.logic = _data["logic"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["logic"] = this.logic;
        return data;
    }
}

export interface IFilter {
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;
    logic?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderStatus extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderStatus {
    object?: WorkOrderStatus[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderStatus.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderStatus extends IAuditActionResult {
    object?: WorkOrderStatus[] | undefined;
}

export class WorkOrderStatus implements IWorkOrderStatus {
    productName?: string | undefined;
    partNumber?: string | undefined;
    procedureName?: string | undefined;
    locationName?: string | undefined;
    workOrderSummary?: WorkOrderSummary | undefined;

    constructor(data?: IWorkOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.partNumber = _data["partNumber"];
            this.procedureName = _data["procedureName"];
            this.locationName = _data["locationName"];
            this.workOrderSummary = _data["workOrderSummary"] ? WorkOrderSummary.fromJS(_data["workOrderSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["partNumber"] = this.partNumber;
        data["procedureName"] = this.procedureName;
        data["locationName"] = this.locationName;
        data["workOrderSummary"] = this.workOrderSummary ? this.workOrderSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkOrderStatus {
    productName?: string | undefined;
    partNumber?: string | undefined;
    procedureName?: string | undefined;
    locationName?: string | undefined;
    workOrderSummary?: WorkOrderSummary | undefined;
}

export class WorkOrderSummary implements IWorkOrderSummary {
    workOrderId?: number | undefined;
    workOrderItemNumber?: string | undefined;
    purchaseOrderLineNumber?: string | undefined;
    workOrderPartSerialNumber?: string | undefined;
    workOrderStatus?: string | undefined;
    workOrderAssignedTo?: string | undefined;
    assignedTo?: number | undefined;
    workOrderHasNcr?: boolean;
    workOrderScheduledEndDate?: Date | undefined;

    constructor(data?: IWorkOrderSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.workOrderItemNumber = _data["workOrderItemNumber"];
            this.purchaseOrderLineNumber = _data["purchaseOrderLineNumber"];
            this.workOrderPartSerialNumber = _data["workOrderPartSerialNumber"];
            this.workOrderStatus = _data["workOrderStatus"];
            this.workOrderAssignedTo = _data["workOrderAssignedTo"];
            this.assignedTo = _data["assignedTo"];
            this.workOrderHasNcr = _data["workOrderHasNcr"];
            this.workOrderScheduledEndDate = _data["workOrderScheduledEndDate"] ? new Date(_data["workOrderScheduledEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderSummary {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["workOrderItemNumber"] = this.workOrderItemNumber;
        data["purchaseOrderLineNumber"] = this.purchaseOrderLineNumber;
        data["workOrderPartSerialNumber"] = this.workOrderPartSerialNumber;
        data["workOrderStatus"] = this.workOrderStatus;
        data["workOrderAssignedTo"] = this.workOrderAssignedTo;
        data["assignedTo"] = this.assignedTo;
        data["workOrderHasNcr"] = this.workOrderHasNcr;
        data["workOrderScheduledEndDate"] = this.workOrderScheduledEndDate ? this.workOrderScheduledEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderSummary {
    workOrderId?: number | undefined;
    workOrderItemNumber?: string | undefined;
    purchaseOrderLineNumber?: string | undefined;
    workOrderPartSerialNumber?: string | undefined;
    workOrderStatus?: string | undefined;
    workOrderAssignedTo?: string | undefined;
    assignedTo?: number | undefined;
    workOrderHasNcr?: boolean;
    workOrderScheduledEndDate?: Date | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderModel extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderModel {
    object?: WorkOrderModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderModel extends IAuditActionResult {
    object?: WorkOrderModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfInvoiceableWorkOrderView extends AuditActionResult implements IAuditActionResultOfICollectionOfInvoiceableWorkOrderView {
    object?: InvoiceableWorkOrderView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfInvoiceableWorkOrderView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(InvoiceableWorkOrderView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfInvoiceableWorkOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfInvoiceableWorkOrderView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfInvoiceableWorkOrderView extends IAuditActionResult {
    object?: InvoiceableWorkOrderView[] | undefined;
}

export class InvoiceableWorkOrderView implements IInvoiceableWorkOrderView {
    customerName?: string | undefined;
    customerId?: number;
    id?: number;
    purchaseOrderId?: number;
    referencePO?: string | undefined;
    customerPurchaseNumber?: string | undefined;
    serialNumber?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    partId?: number;
    partName?: string | undefined;
    actualEndDate?: Date | undefined;
    totalSalePrice?: number;
    customerLineNumber?: string | undefined;

    constructor(data?: IInvoiceableWorkOrderView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.customerId = _data["customerId"];
            this.id = _data["id"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.referencePO = _data["referencePO"];
            this.customerPurchaseNumber = _data["customerPurchaseNumber"];
            this.serialNumber = _data["serialNumber"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.partId = _data["partId"];
            this.partName = _data["partName"];
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.totalSalePrice = _data["totalSalePrice"];
            this.customerLineNumber = _data["customerLineNumber"];
        }
    }

    static fromJS(data: any): InvoiceableWorkOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceableWorkOrderView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["referencePO"] = this.referencePO;
        data["customerPurchaseNumber"] = this.customerPurchaseNumber;
        data["serialNumber"] = this.serialNumber;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["partId"] = this.partId;
        data["partName"] = this.partName;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["totalSalePrice"] = this.totalSalePrice;
        data["customerLineNumber"] = this.customerLineNumber;
        return data;
    }
}

export interface IInvoiceableWorkOrderView {
    customerName?: string | undefined;
    customerId?: number;
    id?: number;
    purchaseOrderId?: number;
    referencePO?: string | undefined;
    customerPurchaseNumber?: string | undefined;
    serialNumber?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    partId?: number;
    partName?: string | undefined;
    actualEndDate?: Date | undefined;
    totalSalePrice?: number;
    customerLineNumber?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfInvoiceablePurchaseView extends AuditActionResult implements IAuditActionResultOfICollectionOfInvoiceablePurchaseView {
    object?: InvoiceablePurchaseView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfInvoiceablePurchaseView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(InvoiceablePurchaseView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfInvoiceablePurchaseView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfInvoiceablePurchaseView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfInvoiceablePurchaseView extends IAuditActionResult {
    object?: InvoiceablePurchaseView[] | undefined;
}

export class InvoiceablePurchaseView implements IInvoiceablePurchaseView {
    customerName?: string | undefined;
    customerId?: number;
    id?: number;
    purchaseOrderId?: number;
    referencePO?: string | undefined;
    customerPurchaseNumber?: string | undefined;
    serialNumber?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    invoiceClass?: string | undefined;
    partId?: number | undefined;
    partName?: string | undefined;
    actualEndDate?: Date | undefined;
    purchasePrice?: number;
    totalSalePrice?: number;
    customerLineNumber?: string | undefined;
    purchaseParts?: string | undefined;

    constructor(data?: IInvoiceablePurchaseView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.customerId = _data["customerId"];
            this.id = _data["id"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.referencePO = _data["referencePO"];
            this.customerPurchaseNumber = _data["customerPurchaseNumber"];
            this.serialNumber = _data["serialNumber"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.invoiceClass = _data["invoiceClass"];
            this.partId = _data["partId"];
            this.partName = _data["partName"];
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.purchasePrice = _data["purchasePrice"];
            this.totalSalePrice = _data["totalSalePrice"];
            this.customerLineNumber = _data["customerLineNumber"];
            this.purchaseParts = _data["purchaseParts"];
        }
    }

    static fromJS(data: any): InvoiceablePurchaseView {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceablePurchaseView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["referencePO"] = this.referencePO;
        data["customerPurchaseNumber"] = this.customerPurchaseNumber;
        data["serialNumber"] = this.serialNumber;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["invoiceClass"] = this.invoiceClass;
        data["partId"] = this.partId;
        data["partName"] = this.partName;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["purchasePrice"] = this.purchasePrice;
        data["totalSalePrice"] = this.totalSalePrice;
        data["customerLineNumber"] = this.customerLineNumber;
        data["purchaseParts"] = this.purchaseParts;
        return data;
    }
}

export interface IInvoiceablePurchaseView {
    customerName?: string | undefined;
    customerId?: number;
    id?: number;
    purchaseOrderId?: number;
    referencePO?: string | undefined;
    customerPurchaseNumber?: string | undefined;
    serialNumber?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    invoiceClass?: string | undefined;
    partId?: number | undefined;
    partName?: string | undefined;
    actualEndDate?: Date | undefined;
    purchasePrice?: number;
    totalSalePrice?: number;
    customerLineNumber?: string | undefined;
    purchaseParts?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfPortalWorkOrderView extends AuditActionResult implements IAuditActionResultOfICollectionOfPortalWorkOrderView {
    object?: PortalWorkOrderView[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfPortalWorkOrderView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(PortalWorkOrderView.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfPortalWorkOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfPortalWorkOrderView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfPortalWorkOrderView extends IAuditActionResult {
    object?: PortalWorkOrderView[] | undefined;
}

export class PortalWorkOrderView implements IPortalWorkOrderView {
    id?: number;
    workOrderId?: number;
    customerId?: number | undefined;
    customerName?: string | undefined;
    serialNumber?: string | undefined;
    companyPartNumber?: string | undefined;
    cycleCount?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    qty?: number | undefined;
    startDate?: Date | undefined;
    dueDate?: Date | undefined;
    partName?: string | undefined;
    partId?: number | undefined;
    productName?: string | undefined;
    procedureName?: string | undefined;
    status?: string | undefined;
    workOrderTaskId?: number | undefined;
    hasPhotos?: boolean;
    hasNCRs?: boolean;
    hasFiles?: boolean;
    hasMonitors?: boolean;
    disposition?: string | undefined;
    supplier?: string | undefined;
    price?: number | undefined;
    invoiceAmount?: number | undefined;
    invoiceDate?: Date | undefined;
    invoiceName?: string | undefined;
    percentageOfTasksCompleted?: number | undefined;
    percentageOfTasksCompletedNumerator?: number | undefined;
    percentageOfTasksCompletedDenominator?: number | undefined;
    percentageOfExpectedDurationTimeLogged?: number | undefined;
    percentageOfExpectedDurationTimeLoggedNumerator?: number | undefined;
    percentageOfExpectedDurationTimeLoggedDenominator?: number | undefined;
    messages?: WorkOrderMessageModel[] | undefined;
    subParts?: SubPartModel[] | undefined;
    stepText?: string | undefined;
    customerLastRespondent?: boolean;

    constructor(data?: IPortalWorkOrderView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workOrderId = _data["workOrderId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.serialNumber = _data["serialNumber"];
            this.companyPartNumber = _data["companyPartNumber"];
            this.cycleCount = _data["cycleCount"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.qty = _data["qty"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.partName = _data["partName"];
            this.partId = _data["partId"];
            this.productName = _data["productName"];
            this.procedureName = _data["procedureName"];
            this.status = _data["status"];
            this.workOrderTaskId = _data["workOrderTaskId"];
            this.hasPhotos = _data["hasPhotos"];
            this.hasNCRs = _data["hasNCRs"];
            this.hasFiles = _data["hasFiles"];
            this.hasMonitors = _data["hasMonitors"];
            this.disposition = _data["disposition"];
            this.supplier = _data["supplier"];
            this.price = _data["price"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceName = _data["invoiceName"];
            this.percentageOfTasksCompleted = _data["percentageOfTasksCompleted"];
            this.percentageOfTasksCompletedNumerator = _data["percentageOfTasksCompletedNumerator"];
            this.percentageOfTasksCompletedDenominator = _data["percentageOfTasksCompletedDenominator"];
            this.percentageOfExpectedDurationTimeLogged = _data["percentageOfExpectedDurationTimeLogged"];
            this.percentageOfExpectedDurationTimeLoggedNumerator = _data["percentageOfExpectedDurationTimeLoggedNumerator"];
            this.percentageOfExpectedDurationTimeLoggedDenominator = _data["percentageOfExpectedDurationTimeLoggedDenominator"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(WorkOrderMessageModel.fromJS(item));
            }
            if (Array.isArray(_data["subParts"])) {
                this.subParts = [] as any;
                for (let item of _data["subParts"])
                    this.subParts!.push(SubPartModel.fromJS(item));
            }
            this.stepText = _data["stepText"];
            this.customerLastRespondent = _data["customerLastRespondent"];
        }
    }

    static fromJS(data: any): PortalWorkOrderView {
        data = typeof data === 'object' ? data : {};
        let result = new PortalWorkOrderView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workOrderId"] = this.workOrderId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["serialNumber"] = this.serialNumber;
        data["companyPartNumber"] = this.companyPartNumber;
        data["cycleCount"] = this.cycleCount;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["qty"] = this.qty;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["partName"] = this.partName;
        data["partId"] = this.partId;
        data["productName"] = this.productName;
        data["procedureName"] = this.procedureName;
        data["status"] = this.status;
        data["workOrderTaskId"] = this.workOrderTaskId;
        data["hasPhotos"] = this.hasPhotos;
        data["hasNCRs"] = this.hasNCRs;
        data["hasFiles"] = this.hasFiles;
        data["hasMonitors"] = this.hasMonitors;
        data["disposition"] = this.disposition;
        data["supplier"] = this.supplier;
        data["price"] = this.price;
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceName"] = this.invoiceName;
        data["percentageOfTasksCompleted"] = this.percentageOfTasksCompleted;
        data["percentageOfTasksCompletedNumerator"] = this.percentageOfTasksCompletedNumerator;
        data["percentageOfTasksCompletedDenominator"] = this.percentageOfTasksCompletedDenominator;
        data["percentageOfExpectedDurationTimeLogged"] = this.percentageOfExpectedDurationTimeLogged;
        data["percentageOfExpectedDurationTimeLoggedNumerator"] = this.percentageOfExpectedDurationTimeLoggedNumerator;
        data["percentageOfExpectedDurationTimeLoggedDenominator"] = this.percentageOfExpectedDurationTimeLoggedDenominator;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subParts)) {
            data["subParts"] = [];
            for (let item of this.subParts)
                data["subParts"].push(item ? item.toJSON() : undefined as any);
        }
        data["stepText"] = this.stepText;
        data["customerLastRespondent"] = this.customerLastRespondent;
        return data;
    }
}

export interface IPortalWorkOrderView {
    id?: number;
    workOrderId?: number;
    customerId?: number | undefined;
    customerName?: string | undefined;
    serialNumber?: string | undefined;
    companyPartNumber?: string | undefined;
    cycleCount?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    qty?: number | undefined;
    startDate?: Date | undefined;
    dueDate?: Date | undefined;
    partName?: string | undefined;
    partId?: number | undefined;
    productName?: string | undefined;
    procedureName?: string | undefined;
    status?: string | undefined;
    workOrderTaskId?: number | undefined;
    hasPhotos?: boolean;
    hasNCRs?: boolean;
    hasFiles?: boolean;
    hasMonitors?: boolean;
    disposition?: string | undefined;
    supplier?: string | undefined;
    price?: number | undefined;
    invoiceAmount?: number | undefined;
    invoiceDate?: Date | undefined;
    invoiceName?: string | undefined;
    percentageOfTasksCompleted?: number | undefined;
    percentageOfTasksCompletedNumerator?: number | undefined;
    percentageOfTasksCompletedDenominator?: number | undefined;
    percentageOfExpectedDurationTimeLogged?: number | undefined;
    percentageOfExpectedDurationTimeLoggedNumerator?: number | undefined;
    percentageOfExpectedDurationTimeLoggedDenominator?: number | undefined;
    messages?: WorkOrderMessageModel[] | undefined;
    subParts?: SubPartModel[] | undefined;
    stepText?: string | undefined;
    customerLastRespondent?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderTaskModel extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderTaskModel {
    object?: WorkOrderTaskModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderTaskModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderTaskModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderTaskModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderTaskModel extends IAuditActionResult {
    object?: WorkOrderTaskModel[] | undefined;
}

export class AddReworkWorkOrderTaskRequest implements IAddReworkWorkOrderTaskRequest {
    workOrderPartId!: number;
    procedureId!: number;
    userId?: number | undefined;
    note?: string | undefined;
    addToWOPrice?: boolean;

    constructor(data?: IAddReworkWorkOrderTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartId = _data["workOrderPartId"];
            this.procedureId = _data["procedureId"];
            this.userId = _data["userId"];
            this.note = _data["note"];
            this.addToWOPrice = _data["addToWOPrice"];
        }
    }

    static fromJS(data: any): AddReworkWorkOrderTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddReworkWorkOrderTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartId"] = this.workOrderPartId;
        data["procedureId"] = this.procedureId;
        data["userId"] = this.userId;
        data["note"] = this.note;
        data["addToWOPrice"] = this.addToWOPrice;
        return data;
    }
}

export interface IAddReworkWorkOrderTaskRequest {
    workOrderPartId: number;
    procedureId: number;
    userId?: number | undefined;
    note?: string | undefined;
    addToWOPrice?: boolean;
}

export class CreateWorkOrderRequest implements ICreateWorkOrderRequest {
    purchaseId!: number;
    workOrderPartInfos?: WorkOrderPartInfoRequest[] | undefined;
    purchaseOrderId?: number;
    scheduledStartDate?: Date;
    scheduledEndDate?: Date;
    hasNCR?: boolean;
    locationId?: number;
    price?: number;
    /** When set, only subparts whose ProcedureId matches this value are included in the WO.
Used when a kit has mixed-procedure subparts and is being split into one WO per procedure group. */
    procedureFilter?: number | undefined;

    constructor(data?: ICreateWorkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            if (Array.isArray(_data["workOrderPartInfos"])) {
                this.workOrderPartInfos = [] as any;
                for (let item of _data["workOrderPartInfos"])
                    this.workOrderPartInfos!.push(WorkOrderPartInfoRequest.fromJS(item));
            }
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.scheduledStartDate = _data["scheduledStartDate"] ? new Date(_data["scheduledStartDate"].toString()) : undefined as any;
            this.scheduledEndDate = _data["scheduledEndDate"] ? new Date(_data["scheduledEndDate"].toString()) : undefined as any;
            this.hasNCR = _data["hasNCR"];
            this.locationId = _data["locationId"];
            this.price = _data["price"];
            this.procedureFilter = _data["procedureFilter"];
        }
    }

    static fromJS(data: any): CreateWorkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        if (Array.isArray(this.workOrderPartInfos)) {
            data["workOrderPartInfos"] = [];
            for (let item of this.workOrderPartInfos)
                data["workOrderPartInfos"].push(item ? item.toJSON() : undefined as any);
        }
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["scheduledStartDate"] = this.scheduledStartDate ? this.scheduledStartDate.toISOString() : undefined as any;
        data["scheduledEndDate"] = this.scheduledEndDate ? this.scheduledEndDate.toISOString() : undefined as any;
        data["hasNCR"] = this.hasNCR;
        data["locationId"] = this.locationId;
        data["price"] = this.price;
        data["procedureFilter"] = this.procedureFilter;
        return data;
    }
}

export interface ICreateWorkOrderRequest {
    purchaseId: number;
    workOrderPartInfos?: WorkOrderPartInfoRequest[] | undefined;
    purchaseOrderId?: number;
    scheduledStartDate?: Date;
    scheduledEndDate?: Date;
    hasNCR?: boolean;
    locationId?: number;
    price?: number;
    /** When set, only subparts whose ProcedureId matches this value are included in the WO.
Used when a kit has mixed-procedure subparts and is being split into one WO per procedure group. */
    procedureFilter?: number | undefined;
}

export class WorkOrderPartInfoRequest implements IWorkOrderPartInfoRequest {
    purchaseOrderPartId?: number;
    serializeIndividually?: boolean;
    serialNumbers?: string[] | undefined;
    customerLineNumbers?: string[] | undefined;
    partData?: string[] | undefined;
    qty?: number;
    price?: number;
    poNumber?: string | undefined;
    note?: string | undefined;

    constructor(data?: IWorkOrderPartInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderPartId = _data["purchaseOrderPartId"];
            this.serializeIndividually = _data["serializeIndividually"];
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(item);
            }
            if (Array.isArray(_data["customerLineNumbers"])) {
                this.customerLineNumbers = [] as any;
                for (let item of _data["customerLineNumbers"])
                    this.customerLineNumbers!.push(item);
            }
            if (Array.isArray(_data["partData"])) {
                this.partData = [] as any;
                for (let item of _data["partData"])
                    this.partData!.push(item);
            }
            this.qty = _data["qty"];
            this.price = _data["price"];
            this.poNumber = _data["poNumber"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): WorkOrderPartInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderPartId"] = this.purchaseOrderPartId;
        data["serializeIndividually"] = this.serializeIndividually;
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item);
        }
        if (Array.isArray(this.customerLineNumbers)) {
            data["customerLineNumbers"] = [];
            for (let item of this.customerLineNumbers)
                data["customerLineNumbers"].push(item);
        }
        if (Array.isArray(this.partData)) {
            data["partData"] = [];
            for (let item of this.partData)
                data["partData"].push(item);
        }
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["poNumber"] = this.poNumber;
        data["note"] = this.note;
        return data;
    }
}

export interface IWorkOrderPartInfoRequest {
    purchaseOrderPartId?: number;
    serializeIndividually?: boolean;
    serialNumbers?: string[] | undefined;
    customerLineNumbers?: string[] | undefined;
    partData?: string[] | undefined;
    qty?: number;
    price?: number;
    poNumber?: string | undefined;
    note?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderMessageModel extends AuditActionResult implements IAuditActionResultOfWorkOrderMessageModel {
    object?: WorkOrderMessageModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderMessageModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderMessageModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderMessageModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderMessageModel extends IAuditActionResult {
    object?: WorkOrderMessageModel | undefined;
}

export class CreateWorkOrderMessageRequest implements ICreateWorkOrderMessageRequest {
    id!: number;
    message!: string;

    constructor(data?: ICreateWorkOrderMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateWorkOrderMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkOrderMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateWorkOrderMessageRequest {
    id: number;
    message: string;
}

export class TakeOverWorkOrderRequest implements ITakeOverWorkOrderRequest {
    workOrderId?: number;
    userId?: number;

    constructor(data?: ITakeOverWorkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TakeOverWorkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TakeOverWorkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITakeOverWorkOrderRequest {
    workOrderId?: number;
    userId?: number;
}

export class CancelWorkOrderRequest implements ICancelWorkOrderRequest {
    workOrderId?: number;
    invoiceable?: boolean;

    constructor(data?: ICancelWorkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.invoiceable = _data["invoiceable"];
        }
    }

    static fromJS(data: any): CancelWorkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelWorkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["invoiceable"] = this.invoiceable;
        return data;
    }
}

export interface ICancelWorkOrderRequest {
    workOrderId?: number;
    invoiceable?: boolean;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderModel extends AuditActionResult implements IAuditActionResultOfWorkOrderModel {
    object?: WorkOrderModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderModel extends IAuditActionResult {
    object?: WorkOrderModel | undefined;
}

export class UpdateWorkOrderPriceRequest implements IUpdateWorkOrderPriceRequest {
    workOrderId?: number;
    price?: number;

    constructor(data?: IUpdateWorkOrderPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UpdateWorkOrderPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["price"] = this.price;
        return data;
    }
}

export interface IUpdateWorkOrderPriceRequest {
    workOrderId?: number;
    price?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfPurchaseModel extends AuditActionResult implements IAuditActionResultOfPurchaseModel {
    object?: PurchaseModel | undefined;

    constructor(data?: IAuditActionResultOfPurchaseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? PurchaseModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfPurchaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfPurchaseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfPurchaseModel extends IAuditActionResult {
    object?: PurchaseModel | undefined;
}

export class UpdatePurchasePriceRequest implements IUpdatePurchasePriceRequest {
    purchaseId?: number;
    purchasePrice?: number;

    constructor(data?: IUpdatePurchasePriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            this.purchasePrice = _data["purchasePrice"];
        }
    }

    static fromJS(data: any): UpdatePurchasePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchasePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        data["purchasePrice"] = this.purchasePrice;
        return data;
    }
}

export interface IUpdatePurchasePriceRequest {
    purchaseId?: number;
    purchasePrice?: number;
}

export class UpdateWorkOrderEndDateRequest implements IUpdateWorkOrderEndDateRequest {
    workOrderId?: number;
    scheduledEndDate?: Date;
    scheduledEndDateChangeReason?: string | undefined;

    constructor(data?: IUpdateWorkOrderEndDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.scheduledEndDate = _data["scheduledEndDate"] ? new Date(_data["scheduledEndDate"].toString()) : undefined as any;
            this.scheduledEndDateChangeReason = _data["scheduledEndDateChangeReason"];
        }
    }

    static fromJS(data: any): UpdateWorkOrderEndDateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderEndDateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["scheduledEndDate"] = this.scheduledEndDate ? this.scheduledEndDate.toISOString() : undefined as any;
        data["scheduledEndDateChangeReason"] = this.scheduledEndDateChangeReason;
        return data;
    }
}

export interface IUpdateWorkOrderEndDateRequest {
    workOrderId?: number;
    scheduledEndDate?: Date;
    scheduledEndDateChangeReason?: string | undefined;
}

export class ConfirmPurchaseShippedRequest implements IConfirmPurchaseShippedRequest {
    purchaseId?: number;
    shippingMethod?: string | undefined;
    trackingNumber?: string | undefined;

    constructor(data?: IConfirmPurchaseShippedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            this.shippingMethod = _data["shippingMethod"];
            this.trackingNumber = _data["trackingNumber"];
        }
    }

    static fromJS(data: any): ConfirmPurchaseShippedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPurchaseShippedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        data["shippingMethod"] = this.shippingMethod;
        data["trackingNumber"] = this.trackingNumber;
        return data;
    }
}

export interface IConfirmPurchaseShippedRequest {
    purchaseId?: number;
    shippingMethod?: string | undefined;
    trackingNumber?: string | undefined;
}

export class TransmitXmlByWorkOrderRequest implements ITransmitXmlByWorkOrderRequest {
    workOrderId?: number;

    constructor(data?: ITransmitXmlByWorkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
        }
    }

    static fromJS(data: any): TransmitXmlByWorkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransmitXmlByWorkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        return data;
    }
}

export interface ITransmitXmlByWorkOrderRequest {
    workOrderId?: number;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderPartModel extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderPartModel {
    object?: WorkOrderPartModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderPartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderPartModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderPartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderPartModel extends IAuditActionResult {
    object?: WorkOrderPartModel[] | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderPartModel extends AuditActionResult implements IAuditActionResultOfWorkOrderPartModel {
    object?: WorkOrderPartModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderPartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderPartModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderPartModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderPartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderPartModel extends IAuditActionResult {
    object?: WorkOrderPartModel | undefined;
}

export class AddWorkOrderPartRequest implements IAddWorkOrderPartRequest {
    workOrderId!: number;
    partId!: number;
    qty!: number;
    serialNumber?: string | undefined;

    constructor(data?: IAddWorkOrderPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.partId = _data["partId"];
            this.qty = _data["qty"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): AddWorkOrderPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkOrderPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["partId"] = this.partId;
        data["qty"] = this.qty;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IAddWorkOrderPartRequest {
    workOrderId: number;
    partId: number;
    qty: number;
    serialNumber?: string | undefined;
}

export class UpdateWorkOrderPartRequest implements IUpdateWorkOrderPartRequest {
    workOrderPartId?: number;
    serialNumber?: string | undefined;
    partData?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    poNumber?: string | undefined;
    actualPONumber?: string | undefined;
    note?: string | undefined;
    customerLineNumber?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdateWorkOrderPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartId = _data["workOrderPartId"];
            this.serialNumber = _data["serialNumber"];
            this.partData = _data["partData"];
            this.segregationType = _data["segregationType"];
            this.poNumber = _data["poNumber"];
            this.actualPONumber = _data["actualPONumber"];
            this.note = _data["note"];
            this.customerLineNumber = _data["customerLineNumber"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateWorkOrderPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartId"] = this.workOrderPartId;
        data["serialNumber"] = this.serialNumber;
        data["partData"] = this.partData;
        data["segregationType"] = this.segregationType;
        data["poNumber"] = this.poNumber;
        data["actualPONumber"] = this.actualPONumber;
        data["note"] = this.note;
        data["customerLineNumber"] = this.customerLineNumber;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateWorkOrderPartRequest {
    workOrderPartId?: number;
    serialNumber?: string | undefined;
    partData?: string | undefined;
    segregationType?: EnumSegregationType | undefined;
    poNumber?: string | undefined;
    actualPONumber?: string | undefined;
    note?: string | undefined;
    customerLineNumber?: string | undefined;
    isActive?: boolean | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfNCRPartWODetailView extends AuditActionResult implements IAuditActionResultOfNCRPartWODetailView {
    object?: NCRPartWODetailView | undefined;

    constructor(data?: IAuditActionResultOfNCRPartWODetailView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? NCRPartWODetailView.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfNCRPartWODetailView {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfNCRPartWODetailView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfNCRPartWODetailView extends IAuditActionResult {
    object?: NCRPartWODetailView | undefined;
}

export class NCRPartWODetailView implements INCRPartWODetailView {
    workOrderId?: number;
    workOrderCompletedDate?: Date | undefined;
    workOrderPartId?: number;
    partNumber?: string | undefined;
    partName?: string | undefined;
    serialNumber?: string | undefined;
    workOrderPartMonitors?: WorkOrderPartMonitorView[] | undefined;

    constructor(data?: INCRPartWODetailView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.workOrderCompletedDate = _data["workOrderCompletedDate"] ? new Date(_data["workOrderCompletedDate"].toString()) : undefined as any;
            this.workOrderPartId = _data["workOrderPartId"];
            this.partNumber = _data["partNumber"];
            this.partName = _data["partName"];
            this.serialNumber = _data["serialNumber"];
            if (Array.isArray(_data["workOrderPartMonitors"])) {
                this.workOrderPartMonitors = [] as any;
                for (let item of _data["workOrderPartMonitors"])
                    this.workOrderPartMonitors!.push(WorkOrderPartMonitorView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NCRPartWODetailView {
        data = typeof data === 'object' ? data : {};
        let result = new NCRPartWODetailView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["workOrderCompletedDate"] = this.workOrderCompletedDate ? this.workOrderCompletedDate.toISOString() : undefined as any;
        data["workOrderPartId"] = this.workOrderPartId;
        data["partNumber"] = this.partNumber;
        data["partName"] = this.partName;
        data["serialNumber"] = this.serialNumber;
        if (Array.isArray(this.workOrderPartMonitors)) {
            data["workOrderPartMonitors"] = [];
            for (let item of this.workOrderPartMonitors)
                data["workOrderPartMonitors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INCRPartWODetailView {
    workOrderId?: number;
    workOrderCompletedDate?: Date | undefined;
    workOrderPartId?: number;
    partNumber?: string | undefined;
    partName?: string | undefined;
    serialNumber?: string | undefined;
    workOrderPartMonitors?: WorkOrderPartMonitorView[] | undefined;
}

export class WorkOrderPartMonitorView implements IWorkOrderPartMonitorView {
    workOrderPartMonitorId?: number;
    workOrderPartMonitorDescription?: string | undefined;
    result?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IWorkOrderPartMonitorView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartMonitorId = _data["workOrderPartMonitorId"];
            this.workOrderPartMonitorDescription = _data["workOrderPartMonitorDescription"];
            this.result = _data["result"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): WorkOrderPartMonitorView {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPartMonitorView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartMonitorId"] = this.workOrderPartMonitorId;
        data["workOrderPartMonitorDescription"] = this.workOrderPartMonitorDescription;
        data["result"] = this.result;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IWorkOrderPartMonitorView {
    workOrderPartMonitorId?: number;
    workOrderPartMonitorDescription?: string | undefined;
    result?: string | undefined;
    comment?: string | undefined;
}

export class BulkUpdateWorkOrderPartRequest implements IBulkUpdateWorkOrderPartRequest {
    workOrderPartIds?: number[] | undefined;
    partData?: string | undefined;

    constructor(data?: IBulkUpdateWorkOrderPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workOrderPartIds"])) {
                this.workOrderPartIds = [] as any;
                for (let item of _data["workOrderPartIds"])
                    this.workOrderPartIds!.push(item);
            }
            this.partData = _data["partData"];
        }
    }

    static fromJS(data: any): BulkUpdateWorkOrderPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateWorkOrderPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderPartIds)) {
            data["workOrderPartIds"] = [];
            for (let item of this.workOrderPartIds)
                data["workOrderPartIds"].push(item);
        }
        data["partData"] = this.partData;
        return data;
    }
}

export interface IBulkUpdateWorkOrderPartRequest {
    workOrderPartIds?: number[] | undefined;
    partData?: string | undefined;
}

export class CycleCountUpdateRequest implements ICycleCountUpdateRequest {
    partNumber?: string | undefined;
    serialNumber?: string | undefined;
    cycleCount?: number;

    constructor(data?: ICycleCountUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partNumber = _data["partNumber"];
            this.serialNumber = _data["serialNumber"];
            this.cycleCount = _data["cycleCount"];
        }
    }

    static fromJS(data: any): CycleCountUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CycleCountUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partNumber"] = this.partNumber;
        data["serialNumber"] = this.serialNumber;
        data["cycleCount"] = this.cycleCount;
        return data;
    }
}

export interface ICycleCountUpdateRequest {
    partNumber?: string | undefined;
    serialNumber?: string | undefined;
    cycleCount?: number;
}

export class SplitWorkOrderPartRequest implements ISplitWorkOrderPartRequest {
    workOrderPartId!: number;
    reasonToSplit!: string;

    constructor(data?: ISplitWorkOrderPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartId = _data["workOrderPartId"];
            this.reasonToSplit = _data["reasonToSplit"];
        }
    }

    static fromJS(data: any): SplitWorkOrderPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SplitWorkOrderPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartId"] = this.workOrderPartId;
        data["reasonToSplit"] = this.reasonToSplit;
        return data;
    }
}

export interface ISplitWorkOrderPartRequest {
    workOrderPartId: number;
    reasonToSplit: string;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfICollectionOfWorkOrderPartNCRModel extends AuditActionResult implements IAuditActionResultOfICollectionOfWorkOrderPartNCRModel {
    object?: WorkOrderPartNCRModel[] | undefined;

    constructor(data?: IAuditActionResultOfICollectionOfWorkOrderPartNCRModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["object"])) {
                this.object = [] as any;
                for (let item of _data["object"])
                    this.object!.push(WorkOrderPartNCRModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AuditActionResultOfICollectionOfWorkOrderPartNCRModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfICollectionOfWorkOrderPartNCRModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.object)) {
            data["object"] = [];
            for (let item of this.object)
                data["object"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfICollectionOfWorkOrderPartNCRModel extends IAuditActionResult {
    object?: WorkOrderPartNCRModel[] | undefined;
}

export class CreateWorkOrderPartNCRRequest implements ICreateWorkOrderPartNCRRequest {
    workOrderPartIds!: number[];
    createIndividually?: boolean;
    typeId?: number | undefined;
    tagType?: string | undefined;
    description!: string;
    recommendation!: string;

    constructor(data?: ICreateWorkOrderPartNCRRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.workOrderPartIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workOrderPartIds"])) {
                this.workOrderPartIds = [] as any;
                for (let item of _data["workOrderPartIds"])
                    this.workOrderPartIds!.push(item);
            }
            this.createIndividually = _data["createIndividually"];
            this.typeId = _data["typeId"];
            this.tagType = _data["tagType"];
            this.description = _data["description"];
            this.recommendation = _data["recommendation"];
        }
    }

    static fromJS(data: any): CreateWorkOrderPartNCRRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkOrderPartNCRRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderPartIds)) {
            data["workOrderPartIds"] = [];
            for (let item of this.workOrderPartIds)
                data["workOrderPartIds"].push(item);
        }
        data["createIndividually"] = this.createIndividually;
        data["typeId"] = this.typeId;
        data["tagType"] = this.tagType;
        data["description"] = this.description;
        data["recommendation"] = this.recommendation;
        return data;
    }
}

export interface ICreateWorkOrderPartNCRRequest {
    workOrderPartIds: number[];
    createIndividually?: boolean;
    typeId?: number | undefined;
    tagType?: string | undefined;
    description: string;
    recommendation: string;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderPartNCRModel extends AuditActionResult implements IAuditActionResultOfWorkOrderPartNCRModel {
    object?: WorkOrderPartNCRModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderPartNCRModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderPartNCRModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderPartNCRModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderPartNCRModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderPartNCRModel extends IAuditActionResult {
    object?: WorkOrderPartNCRModel | undefined;
}

export class UpdateWorkOrderPartNCRRequest implements IUpdateWorkOrderPartNCRRequest {
    id!: number;
    typeId?: number | undefined;
    tagType?: string | undefined;
    description?: string | undefined;
    recommendation?: string | undefined;
    disposition?: string | undefined;
    closedOn?: Date | undefined;
    workOrderPartTagTypes?: { [key: string]: string; } | undefined;

    constructor(data?: IUpdateWorkOrderPartNCRRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.tagType = _data["tagType"];
            this.description = _data["description"];
            this.recommendation = _data["recommendation"];
            this.disposition = _data["disposition"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            if (_data["workOrderPartTagTypes"]) {
                this.workOrderPartTagTypes = {} as any;
                for (let key in _data["workOrderPartTagTypes"]) {
                    if (_data["workOrderPartTagTypes"].hasOwnProperty(key))
                        (this.workOrderPartTagTypes as any)![key] = _data["workOrderPartTagTypes"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateWorkOrderPartNCRRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderPartNCRRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["tagType"] = this.tagType;
        data["description"] = this.description;
        data["recommendation"] = this.recommendation;
        data["disposition"] = this.disposition;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        if (this.workOrderPartTagTypes) {
            data["workOrderPartTagTypes"] = {};
            for (let key in this.workOrderPartTagTypes) {
                if (this.workOrderPartTagTypes.hasOwnProperty(key))
                    (data["workOrderPartTagTypes"] as any)[key] = (this.workOrderPartTagTypes as any)[key];
            }
        }
        return data;
    }
}

export interface IUpdateWorkOrderPartNCRRequest {
    id: number;
    typeId?: number | undefined;
    tagType?: string | undefined;
    description?: string | undefined;
    recommendation?: string | undefined;
    disposition?: string | undefined;
    closedOn?: Date | undefined;
    workOrderPartTagTypes?: { [key: string]: string; } | undefined;
}

export class SendWorkOrderPartNCREmailRequest implements ISendWorkOrderPartNCREmailRequest {
    workOrderPartNCRId!: number;
    recipientEmailAddress!: string;

    constructor(data?: ISendWorkOrderPartNCREmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartNCRId = _data["workOrderPartNCRId"];
            this.recipientEmailAddress = _data["recipientEmailAddress"];
        }
    }

    static fromJS(data: any): SendWorkOrderPartNCREmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendWorkOrderPartNCREmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartNCRId"] = this.workOrderPartNCRId;
        data["recipientEmailAddress"] = this.recipientEmailAddress;
        return data;
    }
}

export interface ISendWorkOrderPartNCREmailRequest {
    workOrderPartNCRId: number;
    recipientEmailAddress: string;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderPartMonitorModel extends AuditActionResult implements IAuditActionResultOfWorkOrderPartMonitorModel {
    object?: WorkOrderPartMonitorModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderPartMonitorModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderPartMonitorModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderPartMonitorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderPartMonitorModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderPartMonitorModel extends IAuditActionResult {
    object?: WorkOrderPartMonitorModel | undefined;
}

export class UpdateWorkOrderPartMonitorRequest implements IUpdateWorkOrderPartMonitorRequest {
    workOrderPartMonitorId?: number;
    numVal?: number | undefined;
    textVal?: string | undefined;
    multiVal?: string | undefined;
    comment?: string | undefined;
    lowNumVal?: number | undefined;
    highNumVal?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;

    constructor(data?: IUpdateWorkOrderPartMonitorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderPartMonitorId = _data["workOrderPartMonitorId"];
            this.numVal = _data["numVal"];
            this.textVal = _data["textVal"];
            this.multiVal = _data["multiVal"];
            this.comment = _data["comment"];
            this.lowNumVal = _data["lowNumVal"];
            this.highNumVal = _data["highNumVal"];
            this.sciTarget = _data["sciTarget"];
            this.sciLowTarget = _data["sciLowTarget"];
            this.sciHighTarget = _data["sciHighTarget"];
        }
    }

    static fromJS(data: any): UpdateWorkOrderPartMonitorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderPartMonitorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderPartMonitorId"] = this.workOrderPartMonitorId;
        data["numVal"] = this.numVal;
        data["textVal"] = this.textVal;
        data["multiVal"] = this.multiVal;
        data["comment"] = this.comment;
        data["lowNumVal"] = this.lowNumVal;
        data["highNumVal"] = this.highNumVal;
        data["sciTarget"] = this.sciTarget;
        data["sciLowTarget"] = this.sciLowTarget;
        data["sciHighTarget"] = this.sciHighTarget;
        return data;
    }
}

export interface IUpdateWorkOrderPartMonitorRequest {
    workOrderPartMonitorId?: number;
    numVal?: number | undefined;
    textVal?: string | undefined;
    multiVal?: string | undefined;
    comment?: string | undefined;
    lowNumVal?: number | undefined;
    highNumVal?: number | undefined;
    sciTarget?: string | undefined;
    sciLowTarget?: string | undefined;
    sciHighTarget?: string | undefined;
}

/** Base class for an API call with a typed result */
export class AuditActionResultOfWorkOrderTaskModel extends AuditActionResult implements IAuditActionResultOfWorkOrderTaskModel {
    object?: WorkOrderTaskModel | undefined;

    constructor(data?: IAuditActionResultOfWorkOrderTaskModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.object = _data["object"] ? WorkOrderTaskModel.fromJS(_data["object"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AuditActionResultOfWorkOrderTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditActionResultOfWorkOrderTaskModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** Base class for an API call with a typed result */
export interface IAuditActionResultOfWorkOrderTaskModel extends IAuditActionResult {
    object?: WorkOrderTaskModel | undefined;
}

/**  */
export class CreateWorkOrderTaskRequest implements ICreateWorkOrderTaskRequest {
    /** WorkOrder we are adding the Procedure Step to */
    workOrderId?: number | undefined;
    /** The Procedure the ProcedureStep is related to */
    procedureId?: number | undefined;
    /** The ProcedureStep we are adding which will be a task of the WorkOrder */
    procedureStepId?: number | undefined;
    /** The Task Step Order number of the Procedure Step. Tasks after this will use another request to update their order */
    taskStepOrder?: number | undefined;

    constructor(data?: ICreateWorkOrderTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.procedureId = _data["procedureId"];
            this.procedureStepId = _data["procedureStepId"];
            this.taskStepOrder = _data["taskStepOrder"];
        }
    }

    static fromJS(data: any): CreateWorkOrderTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkOrderTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["procedureId"] = this.procedureId;
        data["procedureStepId"] = this.procedureStepId;
        data["taskStepOrder"] = this.taskStepOrder;
        return data;
    }
}

/**  */
export interface ICreateWorkOrderTaskRequest {
    /** WorkOrder we are adding the Procedure Step to */
    workOrderId?: number | undefined;
    /** The Procedure the ProcedureStep is related to */
    procedureId?: number | undefined;
    /** The ProcedureStep we are adding which will be a task of the WorkOrder */
    procedureStepId?: number | undefined;
    /** The Task Step Order number of the Procedure Step. Tasks after this will use another request to update their order */
    taskStepOrder?: number | undefined;
}

export class UpdateWorkOrderTaskRequest implements IUpdateWorkOrderTaskRequest {
    workOrderTaskId?: number | undefined;
    taskStepOrder?: number | undefined;
    assignedUserId?: number | undefined;
    taskIsRunning?: boolean | undefined;
    taskRunningSince?: Date;
    startedOn?: Date;
    status?: string | undefined;
    totalTaskTime?: number | undefined;
    referenceFilesIds?: number[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    mappedWorkOrderParts?: MappedWorkOrderPart2[] | undefined;

    constructor(data?: IUpdateWorkOrderTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderTaskId = _data["workOrderTaskId"];
            this.taskStepOrder = _data["taskStepOrder"];
            this.assignedUserId = _data["assignedUserId"];
            this.taskIsRunning = _data["taskIsRunning"];
            this.taskRunningSince = _data["taskRunningSince"] ? new Date(_data["taskRunningSince"].toString()) : undefined as any;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : undefined as any;
            this.status = _data["status"];
            this.totalTaskTime = _data["totalTaskTime"];
            if (Array.isArray(_data["referenceFilesIds"])) {
                this.referenceFilesIds = [] as any;
                for (let item of _data["referenceFilesIds"])
                    this.referenceFilesIds!.push(item);
            }
            if (Array.isArray(_data["referenceFiles"])) {
                this.referenceFiles = [] as any;
                for (let item of _data["referenceFiles"])
                    this.referenceFiles!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["mappedWorkOrderParts"])) {
                this.mappedWorkOrderParts = [] as any;
                for (let item of _data["mappedWorkOrderParts"])
                    this.mappedWorkOrderParts!.push(MappedWorkOrderPart2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWorkOrderTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderTaskId"] = this.workOrderTaskId;
        data["taskStepOrder"] = this.taskStepOrder;
        data["assignedUserId"] = this.assignedUserId;
        data["taskIsRunning"] = this.taskIsRunning;
        data["taskRunningSince"] = this.taskRunningSince ? this.taskRunningSince.toISOString() : undefined as any;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["status"] = this.status;
        data["totalTaskTime"] = this.totalTaskTime;
        if (Array.isArray(this.referenceFilesIds)) {
            data["referenceFilesIds"] = [];
            for (let item of this.referenceFilesIds)
                data["referenceFilesIds"].push(item);
        }
        if (Array.isArray(this.referenceFiles)) {
            data["referenceFiles"] = [];
            for (let item of this.referenceFiles)
                data["referenceFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mappedWorkOrderParts)) {
            data["mappedWorkOrderParts"] = [];
            for (let item of this.mappedWorkOrderParts)
                data["mappedWorkOrderParts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateWorkOrderTaskRequest {
    workOrderTaskId?: number | undefined;
    taskStepOrder?: number | undefined;
    assignedUserId?: number | undefined;
    taskIsRunning?: boolean | undefined;
    taskRunningSince?: Date;
    startedOn?: Date;
    status?: string | undefined;
    totalTaskTime?: number | undefined;
    referenceFilesIds?: number[] | undefined;
    referenceFiles?: FileModel[] | undefined;
    mappedWorkOrderParts?: MappedWorkOrderPart2[] | undefined;
}

export class MappedWorkOrderPart2 implements IMappedWorkOrderPart2 {
    id?: number;
    tagType?: string | undefined;
    detail?: string | undefined;

    constructor(data?: IMappedWorkOrderPart2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagType = _data["tagType"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): MappedWorkOrderPart2 {
        data = typeof data === 'object' ? data : {};
        let result = new MappedWorkOrderPart2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagType"] = this.tagType;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IMappedWorkOrderPart2 {
    id?: number;
    tagType?: string | undefined;
    detail?: string | undefined;
}

export class XmlTransmissionRequest implements IXmlTransmissionRequest {
    transmissionId?: number;

    constructor(data?: IXmlTransmissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transmissionId = _data["transmissionId"];
        }
    }

    static fromJS(data: any): XmlTransmissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new XmlTransmissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transmissionId"] = this.transmissionId;
        return data;
    }
}

export interface IXmlTransmissionRequest {
    transmissionId?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}